import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';

import {
  FormModeEnum,
  ToolbarItem,
  TableActionParams,
  TableSettings,
  NotificationService,
  ModalService,
  BackendService,
  FieldStructure,
  TableActionEnum,
  ToolbarAction,
  TableComponent,
} from 'beyond-util';
import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { UgovorFormModeEnum } from './enums/ugovor-form-mode.enum';
import { UgovorTabEnum } from './enums/ugovor-tab.enum';
import { PodugovorTabEnum } from './enums/podugovor-tab.enum';
import { ActionType } from '../../../enums/action-type.enum';
import { Subject } from 'rxjs/Subject';
import { EnumService } from '../../../services/enum.service';
import {
  UGOVOR_CILJNE_GRUPE,
  UGOVOR_OTKAZI,
  PODUGOVOR_SACUVAJ,
  PODUGOVOR_CILJNE_GRUPE,
  PODUGOVOR_SPOTOVI,
} from '../../../constants/tooltip-messages';
import { BudzetService } from '../../../services/budzet.service';
import { UtilServiceClient } from '../../../services/util.service';
import { ValidationService } from '../../../services/validation.service';
import { Observable } from 'rxjs/Observable';
import { DEFAULT_DATE_FORMAT } from '../../../constants/date-format';

declare var $: any;

@Component({
  selector: 'app-ugovori',
  templateUrl: './ugovori.component.html',
  styleUrls: ['./ugovori.component.scss'],
})
export class UgovoriComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private readonly disabledColumnsCiljneGrupe = ['CiljnaGrupaOpis'];
  private disabledColumnsOglasivaci = ['KlijentSifra'];
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;
  private _podugovorDataSettings: Array<any>;
  private _granicnaVrednostBudzeta = 0;

  public ugovoreniBudzetRSD = 0;
  public rezervacijeRSD = 0;
  public realaizacijeRSD = 0;

  private _ugovorFormMode: UgovorFormModeEnum = UgovorFormModeEnum.Ugovor;
  private _jeAneksUgovora = false;
  public _ugovorZaAneksiranje: any = {};
  private _podugovoriZaAneksiranje: any = [];
  private _brojPodugovoraPreAneksiranja: any = {};

  private _returnToMode: FormModeEnum;
  private _prosliMode: FormModeEnum;

  public UgovorTabEnum = UgovorTabEnum;
  public PodugovorTabEnum = PodugovorTabEnum;

  public activeTabUgovor: UgovorTabEnum = UgovorTabEnum.Korekcije;
  public activeTabPodugovor: PodugovorTabEnum = PodugovorTabEnum.Korekcije;

  public ugovorSettingsTable: TableSettings;
  public podugovorSettingsTable: TableSettings;
  public korekcijePodugovorSettings: TableSettings;
  public korekcijeSettingsTable: TableSettings;
  public klijentBudzetSettings: TableSettings;

  public ciljneGrupeUgovorSettingsTable: TableSettings;
  public oglasivaciSettingsTable: TableSettings;
  public spotoviSettingsTable: TableSettings;
  public cenePoOdluciSettingsTable: TableSettings;
  public cppCeneSettingsTable: TableSettings;
  public brendiraneSpiceSettingsTable: TableSettings;

  public sponzorstvoEmisijaSettingsTable: TableSettings;
  public sponzorstvoCenaSettingsTable: TableSettings;

  public ciljneGrupePodugovorSettingsTable: TableSettings;

  public ugovorCount: number;

  public aneksiUgovoraList: any[] = [];
  public aneksiPodugovoraList: any[] = [];
  public finalAneksiPodugovoraList: any[] = [];
  public podugovorList: any[] = [];
  public deletedPodugovorList: any[] = [];
  public ucitaniPodugovoriList: any[] = [];
  public korekcijeUgovorList: any[] = [];
  public korekcijeAneksUgovorList: any[] = [];
  public korekcijePodugovorList: any[] = [];
  public korekcijeAneksPodugovorList: any[] = [];
  public klijentBudzetList: any[] = [];
  public aneksKlijentBudzetList: any[] = [];
  public parentKorekcije: any[] = [];
  public parentCPPCene: any[] = [];
  public parentSponzorstvoCene: any[] = [];
  public parentCenePoOdluci: any[] = [];

  public ciljneGrupeUgovorList: any[] = [];
  public ciljneGrupeAneksUgovorList: any[] = [];
  public ciljneGrupePodugovorList: any[] = [];
  public ciljneGrupeAneksPodugovorList: any[] = [];

  public oglasivaciList: any[] = [];
  public aneksOglasivaciList: any[] = [];
  public spotoviList: any[] = [];
  public aneksSpotoviList: any[] = [];
  public deletedSpotoviList: any[] = [];
  public deletedAneksSpotoviList: any[] = [];
  public cenePoOdluciList: any[] = [];
  public aneksCenePoOdluciList: any[] = [];
  public cppCeneList: any[] = [];
  public aneksCppCeneList: any[] = [];
  public sponzorstvaEmisijaList: any[] = [];
  public aneksSponzorstvaEmisijaList: any[] = [];
  public pregledDetaljaSponzorstvaCenaList: any[] = [];
  public aneksPregledDetaljaSponzorstvaCenaList: any[] = [];
  public sponzorstvoValuta: string;

  public brendiraneSpiceList: any[] = [];
  public aneksBrendiraneSpiceList: any[] = [];
  public activeTabAneksPodugovora: any = {};
  public deletedKlijentBudzetWhileEditing: any[] = [];

  public podugovor: any = {};
  public parentPodugovor: any = {};
  public aneksPodugovora: any = {};
  public parentAneksPodugovora: any = {};
  public showDetails = false;
  public showPodugovorDetails = false;

  public allSelected = false;
  public isUgovorMode = true;
  public isAneksPodugovora: boolean = false;

  public podugovorFieldStructure: FieldStructure;
  public ugovorFieldStructure: FieldStructure;
  public privilegije: string[] = [];

  public ugovorMode: any = {};
  public aneksiranjeInProgress: boolean;
  public kreiranjePodugovoraInProgress: boolean;

  public validateSubject: Subject<any> = new Subject<any>();
  public validateSubject$ = this.validateSubject.asObservable();

  public validatePodugovorSubject: Subject<any> = new Subject<any>();
  public validatePodugovor$ = this.validatePodugovorSubject.asObservable();

  public tooltips = {
    UGOVOR_CILJNE_GRUPE,
    PODUGOVOR_CILJNE_GRUPE,
    PODUGOVOR_SPOTOVI,
  };

  public tooltipOptions = {
    placement: 'top',
    'show-delay': '500',
    theme: 'light',
  };

  public showFinData = true;
  private finDataUgovor = [
    'NacinObracunaId',
    'MetodRacunanja',
    'NacinPlacanjaId',
    'ValutaId',
    'DatumValute',
    'Kurs',
    'JedinstvenaCena',
    'BrojDanaPlacanja',
    'PDV',
    'SamoPDV',
    'Cenovnik',
    'KorakFakturisanja',
    'DatumFakturisanja',
    'NapomenaZaFakturisanje',
    'UkupnaVrednostEUR',
    'UkupnaVrednostRSD',
  ];

  private finDataPodugovor = [
    'NacinObracunaId',
    'NacinPlacanjaId',
    'ValutaId',
    'DatumValute',
    'Kurs',
    'JedinstvenaCena',
    'UkupnaVrednostPaketa',
    'BrojDanaPlacanja',
    'PDV',
    'SamoPDV',
    'Cenovnik',
    'KorakFakturisanja',
    'DatumFakturisanja',
    'NapomenaZaFakturisanje',
    'UgovorenaVrednost',
    'SumaOglasivacaRSD',
    'SumaOglasivacaEUR',
  ];

  public UgovorFormModeEnum = UgovorFormModeEnum;

  get isPodugovorMode(): boolean {
    return this._ugovorFormMode === UgovorFormModeEnum.Podugovor;
  }

  get isAneksUgovora(): boolean {
    return this._ugovorFormMode === UgovorFormModeEnum.AneksUgovora;
  }

  get isStatusPotpisan(): boolean {
    return this.order.StatusUgovoraId === this._enumService.potpisanUgovorId;
  }

  get isStatusAneksiran(): boolean {
    return this.order.StatusUgovoraId === this._enumService.aneksiranUgovorId;
  }

  get isEditOrAddMode(): boolean {
    return this.mode === FormModeEnum.Edit || this.mode === FormModeEnum.Add;
  }

  get spotIds(): string {
    if(this.isAneksPodugovora) {
      return this.aneksSpotoviList && this.aneksSpotoviList.length
      ? this.aneksSpotoviList
          .filter(
            s =>
              s.VrstaSpotaId ===
              this._enumService.getVrstaSpotaId('Brendirane špice')
          )
          .map(s => s.Id)
          .join(',')
      : '';
    }
    else {
      return this.spotoviList && this.spotoviList.length
      ? this.spotoviList
          .filter(
            s =>
              s.VrstaSpotaId ===
              this._enumService.getVrstaSpotaId('Brendirane špice')
          )
          .map(s => s.Id)
          .join(',')
      : '';
    }
  }

  get granicnaVrednostBudzeta(): number {
    return this._granicnaVrednostBudzeta;
  }

  get klijentIds(): string {
    const ids: string =
      this.klijentBudzetList && this.klijentBudzetList.length
        ? this.klijentBudzetList
            .map(s => {
              if (s.Klijent && s.Klijent.Id) {
                return s.Klijent.Id;
              }
            })
            .join(',')
        : '';

    return ids;
  }

  private contentPlaceholder: TableComponent;
  @ViewChild('contentPlaceholder') set content(content: TableComponent) {
    if (content) {
      this.contentPlaceholder = content;
    }
  }

  private aneksContentPlaceholder: TableComponent;
  @ViewChild('aneksContentPlaceholder') set aneksContent(content: TableComponent) {
    if (content) {
      this.aneksContentPlaceholder = content;
    }
  }

  private brendiraneSpiceContentPlaceholder: TableComponent;
  @ViewChild('brendiraneSpiceContentPlaceholder') set spiceContent(
    content: TableComponent
  ) {
    if (content) {
      this.brendiraneSpiceContentPlaceholder = content;
    }
  }

  private aneksBrendiraneSpiceContentPlaceholder: TableComponent;
  @ViewChild('aneksBrendiraneSpiceContentPlaceholder') set aneksSpiceContent(
    content: TableComponent
  ) {
    if (content) {
      this.aneksBrendiraneSpiceContentPlaceholder = content;
    }
  }
  
  private spotoviContentPlaceholder: TableComponent;
  @ViewChild('spotoviContentPlaceholder') set spotoviContent(
    content: TableComponent
  ) {
    if (content) {
      this.spotoviContentPlaceholder = content;
    }
  }

  private aneksSpotoviContentPlaceholder: TableComponent;
  @ViewChild('aneksSpotoviContentPlaceholder') set aneksSpotoviContent(
    content: TableComponent
  ) {
    if (content) {
      this.aneksSpotoviContentPlaceholder = content;
    }
  }

  private klijentBudzetPlaceholder: TableComponent;
  @ViewChild('klijentBudzetPlaceholder') set klijentContent(
    content: TableComponent
  ) {
    if (content) {
      this.klijentBudzetPlaceholder = content;
    }
  }

  private cppCeneContentPlaceholder: TableComponent;
  @ViewChild('cppCeneContentPlaceholder') set cppContent(
    cppContent: TableComponent
  ) {
    if (cppContent) {
      this.cppCeneContentPlaceholder = cppContent;
    }
  }

  private aneksCppCeneContentPlaceholder: TableComponent;
  @ViewChild('aneksCppCeneContentPlaceholder') set aneksCppContent(
    aneksCppContent: TableComponent
  ) {
    if (aneksCppContent) {
      this.aneksCppCeneContentPlaceholder = aneksCppContent;
    }
  }

  private sponzorstvaEmisijaContentPlaceholder: TableComponent;
  @ViewChild('sponzorstvaEmisijeContentPlaceholder')
  set sponzorstvaEmisijaContent(emisijaContent: TableComponent) {
    if (emisijaContent) {
      this.sponzorstvaEmisijaContentPlaceholder = emisijaContent;
    }
  }

  private aneksSponzorstvaEmisijeContentPlaceholder: TableComponent;
  @ViewChild('aneksSponzorstvaEmisijeContentPlaceholder')
  set aneksSponzorstvaEmisijeContent(emisijaContent: TableComponent) {
    if (emisijaContent) {
      this.aneksSponzorstvaEmisijeContentPlaceholder = emisijaContent;
    }
  }

  private sponzorstvoCeneContentPlaceholder: TableComponent;
  @ViewChild('sponzorstvoCeneContentPlaceholder')
  set sponzorstvoCeneContent(sponzorstvoCeneContent: TableComponent) {
    if (sponzorstvoCeneContent) {
      this.sponzorstvoCeneContentPlaceholder = sponzorstvoCeneContent;
    }
  }

  private aneksSponzorstvoCeneContentPlaceholder: TableComponent;
  @ViewChild('aneksSponzorstvoCeneContentPlaceholder')
  set aneksSponzorstvoCeneContent(sponzorstvoCeneContent: TableComponent) {
    if (sponzorstvoCeneContent) {
      this.aneksSponzorstvoCeneContentPlaceholder = sponzorstvoCeneContent;
    }
  }

  private korekcijeUgovorContentPlaceholder: TableComponent;
  @ViewChild('korekcijeUgovorContentPlaceholder')
  set korekcijeUgovorContent(korekcijeUgovorContent: TableComponent) {
    if (korekcijeUgovorContent) {
      this.korekcijeUgovorContentPlaceholder = korekcijeUgovorContent;
    }
  }

  private korekcijePodugovorContentPlaceholder: TableComponent;
  @ViewChild('korekcijePodugovorContentPlaceholder')
  set korekcijeContent(korekcijePodugovorContent: TableComponent) {
    if (korekcijePodugovorContent) {
      this.korekcijePodugovorContentPlaceholder = korekcijePodugovorContent;
    }
  }

  private korekcijeAneksPodugovorContentPlaceholder: TableComponent;
  @ViewChild('korekcijeAneksPodugovorContentPlaceholder')
  set korekcijeAneksContent(korekcijeAneksPodugovorContent: TableComponent) {
    if (korekcijeAneksPodugovorContent) {
      this.korekcijeAneksPodugovorContentPlaceholder = korekcijeAneksPodugovorContent;
    }
  }

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _budzetService: BudzetService,
    private _enumService: EnumService,
    private _utilService: UtilServiceClient,
    private _spinner: NgxSpinnerService,
    private _validationService: ValidationService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
      this.fetchEnumsUgovor();
    });
    this.subcribeToTipUgovoraSwitched();
    this.aneksiranjeInProgress = false;
    this.aneksPodugovora.JeAneks = false;
    this.isAneksPodugovora = false;
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  fetchEnumsUgovorSingle() {
    this._enumService.fetchTipoviUgovoraSingle();
    this._enumService.fetchStatusUgovoraSingle();
    this._enumService.fetchValute();
    this._enumService.fetchNacinPlacanja();
    this._enumService.fetchVrstaUsluge();
    // this._enumService.fetchVrstaKorekcije();
    this._enumService.fetchVrstaZabrane();
    this._enumService.fetchTipKorekcija(true);
    this._enumService.fetchVrstaKlijenta();
    this._enumService.registerZeljenePozicije();
    this._enumService.fetchProgrami();
    this._enumService.fetchMedijumi();
    this._enumService.fetchVrsteMedija();
    this._enumService.registerMetodRacunanja();
  }

  fetchEnumsUgovor() {
    this._enumService.fetchTipoviUgovora();
    this._enumService.fetchStatusUgovora();
  }

  fetchEnumsPodugovor() {
    if(this.isAneksPodugovora) {
      this._enumService.fetchVrstaSpota();
      if (this.aneksPodugovora.TipUgovoraId) {
        this.tipUgovoraSwitched(
          'MSUGO_PUG_NacinObracunaIdEnum',
          this.aneksPodugovora.TipUgovoraId
        );
      } else {
        this.tipUgovoraSwitched(
          'MSUGO_PUG_NacinObracunaIdEnum',
          this.order.TipUgovoraId
        );
      }
      this._enumService.fetchTipKorekcija();
      this._enumService.fetchVrstaKlijenta();
    }
    else {
      this._enumService.fetchVrstaSpota();
      if (this.podugovor.TipUgovoraId) {
        this.tipUgovoraSwitched(
          'MSUGO_PUG_NacinObracunaIdEnum',
          this.podugovor.TipUgovoraId
        );
      } else {
        this.tipUgovoraSwitched(
          'MSUGO_PUG_NacinObracunaIdEnum',
          this.order.TipUgovoraId
        );
      }
      this._enumService.fetchTipKorekcija();
      this._enumService.fetchVrstaKlijenta();
    }
  }

  fetchMetodRacunanja(klijentBudzet): Observable<any> {
    return this._rtsBackendService.save(
      FormCode.MSUGO_MOKB,
      FormName.ObracunCPPGranicnaVrednost,
      klijentBudzet,
      true
    );
  }

  goToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
  }

  goToTop(topButton: HTMLElement) {
    window.scrollTo(0, 200);
  }

  dodajRed() {
    if(this._ugovorFormMode === UgovorFormModeEnum.Podugovor && (this.mode === FormModeEnum.Edit || this.mode === FormModeEnum.Add)) {
      return this.spotoviContentPlaceholder.onInlineAddOpenFromHeader();
    }
    else if(this.isAneksPodugovora) {
      return this.aneksSpotoviContentPlaceholder.onInlineAddOpenFromHeader();
    }
    else {
      return this._notificationService.openNoty('Nije moguće izvršiti akciju.');
    }
  }

  subcribeToTipUgovoraSwitched() {
    this._subscriptions.push(
      this._enumService.tipUgovoraSwtiched$.subscribe((tip: number) => {
        const naciniZaTip = this._enumService.naciniObracunaZaTipUgovora[tip];
        if (naciniZaTip.some(x => x.Id === this.order.NacinObracunaId)) {
          this.order.NacinObracunaId = naciniZaTip.find(
            x => x.Id === this.order.NacinObracunaId
          ).Id;
        } else {
          this.order.NacinObracunaId = naciniZaTip[0].Id;
        }

        this.toggleJedinstvenaCenaField(
          this.order.NacinObracunaId,
          this.ugovorFieldStructure
        );

        this.toggleNacinObracuna(
          this.ugovorFieldStructure,
          naciniZaTip.length !== 1
        );
      })
    );

    this._subscriptions.push(
      this._enumService.tipUgovoraPugSwtiched$.subscribe(tip => {
        const naciniZaTip = this._enumService.naciniObracunaZaTipUgovora[tip];
        if (this.mode === FormModeEnum.Add) {
          if(this.isAneksPodugovora) {
            if (naciniZaTip.some(x => x.Id === this.order.NacinObracunaId)) {
              this.aneksPodugovora.NacinObracunaId = this.order.NacinObracunaId;
            } else {
              this.aneksPodugovora.NacinObracunaId = naciniZaTip[0].Id;
            }
          }
          else {
            if (naciniZaTip.some(x => x.Id === this.order.NacinObracunaId)) {
              this.podugovor.NacinObracunaId = this.order.NacinObracunaId;
            } else {
              this.podugovor.NacinObracunaId = naciniZaTip[0].Id;
            }
          }
        } else if (this.mode === FormModeEnum.Edit) {
          if(this.isAneksPodugovora) {
            if (this.aneksPodugovora.NacinObracunaId !== naciniZaTip[0].Id) {
              this.aneksPodugovora.NacinObracunaId = naciniZaTip[0].Id;
            }
          }
          else {
            if (this.podugovor.NacinObracunaId !== naciniZaTip[0].Id) {
              this.podugovor.NacinObracunaId = naciniZaTip[0].Id;
            }
          }
        }

        if(this.isAneksPodugovora) {
          this.toggleMetodRacunanja(this.aneksPodugovora.NacinObracunaId === 2);
          if(this.podugovorFieldStructure) {
            this.toggleNacinObracuna(
              this.podugovorFieldStructure,
              naciniZaTip.length !== 1
            );
    
            this.toggleJedinstvenaCenaField(
              this.aneksPodugovora.NacinObracunaId,
              this.podugovorFieldStructure
            );
            this.toggleAneksJedinstvenaCenaMandatory();
            this.toggleTrajanjePodugovor(this.aneksPodugovora.NacinObracunaId);
            this.toggleUkupnaVrednostPaketaPodugovor(
              this.aneksPodugovora.NacinObracunaId
            );
          }
        }
        else {
          this.toggleMetodRacunanja(this.podugovor.NacinObracunaId === 2);
          if(this.podugovorFieldStructure) {
            this.toggleNacinObracuna(
              this.podugovorFieldStructure,
              naciniZaTip.length !== 1
            );
    
            this.toggleJedinstvenaCenaField(
              this.podugovor.NacinObracunaId,
              this.podugovorFieldStructure
            );
            this.toggleJedinstvenaCenaMandatory();
            this.toggleTrajanjePodugovor(this.podugovor.NacinObracunaId);
            this.toggleUkupnaVrednostPaketaPodugovor(
              this.podugovor.NacinObracunaId
            );
          }
        }
      })
    );
  }

  tipUgovoraSwitched(enumName: string, tipUgovora: number) {
    switch (enumName) {
      case 'MSUGO_UGO_NacinObracunaIdEnum':
        this._enumService.fetchNacinObracunaUgovor(tipUgovora);
        break;
      case 'MSUGO_PUG_NacinObracunaIdEnum':
        this._enumService.fetchNacinObracunaPodugovor(tipUgovora);
        break;
    }
  }

  setInProgress(mode: FormModeEnum) {
    if (
      mode === FormModeEnum.Add ||
      mode === FormModeEnum.Edit ||
      mode === FormModeEnum.Aneks ||
      mode === FormModeEnum.View
    ) {
      this._returnToMode = mode;
    }
  }

  fetchPodugovorSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSUGO_PUG,
          FormName.Podugovor,
          EndpointTypes.SingleEntity,
          '',
          null
        )
        .subscribe(data => {
          if (this.mode !== FormModeEnum.Aneks) {
            this.splitDetails(data.Settings, 13, false);
          }
          else {
            this.splitDetails(data.Settings, 15, false);
          }

          this._podugovorDataSettings = data.Settings;

          if (!this.showFinData) {
            this.hideFinDataPodugovor(data.Settings);
          }

          this.setLookupsPathPodugovor(data.Settings);
          this.podugovorFieldStructure = new FieldStructure(
            data.Settings,
            'header'
          );

          this.setPodugovorKlijentLookupInitFilter();

          if (this.showFinData) {
            if (this.order.TipUgovoraId) {
              this.toggleNacinObracuna(this.ugovorFieldStructure, true);
            }

            // this.toggleUkupnaVrednostPaketaPodugovor(
            //   this.podugovor.NacinObracunaId
            // );

            this.setKorekcijeSettings(data.Settings, 'Podugovor');
            this.setCenePoOdluciSettings(data.Settings);
            this.setCppCeneSettings(data.Settings);
            this.setSponzorstvoCenaSettings(data.Settings);
          }

          this.setSpotoviSettings(data.Settings);
          this.setCiljneGrupePodugovorSettings(data.Settings);
          this.setOglasivaciSettings(data.Settings);
          this.setSponzorstvoEmisijaSettings(data.Settings);
          this.setBrendiraneSpiceSettings(data.Settings);
        })
    );
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }
    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Novi ugovor';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Ugovori';
    }
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSUGO_UGO,
          FormName.PregledUgovora,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          this._spinner.hide();

          if (!this.settingsTable) {
            data.Settings.inlineEditing = false;
            data.Settings.inlineAdding = false;
            this.setSettings(data.Settings);
          }
          this._dataCount = data.ServiceData.DataSumCount;
          this._data = data.ServiceData.Data;
          this.setAllFields();
          this.refreshTable();
        })
    );
  }

  refreshTable() {
    this.setId(this._data);

    this.ugovorCount = this._dataCount;
    this.orderList = this._data;
    let currentDate = new Date().getTime();

    for(let i = 0; i < this.orderList.length; i++) {
      let datumDo = new Date(moment(this.orderList[i].DatumIsteka).format(DEFAULT_DATE_FORMAT)).getTime();
      if(this.orderList[i].ParentId !== null) {
        if(datumDo >= currentDate) {
          this.orderList[i].color = 'danger';
        }
        else {
          this.orderList[i].color = 'warning';
        }
      }
      else if(datumDo >= currentDate) {
        this.orderList[i].color = 'success';
      }
    }
  }

  create() {
    this._spinner.show();
    const payload = { ...this.order };
    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSUGO_UGO, FormName.PregledUgovora, payload)
        .subscribe((response: any) => {
          this._spinner.hide();

          if (response.Error && response.Error.ErrorMessage) {
            this._notificationService.notyError(response.Error.ErrorMessage);

            return;
          }

          if (!response.ServiceData) {
            this._notificationService.notyError(
              'Desila se greška prilikom čuvanja ugovora.'
            );

            return;
          }

          this.changeMode(FormModeEnum.Table);
          this.loadSettings();
          this._notificationService.openNoty('Ugovor je uspešno sačuvan.');
        })
    );
  }

  addOrder() {
    this.setActionType(ActionType.Create);
    this.validateSubject.next();
  }

  addPodugovor() {
    this.setActionType(ActionType.Create);
    this.validatePodugovorSubject.next();
  }

  validatedPodugovor(isValid: boolean) {
    if (isValid) {
      this.podugovor.Korekcije = this.korekcijePodugovorList;
      this.podugovor.CiljneGrupe = this.ciljneGrupePodugovorList;

      if (this.mode === FormModeEnum.Add) {
        this.podugovorList = [...this.podugovorList, ...[this.podugovor]];
      } else {
        this.podugovorList = [...this.podugovorList];
      }

      this.setSumUkupnoUgovoreno();

      this.podugovor = {};
      if(this.ugovorMode === FormModeEnum.Add) {
        this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Add);
      }
      else {
        this.returnToMode();
      }
    } else {
      this._notificationService.notyError('Niste uneli sva obavezna polja.');
    }
  }

  setSumUkupnoUgovoreno() {
    //this.order.UkupnaVrednost = 0;
    this.order.UkupnaVrednostEUR = 0;
    this.order.UkupnaVrednostRSD = 0;
    for(let i = 0; i < this.podugovorList.length; i++) {
      if(this.podugovorList[i].ValutaId == 1) {
        this.order.UkupnaVrednostEUR += this.podugovorList[i].UgovorenaVrednost;
      }
      else {
        this.order.UkupnaVrednostRSD += this.podugovorList[i].UgovorenaVrednost;
      }
    }

    for(let i = 0; i < this.aneksiPodugovoraList.length; i++) {
      if(this.aneksiPodugovoraList[i].ValutaId == 1) {
        this.order.UkupnaVrednostEUR += this.aneksiPodugovoraList[i].UgovorenaVrednost;
      }
      else {
        this.order.UkupnaVrednostRSD += this.aneksiPodugovoraList[i].UgovorenaVrednost;
      }
    }
    // this.podugovorList.forEach(
    //   p => (this.order.UkupnaVrednost += +p.UgovorenaVrednost)
    // );
    // this.aneksiPodugovoraList.forEach(
    //   p => (this.order.UkupnaVrednost += +p.UgovorenaVrednost)
    // );
  }

  updatePodugovor() {
    this.setActionType(ActionType.Update);
    this.validatePodugovorSubject.next();
  }

  updateOrder() {
    this.isAneksUgovora ? this.aneksUgovora() : this.updateUgovor();
  }

  updateDatesConfirmation() {
    if(this._podugovoriZaAneksiranje.length !== 0) {
        return `Da li želite da promenite datumske opsege (Datum Do) na cenama na datum isteka aneksa ugovora?`;
    }
  }

  private aneksUgovora() { 
    const aneksPayload = { ...this._ugovorZaAneksiranje };
    aneksPayload.JeAneks = true;
    aneksPayload.ParentId = this.order.Id;
    aneksPayload.Id = null;
    aneksPayload.ParentBrojUgovora = this.order.BrojUgovora;
    aneksPayload.ParentPraviBrojUgovora = this.order.PraviBrojUgovora;
    aneksPayload.BrojUgovora = this._ugovorZaAneksiranje.BrojAneksiranogUgovora;
    aneksPayload.Naziv = "";
    aneksPayload.PraviBrojUgovora = null;
    aneksPayload.PodugovoriZaAneksiranje = this._podugovoriZaAneksiranje;

    if(aneksPayload.PodugovoriZaAneksiranje.length > 0) {
      this._modalService.openModal(
        this.updateDatesConfirmation(),
        response => {
          if (response) {
            aneksPayload.promeniCene = true;
            for(let i = 0; i < aneksPayload.PodugovoriZaAneksiranje.length; i++) {
              aneksPayload.PodugovoriZaAneksiranje[i].ParentId = aneksPayload.PodugovoriZaAneksiranje[i].Id;
              aneksPayload.PodugovoriZaAneksiranje[i].Id = null;
              aneksPayload.PodugovoriZaAneksiranje[i].ParentBrojPodugovora = aneksPayload.PodugovoriZaAneksiranje[i].BrojPodugovora;
              aneksPayload.PodugovoriZaAneksiranje[i].BrojPodugovora = aneksPayload.PodugovoriZaAneksiranje[i].BrojPodugovora + 
              this.generisiBrojSelektovanogPodugovoraZaAneksiranje();
              aneksPayload.PodugovoriZaAneksiranje[i].DatumKreiranja = Date.now();
              aneksPayload.PodugovoriZaAneksiranje[i].DatumOdjave = aneksPayload.DatumOdjave;
            }
  
            this._spinner.show();
            this._subscriptions.push(
              this._rtsBackendService
                .save(FormCode.MSUGO_UGOANEKSSINGLE, FormName.PregledUgovora, aneksPayload)
                .subscribe((response) => {
                  if (this.responseHasError(response)) {
                    this._ugovorFormMode = UgovorFormModeEnum.Ugovor;
                    this._spinner.hide();
                    this.loadSettings();
                    this.allSelected = false;
                    this.changeMode(FormModeEnum.Table);
                    return this.notifyErrorFromResponse(response);
                  }
                  this._spinner.hide();
                  this._ugovorFormMode = UgovorFormModeEnum.Ugovor;
                  this.loadSettings();
                  this.allSelected = false;
                  this.changeMode(FormModeEnum.Table);
                })
            );
          }
          else {
            aneksPayload.promeniCene = false;
            aneksPayload.PodugovoriZaAneksiranje = this._podugovoriZaAneksiranje;
            for(let i = 0; i < aneksPayload.PodugovoriZaAneksiranje.length; i++) {
              aneksPayload.PodugovoriZaAneksiranje[i].ParentId = aneksPayload.PodugovoriZaAneksiranje[i].Id;
              aneksPayload.PodugovoriZaAneksiranje[i].Id = null;
              aneksPayload.PodugovoriZaAneksiranje[i].ParentBrojPodugovora = aneksPayload.PodugovoriZaAneksiranje[i].BrojPodugovora;
              aneksPayload.PodugovoriZaAneksiranje[i].BrojPodugovora = aneksPayload.PodugovoriZaAneksiranje[i].BrojPodugovora + 
              this.generisiBrojSelektovanogPodugovoraZaAneksiranje();
              aneksPayload.PodugovoriZaAneksiranje[i].DatumKreiranja = Date.now();
              aneksPayload.PodugovoriZaAneksiranje[i].DatumOdjave = aneksPayload.DatumOdjave;
            }
  
            this._spinner.show();
            this._subscriptions.push(
              this._rtsBackendService
                .save(FormCode.MSUGO_UGOANEKSSINGLE, FormName.PregledUgovora, aneksPayload)
                .subscribe((response) => {
                  if (this.responseHasError(response)) {
                    this._ugovorFormMode = UgovorFormModeEnum.Ugovor;
                    this._spinner.hide();
                    this.loadSettings();
                    this.allSelected = false;
                    this.changeMode(FormModeEnum.Table);
                    return this.notifyErrorFromResponse(response);
                  }
                  this._spinner.hide();
                  this._ugovorFormMode = UgovorFormModeEnum.Ugovor;
                  this.loadSettings();
                  this.allSelected = false;
                  this.changeMode(FormModeEnum.Table);
                })
            );
          }
        }
      );
    }
    else {
      this._spinner.show();
      this._subscriptions.push(
        this._rtsBackendService
          .save(FormCode.MSUGO_UGOANEKSSINGLE, FormName.PregledUgovora, aneksPayload)
          .subscribe((response) => {
            if (this.responseHasError(response)) {
              this._ugovorFormMode = UgovorFormModeEnum.Ugovor;
              this._spinner.hide();
              this.loadSettings();
              this.allSelected = false;
              this.changeMode(FormModeEnum.Table);
              return this.notifyErrorFromResponse(response);
            }
            this._spinner.hide();
            this._ugovorFormMode = UgovorFormModeEnum.Ugovor;
            this.loadSettings();
            this.allSelected = false;
            this.changeMode(FormModeEnum.Table);
          })
      );
    }
  }

  updateUgovor() {
    this.setActionType(ActionType.Update);
    this.validateSubject.next();
  }

  update() {
    this._spinner.show();
    const payload = { ...this.order };

    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSUGO_UGO, FormName.PregledUgovora, payload)
        .subscribe((response: any) => {
          this._spinner.hide();

          if (response.Error && response.Error.ErrorMessage) {
            const msg: string = response.Error.ErrorMessage;

            if (msg.includes('Obrisani podugovori')) {
              const reset = msg
                .substring(msg.indexOf('(') + 1, msg.indexOf(')'))
                .split(',');

              const list = [...this.podugovorList];
              const list2 = [...this.aneksiPodugovoraList];
              if (this._ugovorZaAneksiranje != null && this._ugovorZaAneksiranje.Podugovori != null) {
                list.push(
                  ...this._ugovorZaAneksiranje.Podugovori.filter(x =>
                    reset.includes(x.BrojPodugovora)
                  )
                );
              }
              
              this.podugovorList = list.sort(this.compareBrPug);
              this.aneksiPodugovoraList = list2.sort(this.compareBrPug);
            }

            this._notificationService.notyError(msg);

            return;
          }

          if (!response.ServiceData) {
            this._notificationService.notyError(
              'Desila se greška prilikom izmene ugovora.'
            );

            return;
          }

          this.changeMode(FormModeEnum.Table);
          this.podugovor = {};
          this.aneksPodugovora = {};
          this.aneksiUgovoraList = [];
          this.aneksiPodugovoraList = [];
          this.loadSettings();
          this._notificationService.openNoty('Ugovor je uspešno izmenjen.');
        })
    );
  }

  compareBrPug(pug1, pug2) {
    const brPug1 = pug1.BrojPodugovora;
    const brPug2 = pug2.BrojPodugovora;

    const pugNum1 = +brPug1.substring(brPug1.length - 2);
    const pugNum2 = +brPug2.substring(brPug2.length - 2);

    if (pugNum1 < pugNum2) {
      return -1;
    }
    if (pugNum1 > pugNum2) {
      return 1;
    }

    return 0;
  }

  alterSpotoviTableSettings() {
    this.spotoviSettingsTable.getFieldByName('VrstaSpotaId').editable = false;
    this.spotoviSettingsTable.getFieldByName('VrstaSpotaId').additable = false;
    this.spotoviSettingsTable.getFieldByName('KlijentNaziv').editable = false;
    this.spotoviSettingsTable.getFieldByName('KlijentNaziv').additable = false;
    this.spotoviSettingsTable.getFieldByName(
      'TrajanjeSekunde'
    ).editable = false;
    this.spotoviSettingsTable.getFieldByName(
      'TrajanjeSekunde'
    ).additable = false;
  }

  toggleSpotLookup(toggle: boolean) {
    this.spotoviSettingsTable.getFieldByName('Lookup').additable = toggle;
    this.spotoviSettingsTable.getFieldByName('Lookup').editable = toggle;
  }

  alterCeneTableSettings(settingsTable: TableSettings) {
    settingsTable.getFieldByName('VremeOd').mandatory = true;
    settingsTable.getFieldByName('VremeDo').mandatory = true;
    settingsTable.getFieldByName('CenaOff').mandatory = true;
    settingsTable.getFieldByName('CenaPrime').mandatory = true;
    settingsTable.getFieldByName('ProgramId').mandatory = true;
    settingsTable.getFieldByName('Emisija').mandatory = true;
  }

  alterCppCeneTableSettings(settingsTable: TableSettings) {
    settingsTable.getFieldByName('DatumOd').mandatory = true;
    settingsTable.getFieldByName('DatumDo').mandatory = true;
    settingsTable.getFieldByName('CenaOff').mandatory = true;
    settingsTable.getFieldByName('ProgramId').mandatory = true;
  }

  // brisanje ugovora
  onDeleteConfirm() {
    switch (this._ugovorFormMode) {
      case UgovorFormModeEnum.AneksPodugovora:
        this.onAneksPodugovorDeleteConfirm();
        break;

      case UgovorFormModeEnum.Ugovor:
        this.onUgovorDeleteConfirm();
        break;

      case UgovorFormModeEnum.Podugovor:
      this.onPodugovorDeleteConfirm();
        break;
    }
  }

  onToolbarAction(event: ToolbarAction) {
    switch (event) {
      case ToolbarAction.Close:
        this.ucitaniPodugovoriList = [];
        this.deletedSpotoviList = [];
        this.deletedAneksSpotoviList = [];
        this.onClose();
        break;

      case ToolbarAction.Delete:
        if (this._ugovorFormMode === UgovorFormModeEnum.Ugovor) {
          this.onDelete(
            null,
            this.onDeleteConfirm.bind(this),
            `Da li ste sigurni da želite da obrišete ugovor sa brojem ${this.order.BrojUgovora}?`
          );
        } else if (this._ugovorFormMode === UgovorFormModeEnum.Podugovor) {
          this.onDelete(
            null,
            this.onDeleteConfirm.bind(this),
            `Da li ste sigurni da želite da obrišete podugovor sa brojem ${this.podugovor.BrojPodugovora}?`
          );
        }
        else if(this._ugovorFormMode === UgovorFormModeEnum.AneksPodugovora) {
          this.onDelete(
            null,
            this.onDeleteConfirm.bind(this),
            `Da li ste sigurni da želite da obrišete podugovor sa brojem ${this.aneksPodugovora.BrojPodugovora}?`
          );
        }
        break;

      case ToolbarAction.Save:
        this.onSave();
        break;

      case ToolbarAction.Cancel:
        this.onCancel();
        break;

      case ToolbarAction.Aneksiraj:
        this.onAneksMode();
        break;

      case ToolbarAction.Podugovor:
        this.onAddPodugovor();
        break;

      case ToolbarAction.Edit:
        this.onEdit();
        break;

      case ToolbarAction.Add:
        this.onTableActionAdd();
        break;

      case ToolbarAction.PreuzmiIzSapa:
        this.onPreuzmiIzSAPa();
        break;
    }
  }

  onPodugovorDeleteConfirm() {
    const index = this.podugovorList.findIndex(
      pu => pu.BrojPodugovora === this.podugovor.BrojPodugovora
    );
    if (this.podugovor.Id != null) {
      this.deletedPodugovorList.push(this.podugovor.Id);
    }
    
    this.podugovor = null;
    this.podugovorList.splice(index, 1);
    this.podugovorList = [...this.podugovorList];

    this.setSumUkupnoUgovoreno();

    const mode = this._returnToMode;
    this.switchForm(UgovorFormModeEnum.Ugovor, mode);
  }

  onAneksPodugovorDeleteConfirm() {
    const index = this.aneksiPodugovoraList.findIndex(
      pu => pu.BrojPodugovora === this.aneksPodugovora.BrojPodugovora
    );
    if (this.aneksPodugovora.Id != null) {
      this.deletedPodugovorList.push(this.aneksPodugovora.Id);
    }

    this.aneksPodugovora = null;
    this.aneksiPodugovoraList.splice(index, 1);
    this.aneksiPodugovoraList = [...this.aneksiPodugovoraList];

    this.setSumUkupnoUgovoreno();

    const mode = this._returnToMode;
    this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Edit);
  }

  onUgovorDeleteConfirm() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSUGO_UGO, FormName.PregledUgovora, this.order.Id)
        .subscribe((response: any) => {
          this.changeMode(FormModeEnum.Table);
          this.loadSettings();
          this._spinner.hide();

          if (response.Error && response.Error.ErrorMessage) {
            this._notificationService.notyError(response.Error.ErrorMessage);

            return;
          }

          this._notificationService.openNoty('Uspešno brisanje');
        })
    );
  }

  validirano(isValid: boolean) {
    if (isValid) {
      switch (this.actionType) {
        case ActionType.Create:
          this.create();
          break;
        case ActionType.Update:
          this.update();
          break;
        case ActionType.ValidateUgovor:
          if (!this.klijentBudzetList.length) {
            return this._notificationService.notyError(
              'Pre kreiranja podugovora potrebno je dodati bar jednog klijenta u karticu "Klijenti na ugovoru".'
            );
          }

          this.setPodugovor();
          break;
      }
    } else {
      this.notifyError('Niste uneli sva obavezna polja.');
    }
  }

  setPodugovor() {
    this.clearPodugovor();
    this.toggleKlijentPodugovor(true);
    this.toggleBrojPodugovora(true);
    this.switchForm(UgovorFormModeEnum.Podugovor, FormModeEnum.Add);
    this.fillInitValuesPodugovor();
    this.clearPodugovorTables();
    this.setKlijentSaUgovoraNotEditable();
    this._enumService.fetchNacinObracunaPodugovor(this.order.TipUgovoraId);
    this.setTabPodugovor(PodugovorTabEnum.Korekcije);
  }

  onAddPodugovor() {
    this.kreiranjePodugovoraInProgress = true;
    this.isAneksPodugovora = false;
    this.setActionType(ActionType.ValidateUgovor);
    this.validateSubject.next();
    this.onViewPodugovor({});
  }

  private clearPodugovor() {
    this.podugovor = {};
    this.podugovor.Korekcije = [];
    this.podugovor.Spotovi = [];
    this.podugovor.CiljneGrupe = [];
    this.podugovor.Oglasivaci = [];
    this.podugovor.CenePoOdlukama = [];
    this.podugovor.CeneCPP = [];
    this.podugovor.SponzorstvoCene = [];
    this.podugovor.SponzorstvoEmisija = [];
  }

  private fillInitValuesPodugovor() {
    this.podugovor.Settings = this._podugovorDataSettings;
    this.podugovor.IsNew = true;
    this.podugovor.JeAktivan = true;
    this.podugovor.UgovorId = this.order.Id;
    this.podugovor.BrojUgovora = this.order.BrojUgovora;
    this.podugovor.BrojPodugovora = `${
      this.order.BrojUgovora
    }${this.getNextBrojPodugovoraNew(this.order.BrojUgovora)}`;
    this.podugovor.TipUgovoraId = this.order.TipUgovoraId;
    this.fetchEnumsPodugovor();
    this.podugovor.NacinPlacanjaId = this.order.NacinPlacanjaId;
    this.podugovor.Klijent = { ...this.order.Klijent };
    this.podugovor.DatumKreiranja = new Date();
    this.podugovor.DatumIsteka = this.order.DatumIsteka;
    this.podugovor.Cenovnik = { ...this.order.Cenovnik };
    this.podugovor.ValutaId = this.order.ValutaId;
    this.podugovor.PDV = this.order.PDV;
    this.podugovor.SamoPDV = this.order.SamoPDV;
    this.podugovor.BrojDanaPlacanja = this.order.BrojDanaPlacanja;
    if (this.order.Klijent) {
      this.podugovor.KlijentNaziv = this.order.Klijent.NazivImePrezime;
      this.podugovor.KlijentSaUgovora = this.order.Klijent.NazivImePrezime;
    }
    const isSponzorstvo = this.podugovor.NacinObracunaId === 4;
    if (isSponzorstvo) {
      this.setSponzorstvoValuta();
    }
    if(this.podugovor.NacinObracunaId === 3) {
      this.toggleBrojRezervacijaField(true);
    }
    else {
      this.toggleBrojRezervacijaField(false);
    }
    this.podugovor.StatusUgovoraId = this.order.StatusUgovoraId;
    this.aneksPodugovora.IsAneks = false;
  }

  private getNextBrojPodugovoraNew(brojUgovora) {
    let brojeviPodugovora = this.podugovorList.map(function(a) {return a.BrojPodugovora;});
    
    for (let i = 1; i < 999; i++) {
      let noviBroj = i < 10 ? '0' + i.toString() : i.toString();
      if (brojeviPodugovora.indexOf(brojUgovora + noviBroj) === -1) {
        return noviBroj;
      }
    }
    return 999;
  }

  onAneksMode() {
    if (this._ugovorFormMode === UgovorFormModeEnum.Ugovor) {
      this.korekcijeSettingsTable.listAdditable = false;
      this.ciljneGrupeUgovorSettingsTable.listAdditable = false;
      this._jeAneksUgovora = true;
      this._ugovorZaAneksiranje = { ...this.order };
      this.copyProperties(this.order, this._ugovorZaAneksiranje);
      this._ugovorZaAneksiranje.IsNew = true;
      this._ugovorZaAneksiranje.JeAktivan = true;
      this.setAneksUgovoriKorekcijeList();
      this.setCiljneGrupeAneksUgovorList();
      this.setAneksKlijentBudzetList();
      this._ugovorZaAneksiranje.UkupnaVrednostRSD = 0;
      this._ugovorZaAneksiranje.UkupnaVrednostEUR = 0;
      this._ugovorZaAneksiranje.KlijentBudzetRSD = 0;
      this._ugovorZaAneksiranje.KlijentBudzetEUR = 0;
      this.parentKorekcije = this.order.Korekcije;
      if(this.order.JeAktivan === false) {
        this.korekcijeAneksUgovorList = [];
        this.ciljneGrupeAneksUgovorList = [];
      }
      this.switchForm(UgovorFormModeEnum.AneksUgovora, FormModeEnum.Edit);
      this.ugovorFieldStructure.getFieldByName('BrojUgovora').editable = false;
      this.ugovorFieldStructure.getFieldByName('BrojUgovora').label = "Broj matičnog ugovora";
      this.ugovorFieldStructure.getFieldByName('PraviBrojUgovora').editable = false;
      this.ugovorFieldStructure.getFieldByName('PraviBrojUgovora').label = "Pravi broj matičnog ugovora";
      this.ugovorFieldStructure.getFieldByName('BrojAneksiranogUgovora').visible = true;
      this.ugovorFieldStructure.getFieldByName('BrojAneksiranogUgovora').editable = true;
      this.ugovorFieldStructure.getFieldByName('BrojAneksiranogUgovora').additable = true;
      this.ugovorFieldStructure.getFieldByName('TipUgovoraId').editable = false;
      this.ugovorFieldStructure.getFieldByName('TipUgovoraId').additable = false;
      this.ugovorFieldStructure.getFieldByName('NacinObracunaId').editable = false;
      this.ugovorFieldStructure.getFieldByName('NacinObracunaId').additable = false;
      if(this._ugovorZaAneksiranje.BrojAneksiranihUgovora == 0) {
        this.ugovorFieldStructure.getFieldByName('ParentJeAktivan').visible = false;
      }
      else {
        this.ugovorFieldStructure.getFieldByName('ParentJeAktivan').visible = true;
      }
      let datum = moment(this.order.DatumKreiranja).format('YYYY-MM-DD').slice(2,4);
      this._ugovorZaAneksiranje.BrojAneksiranogUgovora = this._ugovorZaAneksiranje.BrojUgovora + this.generisiBrojAneksiranogUgovora();
    } else {
      this.isAneksPodugovora = true;
      this.aneksiranjeInProgress = true;
      this._brojPodugovoraPreAneksiranja = this.podugovor.BrojPodugovora;
      this.parentPodugovor = { ...this.podugovor };
      this.copyProperties(this.podugovor, this.parentPodugovor);
      this.parentPodugovor.BrojPodugovora = this._brojPodugovoraPreAneksiranja;
      this.aneksPodugovora = { ...this.podugovor };
      this.copyProperties(this.podugovor, this.aneksPodugovora);
      this.aneksPodugovora.IsNew = true;
      this.aneksPodugovora.JeAneks = true;
      //this.aneksPodugovora.IsUpdated = true;
      this.switchForm(UgovorFormModeEnum.AneksPodugovora, FormModeEnum.Edit);
      this.setAneksKorekcijePodugovorList();
      this.setAneksCiljneGrupePodugovorList();
      this.setAneksOglasivaciList();
      this.setAneksSpotoviList();
      this.setAneksBrendiraneSpiceList();
      this.setAneksCppCeneList();
      this.setAneksCenePoOdluciList();
      this.setAneksSponzorstvoEmisija();
      this.setAneksSponzorstvaCena();
      this.setAneksSponzorstvoValuta();
      this.podugovorFieldStructure.getFieldByName('ParentBrojPodugovora').visible = true;
      this.podugovorFieldStructure.getFieldByName('ParentBrojPodugovora').editable = false;
      this.podugovorFieldStructure.getFieldByName('Naziv').editable = true;
      this.podugovorFieldStructure.getFieldByName('TipUgovoraId').editable = false;
      this.podugovorFieldStructure.getFieldByName('TipUgovoraId').additable = false;
      this.podugovorFieldStructure.getFieldByName('NacinObracunaId').editable = false;
      this.podugovorFieldStructure.getFieldByName('NacinObracunaId').additable = false;
      let parentPodugovor = this.podugovorList.filter(p => {
        return p.Id === this.aneksPodugovora.Id
      });
      let datum = moment(parentPodugovor[0].DatumKreiranja).format('YYYY-MM-DD').slice(2,4);
      this.aneksPodugovora.Id = null;
      this.aneksPodugovora.ParentId = this.podugovor.Id;
      this.aneksPodugovora.BrojPodugovora = parentPodugovor[0].BrojPodugovora + this.generisiBrojAneksiranogPodugovora();
      this.aneksPodugovora.ParentBrojPodugovora = parentPodugovor[0].BrojPodugovora;
    }
  }

  generisiBrojAneksiranogUgovora() {
    let datum = moment(Date.now()).format('YYYY-MM-DD').slice(2,4);
    if (this.order.AneksiraniUgovori.length === 0) {
      return `/1-${datum}`;
    }

    let rbrAneksaUgovora: number[] = [];
    for(let i = 0; i < this.order.AneksiraniUgovori.length; i++) {
      rbrAneksaUgovora.push(parseInt(this.order.AneksiraniUgovori[i].BrojUgovora.slice(-4,-3), 10));
    }

    rbrAneksaUgovora.sort(function(a,b){
      if( !isFinite(a) && !isFinite(b) ) {
          return ( isNaN(a) && isNaN(b) )
              ? 1
              : a < b
                  ? -1
                  : a === b
                      ? 0
                      : 1;
      }
      if( !isFinite(a) ) {
          return 1;
      }
      if( !isFinite(b) ) {
          return -1;
      }
      return a-b;
    });

    for(let i = 0; i < rbrAneksaUgovora.length; i++) {
      if(!Number.isNaN(rbrAneksaUgovora[i])) {
        continue;
      }
      else {
        for(let j = 0; j < rbrAneksaUgovora.length; j++) {
          if(Number.isNaN(rbrAneksaUgovora[i])) {
            rbrAneksaUgovora.pop();
          }
        }
      }
    }

    let rbr = "";
    if(rbrAneksaUgovora.length > 1) {
      for(let i = 0; i < rbrAneksaUgovora.length; i++) {
        if(rbrAneksaUgovora[0] !== 1) {
          return `/1-${datum}`;
        }
        else if(rbrAneksaUgovora[i + 1] - rbrAneksaUgovora[i] === 1) {
          continue;
        }
        else if(rbrAneksaUgovora[i + 1] - rbrAneksaUgovora[i] > 1) {
          return rbr = `/${(rbrAneksaUgovora[i] + 1).toString()}-${datum}`;
        }
      }
    }
    else if(rbrAneksaUgovora[0] !== 1) {
      return `/1-${datum}`;
    }
    
    if(rbr === "") {
      let najveciRbr = Math.max(...rbrAneksaUgovora);
      rbr = `/${(najveciRbr + 1).toString()}-${datum}`;
      return rbr;
    }
  }

  generisiBrojAneksiranogPodugovora() {
    let datum = moment(Date.now()).format('YYYY-MM-DD').slice(2,4);
    if (this.aneksiPodugovoraList.length === 0) {
      return ` (${this.podugovor.BrojUgovora})/1-${datum}`;
    }

    let rbrAneksaPodugovora: number[] = [];
    let aneksiraniPodugovori = this.aneksiPodugovoraList.filter(p => {
      return p.ParentId === this.podugovor.Id
    });

    if(aneksiraniPodugovori.length === 0) {
      return ` (${this.podugovor.BrojUgovora})/1-${datum}`;
    }

    for(let i = 0; i < aneksiraniPodugovori.length; i++) {
      rbrAneksaPodugovora.push(parseInt(aneksiraniPodugovori[i].BrojPodugovora.slice(-4,-3), 10));
    }

    rbrAneksaPodugovora.sort(function(a,b){
      if( !isFinite(a) && !isFinite(b) ) {
          return ( isNaN(a) && isNaN(b) )
              ? 1
              : a < b
                  ? -1
                  : a === b
                      ? 0
                      : 1;
      }
      if( !isFinite(a) ) {
          return 1;
      }
      if( !isFinite(b) ) {
          return -1;
      }
      return a-b;
    });

    for(let i = 0; i < rbrAneksaPodugovora.length; i++) {
      if(!Number.isNaN(rbrAneksaPodugovora[i])) {
        continue;
      }
      else {
        for(let j = 0; j < rbrAneksaPodugovora.length; j++) {
          if(Number.isNaN(rbrAneksaPodugovora[i])) {
            rbrAneksaPodugovora.pop();
          }
        }
      }
    }

    let rbr = "";
    if(rbrAneksaPodugovora.length > 1) {
      for(let i = 0; i < rbrAneksaPodugovora.length; i++) {
        if(rbrAneksaPodugovora[0] !== 1) {
          return ` (${this.podugovor.BrojUgovora})/1-${datum}`;
        }
        else if(rbrAneksaPodugovora[i + 1] - rbrAneksaPodugovora[i] === 1) {
          continue;
        }
        else if(rbrAneksaPodugovora[i + 1] - rbrAneksaPodugovora[i] > 1) {
          return rbr = ` (${this.podugovor.BrojUgovora})/${(rbrAneksaPodugovora[i] + 1).toString()}-${datum}`;
        }
      }
    }
    else if(rbrAneksaPodugovora[0] !== 1) {
      return ` (${this.podugovor.BrojUgovora})/1-${datum}`;
    }

    if(rbr === "") {
      let najveciRbr = Math.max(...rbrAneksaPodugovora);
      rbr = ` (${this.podugovor.BrojUgovora})/${(najveciRbr + 1).toString()}-${datum}`;
      return rbr;
    }
  }

  generisiBrojSelektovanogPodugovoraZaAneksiranje() {
    let datum = moment(Date.now()).format('YYYY-MM-DD').slice(2,4);
    return ` (${this._ugovorZaAneksiranje.BrojAneksiranogUgovora})/1-${datum}`;
  }

  onAllSelected(allSelected: any) {
    this.allSelected = allSelected;
    this.podugovorList.forEach(r => {
      r.selected = allSelected;
    });

    this._podugovoriZaAneksiranje = this.getSelectedObjects();
  }

  onRowSelected(selected: any) {
    if (this.allSelected && selected !== this.allSelected) {
      this.allSelected = !this.allSelected;
    }

    this._podugovoriZaAneksiranje = this.getSelectedObjects();

    if(this._podugovoriZaAneksiranje.length === this.podugovorList.length) {
      this.allSelected = true;
    }
  }

  getSelectedObjects() {
    const selected = this.podugovorList.filter(x => x.selected);

    return selected;
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    super.onTableActionFilter(event);
  }

  // Prikaz detalja ugovora
  onTableActionView() {
    this.fetchEnumsUgovorSingle();
    this.ucitaniPodugovoriList = [];
    this.fetchSingleEntity();
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
  }

  getBudget(ugovorId) {
    const payloadUgovor = this._rtsBackendService.getRequestPayload(
      FormCode.MSBUDZET_IZVUGO,
      FormName.RealizacijaUgovora,
      EndpointTypes.GetSingleEntity,
      `?ugovorId=${ugovorId}`,
      null,
      null
    );

    this._subscriptions.push(
      this._budzetService.getIzvestaj(payloadUgovor).subscribe(
        (response: any) => {
          // this.ugovoreniBudzetRSD = response.ServiceData.PriliviRSD
          //   ? parseInt(`${response.ServiceData.PriliviRSD}`, 0)
          //   : 0;
          this.ugovoreniBudzetRSD = this.order.KlijentBudzetUkupno;
          this.rezervacijeRSD = response.ServiceData.RezervisanoRSD
            ? parseInt(`${response.ServiceData.RezervisanoRSD}`, 0)
            : 0;
          this.realaizacijeRSD = response.ServiceData.RealizovanoRSD
            ? parseInt(`${response.ServiceData.RealizovanoRSD}`, 0)
            : 0;
        },
        () => {
          this.notifyError('Desila se greška pri dohvatanju izveštaja.');
        }
      )
    );
  }

  onAneksPodugovoraTableSelect(ugovor: any) {
    this.isAneksPodugovora = true;
    this.podugovor = {};
    if (ugovor.BrojPodugovora) {
      this.aneksPodugovora = this.aneksiPodugovoraList.find(
        pu => pu.BrojPodugovora === ugovor.BrojPodugovora
      );

      if(this.aneksPodugovora.IsNew === true) {
        this.setAneksPodugovoraSettings();
        this.setTabPodugovor(PodugovorTabEnum.KorekcijeAneks);
        this.onViewPodugovor(this.aneksPodugovora);
      }
      // Ukoliko se podugovor prvi put ucitava IsLoaded je undefined.
      else if(this.aneksPodugovora.IsLoaded === undefined) {
        this._spinner.hide();
        this._spinner.show();
        this._subscriptions.push(
          this._rtsBackendService
            .fetchSettings(
              FormCode.MSUGO_PUGSINGLE,
              FormName.Podugovor,
              EndpointTypes.SingleEntity,
              '',
              this.aneksPodugovora.Id,
              true
            )
            .subscribe(response => {
              if (this.responseHasError(response)) {
                this._notificationService.notyError(
                  'Došlo je do greške prilikom učitavanja podugovora.'
                );
                this._spinner.hide();

                return;
              }
              
              this.aneksPodugovora = response.ServiceData[0];
              this.aneksPodugovora.IsLoaded = true;
              this.parentAneksPodugovora = { ...this.aneksPodugovora };
              this.copyProperties(this.aneksPodugovora, this.parentAneksPodugovora);
              this.ucitaniPodugovoriList.push(this.aneksPodugovora);
              let index = this.order.AneksiraniPodugovori.findIndex(element => element.Id === this.aneksPodugovora.Id);
              this.order.AneksiraniPodugovori[index] = this.aneksPodugovora;

              this._subscriptions.push(
                this._rtsBackendService
                  .fetchSettings(
                    FormCode.MSUGO_PUG,
                    FormName.Podugovor,
                    EndpointTypes.SingleEntity,
                    '',
                    null
                  )
                  .subscribe(data => {
                    if (this.responseHasError(data)) {
                      this._notificationService.notyError(
                        'Došlo je do greške prilikom učitavanja podugovora.'
                      );
                      this._spinner.hide();

                      return;
                    }
                    this.aneksPodugovora.Settings = data.Settings;
                    this.splitDetails(data.Settings, 13, false);
                    this.setAneksPodugovoraSettings();
                    this.onViewPodugovor(this.aneksPodugovora);
                    this._spinner.hide();
                  })
              );
            })
        );
        this.setTabPodugovor(PodugovorTabEnum.KorekcijeAneks);
      }
      else {
        this.parentAneksPodugovora = { ...this.aneksPodugovora };
        this.copyProperties(this.aneksPodugovora, this.parentAneksPodugovora);
        this.setAneksPodugovoraSettings();
        this.setTabPodugovor(PodugovorTabEnum.KorekcijeAneks);
        this.onViewPodugovor(this.aneksPodugovora);
      }
    }
  }

  // Prikaz detalja podugovora
  onPodugovorTableSelect(ugovor: any) {
    this.isAneksPodugovora = false;
    this.aneksPodugovora = {};
    if(this._ugovorFormMode === UgovorFormModeEnum.AneksUgovora && this.mode === FormModeEnum.Edit) {
      return;
    }
    if (ugovor.BrojPodugovora) {
      this.podugovor = this.podugovorList.find(
        pu => pu.BrojPodugovora === ugovor.BrojPodugovora
      );

      if(this.podugovor.IsNew === true) {
        if(this.aneksPodugovora === null) {
          this.aneksPodugovora = {};
        }
        this.aneksPodugovora.JeAneks = false;
        this.kreiranjePodugovoraInProgress = false;
        this.setPodugovorSettings();
        this.setTabPodugovor(PodugovorTabEnum.Korekcije);
      }
      // Ukoliko se podugovor prvi put ucitava IsLoaded je undefined.
      else if(this.podugovor.IsLoaded === undefined) {
        this._spinner.hide();
        this._spinner.show();
        this._subscriptions.push(
          this._rtsBackendService
            .fetchSettings(
              FormCode.MSUGO_PUGSINGLE,
              FormName.Podugovor,
              EndpointTypes.SingleEntity,
              '',
              this.podugovor.Id,
              true
            )
            .subscribe(response => {
              if (this.responseHasError(response)) {
                this._notificationService.notyError(
                  'Došlo je do greške prilikom učitavanja podugovora.'
                );
                this._spinner.hide();

                return;
              }
              
              this.podugovor = response.ServiceData[0];
              this.podugovor.IsLoaded = true;
              this.ucitaniPodugovoriList.push(this.podugovor);
              let index = this.podugovorList.findIndex(element => element.Id === this.podugovor.Id);
              this.podugovorList[index] = this.podugovor;
              if(this.aneksPodugovora === null) {
                this.aneksPodugovora = {};
              }
              this.aneksPodugovora.JeAneks = false;
              this.kreiranjePodugovoraInProgress = false;

              this._subscriptions.push(
                this._rtsBackendService
                  .fetchSettings(
                    FormCode.MSUGO_PUG,
                    FormName.Podugovor,
                    EndpointTypes.SingleEntity,
                    '',
                    null
                  )
                  .subscribe(data => {
                    if (this.responseHasError(data)) {
                      this._notificationService.notyError(
                        'Došlo je do greške prilikom učitavanja podugovora.'
                      );
                      this._spinner.hide();

                      return;
                    }
                    this.podugovor.Settings = data.Settings;
                    this.splitDetails(data.Settings, 13, false);

                    this.setPodugovorSettings();
                    this._spinner.hide();
                    this.onViewPodugovor(this.podugovor);
                  })
              );
            })
        );
        this.setTabPodugovor(PodugovorTabEnum.Korekcije);
      }
      else {
        if(this.aneksPodugovora === null) {
          this.aneksPodugovora = {};
        }
        this.aneksPodugovora.JeAneks = false;
        this.kreiranjePodugovoraInProgress = false;
        this.setPodugovorSettings();
        this.setTabPodugovor(PodugovorTabEnum.Korekcije);
        this.onViewPodugovor(this.podugovor);
      }
    }
  }

  setAneksPodugovoraSettings() {
    if (!this.showFinData) {
      this.hideFinDataPodugovor(this.aneksPodugovora.Settings);
    }

    this.setLookupsPathPodugovor(this.aneksPodugovora.Settings);
    this.podugovorFieldStructure = new FieldStructure(
      this.aneksPodugovora.Settings,
      'header'
    );

    this.setPodugovorKlijentLookupInitFilter();

    if (this.showFinData) {
      if (
        this.order.TipUgovoraId &&
        this.aneksPodugovora.TipUgovoraId
      ) {
        this.toggleNacinObracuna(this.ugovorFieldStructure, true);
      }

      this.toggleUkupnaVrednostPaketaPodugovor(
        this.aneksPodugovora.NacinObracunaId
      );

      this.setKorekcijeSettings(this.aneksPodugovora.Settings, 'Podugovor');
      this.setCenePoOdluciSettings(this.aneksPodugovora.Settings);
      this.setCppCeneSettings(this.aneksPodugovora.Settings);
      this.setSponzorstvoCenaSettings(this.aneksPodugovora.Settings);
    }

    this.setSpotoviSettings(this.aneksPodugovora.Settings);
    this.setCiljneGrupePodugovorSettings(this.aneksPodugovora.Settings);
    this.setOglasivaciSettings(this.aneksPodugovora.Settings);
    this.setSponzorstvoEmisijaSettings(this.aneksPodugovora.Settings);
    this.setBrendiraneSpiceSettings(this.aneksPodugovora.Settings);

    if (this.showFinData) {
      if (!this.aneksPodugovora.NacinObracunaId) {
        this.setEditableJedinstvenaCena(
          false,
          this.podugovorFieldStructure
        );
      } else {
        this.toggleJedinstvenaCenaField(
          this.aneksPodugovora.NacinObracunaId,
          this.podugovorFieldStructure
        );
      }

      this.toggleUkupnaVrednostPaketaPodugovor(
        this.aneksPodugovora.NacinObracunaId
      );

      this.toggleTrajanjePodugovor(
        this.aneksPodugovora.NacinObracunaId
      );
      this.setAneksKorekcijePodugovorList();
      this.setAneksSponzorstvaCena();
      this.setAneksSponzorstvoEmisija();
    }

    this.setInProgress(this.mode);

    this.setAneksCiljneGrupePodugovorList();
    this.setAneksOglasivaciList();
    this.setAneksSpotoviList();
    this.setAneksCenePoOdluciList();
    this.setAneksCppCeneList();
    this.setAneksBrendiraneSpiceList();
    this.setSpotoviLookupInitFilter();
    this.fetchEnumsPodugovor();
    this.aneksPodugovora.NacinObracunaId = this.aneksPodugovora.NacinObracunaId;

    if (!this.aneksPodugovora.NacinObracunaId) {
      this.setEditableJedinstvenaCena(
        false,
        this.podugovorFieldStructure
      );
    } else {
      this.toggleJedinstvenaCenaField(
        this.aneksPodugovora.NacinObracunaId,
        this.podugovorFieldStructure
      );
    }

    const isToggleKurs = this.aneksPodugovora.ValutaId === 1;
    const isSponzorstvo = this.aneksPodugovora.NacinObracunaId === 4;
    if (isToggleKurs === false) {
      this.clearKurs(this.aneksPodugovora);
    }
    this.toggleKursData(
      this.podugovorFieldStructure,
      isToggleKurs
    );
    if (isSponzorstvo) {
      this.setAneksSponzorstvoValuta();
    }

    // this.toggleBrojRezervacijaField(
    //   this.podugovor.NacinObracunaId === 3
    // );

    if(this.aneksPodugovora.NacinObracunaId === 3) {
      this.toggleBrojRezervacijaField(true);
    }
    else {
      this.toggleBrojRezervacijaField(false);
    }

    this.switchForm(
      UgovorFormModeEnum.AneksPodugovora,
      FormModeEnum.View
    );
    
    this.setInfobar(
      true,
      this.aneksPodugovora.IzmenioImePrezime,
      this.aneksPodugovora.DatumIzmene
    );
  }

  setPodugovorSettings() {
    if (!this.showFinData) {
      this.hideFinDataPodugovor(this.podugovor.Settings);
    }

    this.setLookupsPathPodugovor(this.podugovor.Settings);
    this.podugovorFieldStructure = new FieldStructure(
      this.podugovor.Settings,
      'header'
    );

    this.setPodugovorKlijentLookupInitFilter();

    if (this.showFinData) {
      if (
        this.order.TipUgovoraId &&
        this.podugovor.TipUgovoraId
      ) {
        this.toggleNacinObracuna(this.ugovorFieldStructure, true);
      }

      this.toggleUkupnaVrednostPaketaPodugovor(
        this.podugovor.NacinObracunaId
      );

      this.setKorekcijeSettings(this.podugovor.Settings, 'Podugovor');
      this.setCenePoOdluciSettings(this.podugovor.Settings);
      this.setCppCeneSettings(this.podugovor.Settings);
      this.setSponzorstvoCenaSettings(this.podugovor.Settings);
    }

    this.setSpotoviSettings(this.podugovor.Settings);
    this.setCiljneGrupePodugovorSettings(this.podugovor.Settings);
    this.setOglasivaciSettings(this.podugovor.Settings);
    this.setSponzorstvoEmisijaSettings(this.podugovor.Settings);
    this.setBrendiraneSpiceSettings(this.podugovor.Settings);

    if (this.showFinData) {
      if (!this.podugovor.NacinObracunaId) {
        this.setEditableJedinstvenaCena(
          false,
          this.podugovorFieldStructure
        );
      } else {
        this.toggleJedinstvenaCenaField(
          this.podugovor.NacinObracunaId,
          this.podugovorFieldStructure
        );
      }

      this.toggleUkupnaVrednostPaketaPodugovor(
        this.podugovor.NacinObracunaId
      );

      this.toggleTrajanjePodugovor(
        this.podugovor.NacinObracunaId
      );
      this.setKorekcijePodugovorList();
      this.setSponzorstvaCena();
      this.setSponzorstvoEmisija();
    }

    this.setInProgress(this.mode);

    this.setCiljneGrupePodugovorList();
    this.setOglasivaciList();
    this.setSpotoviList();
    this.setCenePoOdluciList();
    this.setCppCeneList();
    this.setBrendiraneSpiceList();
    this.setSpotoviLookupInitFilter();
    this.fetchEnumsPodugovor();
    this.podugovor.NacinObracunaId = this.podugovor.NacinObracunaId;

    if (!this.podugovor.NacinObracunaId) {
      this.setEditableJedinstvenaCena(
        false,
        this.podugovorFieldStructure
      );
    } else {
      this.toggleJedinstvenaCenaField(
        this.podugovor.NacinObracunaId,
        this.podugovorFieldStructure
      );
    }

    const isToggleKurs = this.podugovor.ValutaId === 1;
    const isSponzorstvo = this.podugovor.NacinObracunaId === 4;
    if (isToggleKurs === false) {
      this.clearKurs(this.podugovor);
    }
    this.toggleKursData(
      this.podugovorFieldStructure,
      isToggleKurs
    );
    if (isSponzorstvo) {
      this.setSponzorstvoValuta();
    }

    // this.toggleBrojRezervacijaField(
    //   this.podugovor.NacinObracunaId === 3
    // );

    if(this.podugovor.NacinObracunaId === 3) {
      this.toggleBrojRezervacijaField(true);
    }
    else {
      this.toggleBrojRezervacijaField(false);
    }

    this.switchForm(
      UgovorFormModeEnum.Podugovor,
      FormModeEnum.View
    );
    
    this.setInfobar(
      true,
      this.podugovor.IzmenioImePrezime,
      this.podugovor.DatumIzmene
    );

    if(this.podugovor.IsNew === true || this.podugovor.IsNew === undefined) {
      this.setTabPodugovor(
        this.showFinData
          ? PodugovorTabEnum.Korekcije
          : PodugovorTabEnum.Spotovi
      );
    }
  }

  setSponzorstvoValuta() {
    this.sponzorstvoValuta = this._enumService.valuteUgo.find(
      x => x.Id === this.podugovor.ValutaId
    ).Oznaka;
  }

  setAneksSponzorstvoValuta() {
    this.sponzorstvoValuta = this._enumService.valuteUgo.find(
      x => x.Id === this.aneksPodugovora.ValutaId
    ).Oznaka;
  }

  setSpotoviList() {
    this.spotoviList = this._utilService.deepCopy(this.podugovor.Spotovi);

    this.setRbr(this.spotoviList);
  }

  setAneksSpotoviList() {
    if(this.activeTabUgovor === UgovorTabEnum.Podugovori && this.podugovor.JeAneks === null) {
      this.aneksSpotoviList = this._utilService.deepCopy(this.podugovor.Spotovi);
    }
    else {
      this.aneksSpotoviList = this._utilService.deepCopy(this.aneksPodugovora.Spotovi);
    }

    this.setRbr(this.aneksSpotoviList);
  }

  setBrendiraneSpiceList() {
    this.brendiraneSpiceList = this._utilService.deepCopy(
      this.podugovor.BrendiraneSpice
    );
    this.setRbr(this.brendiraneSpiceList);
  }

  setAneksBrendiraneSpiceList() {
    this.aneksBrendiraneSpiceList = this._utilService.deepCopy(
      this.aneksPodugovora.BrendiraneSpice
    );
    this.setRbr(this.aneksBrendiraneSpiceList);
  }

  setCenePoOdluciList() {
    this.cenePoOdluciList = this._utilService.deepCopy(
      this.podugovor.CenePoOdlukama
    );
    this.setRbr(this.cenePoOdluciList);
  }

  setAneksCenePoOdluciList() {
    this.aneksCenePoOdluciList = this._utilService.deepCopy(
      this.aneksPodugovora.CenePoOdlukama
    );
    this.setRbr(this.aneksCenePoOdluciList);
  }

  setCppCeneList() {
    this.cppCeneList = this._utilService.deepCopy(this.podugovor.CeneCPP);
    this.setRbr(this.cppCeneList);
  }

  setAneksCppCeneList() {
    this.aneksCppCeneList = this._utilService.deepCopy(this.aneksPodugovora.CeneCPP);
    this.setRbr(this.aneksCppCeneList);
  }

  private setCiljneGrupePodugovorList() {
    this.ciljneGrupePodugovorList = this._utilService.deepCopy(
      this.podugovor.CiljneGrupe
    );
    this.setRbr(this.ciljneGrupePodugovorList);
  }

  private setAneksCiljneGrupePodugovorList() {
    this.ciljneGrupeAneksPodugovorList = this._utilService.deepCopy(
      this.aneksPodugovora.CiljneGrupe
    );
    this.setRbr(this.ciljneGrupeAneksPodugovorList);
  }

  private setKorekcijePodugovorList() {
    this.korekcijePodugovorList = this._utilService.deepCopy(
      this.podugovor.Korekcije
    );
    this.setRbr(this.korekcijePodugovorList);
  }

  private setAneksKorekcijePodugovorList() {
    this.korekcijeAneksPodugovorList = this._utilService.deepCopy(
      this.aneksPodugovora.Korekcije
    );
    this.setRbr(this.korekcijeAneksPodugovorList);
  }

  private setOglasivaciList() {
    this.oglasivaciList = this._utilService.deepCopy(this.podugovor.Oglasivaci);
    this.setRbr(this.oglasivaciList);
  }

  private setAneksOglasivaciList() {
    this.aneksOglasivaciList = this._utilService.deepCopy(this.aneksPodugovora.Oglasivaci);
    this.setRbr(this.aneksOglasivaciList);
  }

  private setSponzorstvoEmisija() {
    this.sponzorstvaEmisijaList = this._utilService.deepCopy(
      this.podugovor.SponzorstvoEmisija
    );

    this.setRbr(this.sponzorstvaEmisijaList);
  }

  private setAneksSponzorstvoEmisija() {
    this.aneksSponzorstvaEmisijaList = this._utilService.deepCopy(
      this.aneksPodugovora.SponzorstvoEmisija
    );

    this.setRbr(this.aneksSponzorstvaEmisijaList);
  }

  private setSponzorstvaCena() {
    this.pregledDetaljaSponzorstvaCenaList = this._utilService.deepCopy(
      this.podugovor.SponzorstvoCene
    );
    this.pregledDetaljaSponzorstvaCenaList.forEach(x => {
      x.Naziv = x.VrstaSpotaNaziv;
    });
    this.setRbr(this.pregledDetaljaSponzorstvaCenaList);
  }

  private setAneksSponzorstvaCena() {
    this.aneksPregledDetaljaSponzorstvaCenaList = this._utilService.deepCopy(
      this.aneksPodugovora.SponzorstvoCene
    );
    this.aneksPregledDetaljaSponzorstvaCenaList.forEach(x => {
      x.Naziv = x.VrstaSpotaNaziv;
    });
    this.setRbr(this.aneksPregledDetaljaSponzorstvaCenaList);
  }

  getDefaultRbrPrimene(listaKorekcija: any[]): number {
    const temp = [...listaKorekcija];

    let rbr =
      +temp.sort((a, b) => b.RedniBrojPrimene - a.RedniBrojPrimene)[0]
        .RedniBrojPrimene + 1;
    if (!rbr) {
      rbr = 1;
    }

    return rbr;
  }

  isKorekcijaValid(index, mode: UgovorFormModeEnum) {
    let sifra;
    if (mode === UgovorFormModeEnum.Ugovor) {
      sifra = this.korekcijeUgovorList[index].TipKorekcijeSifra;
      this.setValidationOnKorekcije(sifra, this.korekcijeSettingsTable);
    }
    else {
      if(this.isAneksPodugovora) {
        sifra = this.korekcijeAneksPodugovorList[index].TipKorekcijeSifra;
        this.setValidationOnKorekcije(sifra, this.korekcijePodugovorSettings);
      }
      else {
        sifra = this.korekcijePodugovorList[index].TipKorekcijeSifra;
        this.setValidationOnKorekcije(sifra, this.korekcijePodugovorSettings);
      }
    }
  }

  setValidationOnKorekcije(sifra, settings: TableSettings) {
    if (sifra === 'U_SE' || sifra === 'P_SE') {
      settings.getFieldByName('VaziOd').mandatory = true;
      settings.getFieldByName('VaziDo').mandatory = true;
    } else {
      settings.getFieldByName('VaziOd').mandatory = false;
      settings.getFieldByName('VaziDo').mandatory = false;
    }
  }

  validateKorekcijaBeforeSave(event, tabela, index) {
    const POZICIJA_U_BLOKU = 'U_PB';
    const EMISIJA = 'U_EM';

    const isValid = true;
    const korekcijeSaProgramomZaPoredjenje = null;
    const korekcijeBezProgramaZaPoredjenje = null;
    const korekcijeZaPoredjenje = null;
    let novaKorekcijaImaProgram = true;
    const postojeKorekcijeBezPrograma = true;
    const brojKorekcijaBezProgramaZaPoredjenje = null;
    let poruka = '';

    const novaKorekcija = { ...event.document };
    if (!novaKorekcija.ProgramId) {
      novaKorekcija.ProgramId = null;
      novaKorekcijaImaProgram = false;
    }

    if (tabela === 'ugovor') {
      const pripremljeniPodaciResult = this.pripremaPodatakaZaValidaciju(
        this.korekcijeUgovorList,
        novaKorekcija,
        korekcijeZaPoredjenje,
        korekcijeSaProgramomZaPoredjenje,
        korekcijeBezProgramaZaPoredjenje,
        postojeKorekcijeBezPrograma
      );

      const validacijaResult = this.validacijaPostojanjaKorekcijeZaSveProgrameIliZaPojedinacanProgram(
        pripremljeniPodaciResult.brojKorekcijaBezProgramaZaPoredjenje,
        pripremljeniPodaciResult.postojeKorekcijeBezPrograma,
        novaKorekcijaImaProgram,
        pripremljeniPodaciResult.korekcijeZaPoredjenje,
        novaKorekcija,
        POZICIJA_U_BLOKU,
        EMISIJA,
        isValid
      );

      if (validacijaResult.isValid === false) {
        poruka = this.generisanjePorukeZaValidacijuKorekcije(
          validacijaResult.korekcijaSaKojomPostojiPreklapanjeDatuma,
          validacijaResult.jeKorekcijaZaPoziciju,
          validacijaResult.jeKorekcijaZaEmisiju,
          poruka
        );

        return this.showRowError(
          event,
          poruka,
          this.korekcijeUgovorContentPlaceholder
        );
      }
    } else {
      if(this.isAneksPodugovora) {
          const pripremljeniPodaciResultAneks = this.pripremaPodatakaZaValidaciju(
          this.korekcijeAneksPodugovorList,
          novaKorekcija,
          korekcijeZaPoredjenje,
          korekcijeSaProgramomZaPoredjenje,
          korekcijeBezProgramaZaPoredjenje,
          postojeKorekcijeBezPrograma
        );

          const validacijaResultAneks = this.validacijaPostojanjaKorekcijeZaSveProgrameIliZaPojedinacanProgram(
          pripremljeniPodaciResultAneks.brojKorekcijaBezProgramaZaPoredjenje,
          pripremljeniPodaciResultAneks.postojeKorekcijeBezPrograma,
          novaKorekcijaImaProgram,
          pripremljeniPodaciResultAneks.korekcijeZaPoredjenje,
          novaKorekcija,
          POZICIJA_U_BLOKU,
          EMISIJA,
          isValid
        );

        if (validacijaResultAneks.isValid === false) {
          poruka = this.generisanjePorukeZaValidacijuKorekcije(
            validacijaResultAneks.korekcijaSaKojomPostojiPreklapanjeDatuma,
            validacijaResultAneks.jeKorekcijaZaPoziciju,
            validacijaResultAneks.jeKorekcijaZaEmisiju,
            poruka
          );

          return this.showRowError(
            event,
            poruka,
            this.korekcijeAneksPodugovorContentPlaceholder
          );
        }
      }
    else {
          const pripremljeniPodaciResult = this.pripremaPodatakaZaValidaciju(
          this.korekcijePodugovorList,
          novaKorekcija,
          korekcijeZaPoredjenje,
          korekcijeSaProgramomZaPoredjenje,
          korekcijeBezProgramaZaPoredjenje,
          postojeKorekcijeBezPrograma
        );

        const validacijaResult = this.validacijaPostojanjaKorekcijeZaSveProgrameIliZaPojedinacanProgram(
          pripremljeniPodaciResult.brojKorekcijaBezProgramaZaPoredjenje,
          pripremljeniPodaciResult.postojeKorekcijeBezPrograma,
          novaKorekcijaImaProgram,
          pripremljeniPodaciResult.korekcijeZaPoredjenje,
          novaKorekcija,
          POZICIJA_U_BLOKU,
          EMISIJA,
          isValid
        );

        if (validacijaResult.isValid === false) {
          poruka = this.generisanjePorukeZaValidacijuKorekcije(
            validacijaResult.korekcijaSaKojomPostojiPreklapanjeDatuma,
            validacijaResult.jeKorekcijaZaPoziciju,
            validacijaResult.jeKorekcijaZaEmisiju,
            poruka
          );

          return this.showRowError(
            event,
            poruka,
            this.korekcijePodugovorContentPlaceholder
          );
        }
      }
    }
  }

  pripremaPodatakaZaValidaciju(
    korekcije,
    novaKorekcija,
    korekcijeZaPoredjenje,
    korekcijeBezProgramaZaPoredjenje,
    postojeKorekcijeBezPrograma,
    brojKorekcijaBezProgramaZaPoredjenje
  ) {
    for (let i = 0; i < korekcije.length; i++) {
      if (korekcije[i].ProgramId === undefined) {
        korekcije[i].ProgramId = null;
      }
    }

    korekcijeBezProgramaZaPoredjenje = korekcije.filter(
      k =>
        k.ProgramId === null &&
        k.TipKorekcijeSifra === novaKorekcija.TipKorekcijeSifra
    );

    brojKorekcijaBezProgramaZaPoredjenje =
      korekcijeBezProgramaZaPoredjenje.length;

    if (
      korekcijeBezProgramaZaPoredjenje === null ||
      korekcijeBezProgramaZaPoredjenje.length === 0
    ) {
      postojeKorekcijeBezPrograma = false;
    }

    korekcijeZaPoredjenje = korekcije.filter(
      k => k.TipKorekcijeSifra === novaKorekcija.TipKorekcijeSifra
    );

    korekcijeZaPoredjenje = korekcijeZaPoredjenje.sort(k =>
      k.ProgramId === null ? -1 : 1
    );

    const trenutniIndex = korekcijeZaPoredjenje.findIndex(function(korekcija) {
      return korekcija.rbr === novaKorekcija.rbr;
    });
    korekcijeZaPoredjenje.splice(trenutniIndex, 1);

    return {
      brojKorekcijaBezProgramaZaPoredjenje: brojKorekcijaBezProgramaZaPoredjenje,
      postojeKorekcijeBezPrograma: postojeKorekcijeBezPrograma,
      korekcijeZaPoredjenje: korekcijeZaPoredjenje,
    };
  }

  validacijaPostojanjaKorekcijeZaSveProgrameIliZaPojedinacanProgram(
    brojKorekcijaBezProgramaZaPoredjenje,
    postojeKorekcijeBezPrograma,
    novaKorekcijaImaProgram,
    korekcijeZaPoredjenje,
    novaKorekcija,
    POZICIJA_U_BLOKU,
    EMISIJA,
    isValid
  ) {
    let jeKorekcijaZaPoziciju = false;
    let jeKorekcijaZaEmisiju = false;
    let brojUporedjenihKorekcijaBezPrograma = 0;
    let korekcijeBezProgramaSuUporedjene = false;
    let korekcijaSaKojomPostojiPreklapanjeDatuma = null;

    for (let i = 0; i < korekcijeZaPoredjenje.length; i++) {
      if (
        brojUporedjenihKorekcijaBezPrograma ===
        brojKorekcijaBezProgramaZaPoredjenje
      ) {
        korekcijeBezProgramaSuUporedjene = true;
      }
      switch (novaKorekcija.TipKorekcijeSifra) {
        case POZICIJA_U_BLOKU:
          {
            if (korekcijeZaPoredjenje[i].Pozicija === novaKorekcija.Pozicija) {
              jeKorekcijaZaPoziciju = true;
              isValid = this.datumskaValidacijaKorekcija(
                korekcijeZaPoredjenje,
                novaKorekcija,
                i,
                postojeKorekcijeBezPrograma,
                novaKorekcijaImaProgram,
                korekcijeBezProgramaSuUporedjene
              )
                ? false
                : true;
            }
          }
          break;
        case EMISIJA:
          {
            if (
              korekcijeZaPoredjenje[i].Emisija.Naziv ===
              novaKorekcija.Emisija.Naziv
            ) {
              jeKorekcijaZaEmisiju = true;
              isValid = this.datumskaValidacijaKorekcija(
                korekcijeZaPoredjenje,
                novaKorekcija,
                i,
                postojeKorekcijeBezPrograma,
                novaKorekcijaImaProgram,
                korekcijeBezProgramaSuUporedjene
              )
                ? false
                : true;
            }
          }
          break;
        default:
          {
            isValid = this.datumskaValidacijaKorekcija(
              korekcijeZaPoredjenje,
              novaKorekcija,
              i,
              postojeKorekcijeBezPrograma,
              novaKorekcijaImaProgram,
              korekcijeBezProgramaSuUporedjene
            )
              ? false
              : true;
          }
          break;
      }
      if (korekcijeZaPoredjenje[i].ProgramId === null) {
        brojUporedjenihKorekcijaBezPrograma++;
      }
      if (isValid === false) {
        korekcijaSaKojomPostojiPreklapanjeDatuma = korekcijeZaPoredjenje[i];
        break;
      }
    }

    return {
      isValid: isValid,
      jeKorekcijaZaPoziciju: jeKorekcijaZaPoziciju,
      jeKorekcijaZaEmisiju: jeKorekcijaZaEmisiju,
      korekcijaSaKojomPostojiPreklapanjeDatuma: korekcijaSaKojomPostojiPreklapanjeDatuma,
    };
  }

  datumskaValidacijaKorekcija(
    korekcijeZaPoredjenje,
    novaKorekcija,
    i,
    postojeKorekcijeBezPrograma,
    novaKorekcijaImaProgram,
    korekcijeBezProgramaSuUporedjene
  ) {
    if (novaKorekcija.VremeOd.length === 0 && novaKorekcija.VremeDo.length === 0 && 
      (korekcijeZaPoredjenje[i].VremeOd == null || korekcijeZaPoredjenje[i].VremeOd.length === 0) && (korekcijeZaPoredjenje[i].VremeDo == null || korekcijeZaPoredjenje[i].VremeDo.length === 0)) {
      if (!postojeKorekcijeBezPrograma && novaKorekcijaImaProgram) {
        if (
          korekcijeZaPoredjenje[i].ProgramId === null &&
          novaKorekcija.ProgramId !== null
        ) {
          return this.uporediDatume(korekcijeZaPoredjenje, i, novaKorekcija);
        } else if (
          korekcijeZaPoredjenje[i].ProgramId !== novaKorekcija.ProgramId
        ) {
          return false;
        } else {
          return this.uporediDatume(korekcijeZaPoredjenje, i, novaKorekcija);
        }
      } else if (korekcijeBezProgramaSuUporedjene) {
        if (korekcijeZaPoredjenje[i].ProgramId !== novaKorekcija.ProgramId) {
          return false;
        } else {
          return this.uporediDatume(korekcijeZaPoredjenje, i, novaKorekcija);
        }
      } else {
        return this.uporediDatume(korekcijeZaPoredjenje, i, novaKorekcija);
      }
    } else {
      if (novaKorekcija.ProgramId !== null && korekcijeZaPoredjenje[i].ProgramId !== null && korekcijeZaPoredjenje[i].ProgramId !== novaKorekcija.ProgramId) {
        return false;
      }
      if (novaKorekcija.VremeOd.length > 0 && novaKorekcija.VremeDo.length > 0 && 
          (korekcijeZaPoredjenje[i].VremeOd == null || korekcijeZaPoredjenje[i].VremeOd.length === 0) && (korekcijeZaPoredjenje[i].VremeDo == null || korekcijeZaPoredjenje[i].VremeDo.length === 0)) {
        return false;
      } else {
        return this.uporediDatumeSaVremenom(korekcijeZaPoredjenje[i], novaKorekcija);
      }
    }
    
  }

  uporediDatume(korekcijeZaPoredjenje, i, novaKorekcija) {
    const postojecaKorekcijaVaziDo = moment(
      korekcijeZaPoredjenje[i].VaziDo
    ).format('YYYY-MM-DD');
    const postojecaKorekcijaVaziOd = moment(
      korekcijeZaPoredjenje[i].VaziOd
    ).format('YYYY-MM-DD');
    const novaKorekcijaVaziDo = moment(novaKorekcija.VaziDo).format(
      'YYYY-MM-DD'
    );
    const novaKorekcijaVaziOd = moment(novaKorekcija.VaziOd).format(
      'YYYY-MM-DD'
    );
    const preklapanjeDatuma =
      novaKorekcijaVaziOd <= postojecaKorekcijaVaziDo &&
      novaKorekcijaVaziDo >= postojecaKorekcijaVaziOd;

    return preklapanjeDatuma;
  }

  uporediDatumeSaVremenom(korekcijaZaPoredjenje, novaKorekcija) {
    const dateFormat: string = 'YYYY-MM-DD';
    const postojecaKorekcijaVaziDo = moment(korekcijaZaPoredjenje.VaziDo).format(dateFormat);
    const postojecaKorekcijaVaziOd = moment(korekcijaZaPoredjenje.VaziOd).format(dateFormat);
    const novaKorekcijaVaziDo = moment(novaKorekcija.VaziDo).format(dateFormat);
    const novaKorekcijaVaziOd = moment(novaKorekcija.VaziOd).format(dateFormat);

    const preklapanjeDatuma = novaKorekcijaVaziOd <= postojecaKorekcijaVaziDo && novaKorekcijaVaziDo >= postojecaKorekcijaVaziOd;

    if (preklapanjeDatuma) {
      const start1 = this.timeToMinutes(novaKorekcija.VremeOd);
      const end1 = this.timeToMinutes(novaKorekcija.VremeDo);
      const start2 = this.timeToMinutes(korekcijaZaPoredjenje.VremeOd);
      const end2 = this.timeToMinutes(korekcijaZaPoredjenje.VremeDo);
    
      return start1 < end2 && start2 < end1;
    }

    return preklapanjeDatuma;
  }

  timeToMinutes(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  generisanjePorukeZaValidacijuKorekcije(
    korekcijaSaKojomPostojiPreklapanjeDatuma,
    jeKorekcijaZaPoziciju,
    jeKorekcijaZaEmisiju,
    poruka
  ) {
    if (jeKorekcijaZaPoziciju) {
      poruka = `Postoji preklapanje datuma sa korekcijom koja ima šifru: ${
        korekcijaSaKojomPostojiPreklapanjeDatuma.TipKorekcijeSifra
      }
    ${
      korekcijaSaKojomPostojiPreklapanjeDatuma.ProgramNaziv === null ||
      korekcijaSaKojomPostojiPreklapanjeDatuma.ProgramNaziv === undefined
        ? ', nema dodeljen program'
        : `, ima dodeljen program ${korekcijaSaKojomPostojiPreklapanjeDatuma.ProgramNaziv}`
    } i ima dodeljenu poziciju: ${
        korekcijaSaKojomPostojiPreklapanjeDatuma.Pozicija
      }.`;
    } else if (jeKorekcijaZaEmisiju) {
      poruka = `Postoji preklapanje datuma sa korekcijom koja ima šifru: ${
        korekcijaSaKojomPostojiPreklapanjeDatuma.TipKorekcijeSifra
      }
    ${
      korekcijaSaKojomPostojiPreklapanjeDatuma.ProgramNaziv === null ||
      korekcijaSaKojomPostojiPreklapanjeDatuma.ProgramNaziv === undefined
        ? ', nema dodeljen program'
        : `, ima dodeljen program ${korekcijaSaKojomPostojiPreklapanjeDatuma.ProgramNaziv}`
    } i ima dodeljenu emisiju: ${
        korekcijaSaKojomPostojiPreklapanjeDatuma.Emisija.Naziv
      }.`;
    } else {
      poruka = `Postoji preklapanje datuma sa korekcijom koja ima šifru: ${
        korekcijaSaKojomPostojiPreklapanjeDatuma.TipKorekcijeSifra
      }
    ${
      korekcijaSaKojomPostojiPreklapanjeDatuma.ProgramNaziv === null ||
      korekcijaSaKojomPostojiPreklapanjeDatuma.ProgramNaziv === undefined
        ? ', i nema dodeljen program'
        : `, i ima dodeljen program ${korekcijaSaKojomPostojiPreklapanjeDatuma.ProgramNaziv}`
    }.`;
    }

    return poruka;
  }

  korekcijeUgovorListTableAction(event: any) {
    if(this._ugovorFormMode === UgovorFormModeEnum.AneksUgovora) {
      const index = this.korekcijeAneksUgovorList.findIndex(
        i => i.rbr === event.document['rbr']
      );
  
      switch (event.action) {
        case TableActionEnum.Add:
          event.document.RedniBrojPrimene = this.getDefaultRbrPrimene(
            this.korekcijeAneksUgovorList
          );
          this.toggleEmisijaEditableField(this.korekcijeSettingsTable, false);
          break;
        case TableActionEnum.BeforeSave:
          if (event.document.VremeOd.length > 0 && !this._validationService.validateHHmm(event.document.VremeOd)) {
            this.showRowError(event, '"Vreme od" nije validno.', this.korekcijeUgovorContentPlaceholder);
            return;
          }
          if (event.document.VremeDo.length > 0 && !this._validationService.validateHHmm(event.document.VremeDo)) {
            this.showRowError(event, '"Vreme do" nije validno.', this.korekcijeUgovorContentPlaceholder);
            return;
          }
          if (event.document.VremeOd.length > 0 && event.document.VremeDo.length === 0) {
            this.showRowError(event, '"Vreme do" nije validno.', this.korekcijeUgovorContentPlaceholder);
            return;
          }
          if (event.document.VremeDo.length > 0 && event.document.VremeOd.length === 0) {
            this.showRowError(event, '"Vreme od" nije validno.', this.korekcijeUgovorContentPlaceholder);
            return;
          }
          this.isKorekcijaValid(index, UgovorFormModeEnum.Ugovor);
          this.validateKorekcijaBeforeSave(event, UgovorFormModeEnum.Ugovor, index);
          break;
        case TableActionEnum.Save:
          if (isNaN(event.document.RedniBrojPrimene)) {
            this.korekcijeAneksUgovorList[index].RedniBrojPrimene = null;
          }
          break;
        case TableActionEnum.EditCancel:
          if (
            this.korekcijeAneksUgovorList.some(a => a['rbr'] === event.document['rbr'])
          ) {
            this.copyProperties(
              event.document,
              this.korekcijeAneksUgovorList.filter(
                a => a['rbr'] === event.document['rbr']
              )[0]
            );
          }
          break;
        case TableActionEnum.Edit:
          this.switchSifraTipaKorekcije(
            index,
            this.korekcijeAneksUgovorList,
            this.korekcijeSettingsTable
          );
          break;
      }
    }
    else {
      const index = this.korekcijeUgovorList.findIndex(
        i => i.rbr === event.document['rbr']
      );
  
      switch (event.action) {
        case TableActionEnum.Add:
          event.document.RedniBrojPrimene = this.getDefaultRbrPrimene(
            this.korekcijeUgovorList
          );
          this.toggleEmisijaEditableField(this.korekcijeSettingsTable, false);
          break;
        case TableActionEnum.BeforeSave:
          if (event.document.VremeOd.length > 0 && !this._validationService.validateHHmm(event.document.VremeOd)) {
            this.showRowError(event, '"Vreme od" nije validno.', this.korekcijeUgovorContentPlaceholder);
            return;
          }
          if (event.document.VremeDo.length > 0 && !this._validationService.validateHHmm(event.document.VremeDo)) {
            this.showRowError(event, '"Vreme do" nije validno.', this.korekcijeUgovorContentPlaceholder);
            return;
          }
          if (event.document.VremeOd.length > 0 && event.document.VremeDo.length === 0) {
            this.showRowError(event, '"Vreme do" nije validno.', this.korekcijeUgovorContentPlaceholder);
            return;
          }
          if (event.document.VremeDo.length > 0 && event.document.VremeOd.length === 0) {
            this.showRowError(event, '"Vreme od" nije validno.', this.korekcijeUgovorContentPlaceholder);
            return;
          }
          this.isKorekcijaValid(index, UgovorFormModeEnum.Ugovor);
          this.validateKorekcijaBeforeSave(event, UgovorFormModeEnum.Ugovor, index);
          break;
        case TableActionEnum.Save:
          if (isNaN(event.document.RedniBrojPrimene)) {
            this.korekcijeUgovorList[index].RedniBrojPrimene = null;
          }
          break;
        case TableActionEnum.EditCancel:
          if (
            this.korekcijeUgovorList.some(a => a['rbr'] === event.document['rbr'])
          ) {
            this.copyProperties(
              event.document,
              this.korekcijeUgovorList.filter(
                a => a['rbr'] === event.document['rbr']
              )[0]
            );
          }
          break;
        case TableActionEnum.Edit:
          this.switchSifraTipaKorekcije(
            index,
            this.korekcijeUgovorList,
            this.korekcijeSettingsTable
          );
          break;
      }
    }
  }

  korekcijePodugovorListTableAction(event: any) {
    if(this.isAneksPodugovora) {
      const index = this.korekcijeAneksPodugovorList.findIndex(
        i => i.rbr === event.document['rbr']
      );
  
      switch (event.action) {
        case TableActionEnum.Add:
          event.document.RedniBrojPrimene = this.getDefaultRbrPrimene(
            this.korekcijeAneksPodugovorList
          );
          this.toggleEmisijaEditableField(this.korekcijePodugovorSettings, false);
          this.togglePozicijaEditableField(
            this.korekcijePodugovorSettings,
            false
          );
          this.switchSifraTipaKorekcije(
            index,
            this.korekcijeAneksPodugovorList,
            this.korekcijePodugovorSettings
          );
          break;
        case TableActionEnum.BeforeSave:
          if (event.document.VremeOd.length > 0 && !this._validationService.validateHHmm(event.document.VremeOd)) {
            this.showRowError(event, '"Vreme od" nije validno.', this.korekcijeAneksPodugovorContentPlaceholder);
            return;
          }
          if (event.document.VremeDo.length > 0 && !this._validationService.validateHHmm(event.document.VremeDo)) {
            this.showRowError(event, '"Vreme do" nije validno.', this.korekcijeAneksPodugovorContentPlaceholder);
            return;
          }
          if (event.document.VremeOd.length > 0 && event.document.VremeDo.length === 0) {
            this.showRowError(event, '"Vreme do" nije validno.', this.korekcijeAneksPodugovorContentPlaceholder);
            return;
          }
          if (event.document.VremeDo.length > 0 && event.document.VremeOd.length === 0) {
            this.showRowError(event, '"Vreme od" nije validno.', this.korekcijeAneksPodugovorContentPlaceholder);
            return;
          }
          this.isKorekcijaValid(index, UgovorFormModeEnum.AneksPodugovora);
          this.validateKorekcijaBeforeSave(event, UgovorFormModeEnum.AneksPodugovora, index);
          break;
        case TableActionEnum.Save:
          if (isNaN(event.document.RedniBrojPrimene)) {
            this.korekcijeAneksPodugovorList[index].RedniBrojPrimene = null;
          }
          // event.document.RedniBrojPrimene = Number(
          //   event.document.RedniBrojPrimene
          // );
          break;
        case TableActionEnum.EditCancel:
          if (
            this.korekcijeAneksPodugovorList.some(
              a => a['rbr'] === event.document['rbr']
            )
          ) {
            this.copyProperties(
              event.document,
              this.korekcijeAneksPodugovorList.filter(
                a => a['rbr'] === event.document['rbr']
              )[0]
            );
          }
          break;
        case TableActionEnum.Edit:
          this.switchSifraTipaKorekcije(
            index,
            this.korekcijeAneksPodugovorList,
            this.korekcijePodugovorSettings
          );
          break;
      }
    }
    else {
      const index = this.korekcijePodugovorList.findIndex(
        i => i.rbr === event.document['rbr']
      );
  
      switch (event.action) {
        case TableActionEnum.Add:
          event.document.RedniBrojPrimene = this.getDefaultRbrPrimene(
            this.korekcijePodugovorList
          );
          this.toggleEmisijaEditableField(this.korekcijePodugovorSettings, false);
          this.togglePozicijaEditableField(
            this.korekcijePodugovorSettings,
            false
          );
          this.switchSifraTipaKorekcije(
            index,
            this.korekcijePodugovorList,
            this.korekcijePodugovorSettings
          );
          break;
        case TableActionEnum.BeforeSave:
          if (event.document.VremeOd.length > 0 && !this._validationService.validateHHmm(event.document.VremeOd)) {
            this.showRowError(event, '"Vreme od" nije validno.', this.korekcijePodugovorContentPlaceholder);
            return;
          }
          if (event.document.VremeDo.length > 0 && !this._validationService.validateHHmm(event.document.VremeDo)) {
            this.showRowError(event, '"Vreme do" nije validno.', this.korekcijePodugovorContentPlaceholder);
            return;
          }
          if (event.document.VremeOd.length > 0 && event.document.VremeDo.length === 0) {
            this.showRowError(event, '"Vreme do" nije validno.', this.korekcijePodugovorContentPlaceholder);
            return;
          }
          if (event.document.VremeDo.length > 0 && event.document.VremeOd.length === 0) {
            this.showRowError(event, '"Vreme od" nije validno.', this.korekcijePodugovorContentPlaceholder);
            return;
          }
          this.isKorekcijaValid(index, UgovorFormModeEnum.Podugovor);
          this.validateKorekcijaBeforeSave(event, UgovorFormModeEnum.Podugovor, index);
          break;
        case TableActionEnum.Save:
          if (isNaN(event.document.RedniBrojPrimene)) {
            this.korekcijePodugovorList[index].RedniBrojPrimene = null;
          }
          break;
        case TableActionEnum.EditCancel:
          if (
            this.korekcijePodugovorList.some(
              a => a['rbr'] === event.document['rbr']
            )
          ) {
            this.copyProperties(
              event.document,
              this.korekcijePodugovorList.filter(
                a => a['rbr'] === event.document['rbr']
              )[0]
            );
          }
          break;
        case TableActionEnum.Edit:
          this.switchSifraTipaKorekcije(
            index,
            this.korekcijePodugovorList,
            this.korekcijePodugovorSettings
          );
          break;
      }
    }
  }

  spotoviPodugovorListTableAction(event) {
    switch (event.action) {
      case TableActionEnum.Save:
        this.toggleSpotLookup(false);
        event.document.State = 'added';
        return this.goToBottom();
      case TableActionEnum.BeforeSave:
        this.checkDupliSpot(event);
        break;

      case TableActionEnum.Update:
        event.document.State = 'updated';
        break;
      case TableActionEnum.EditCancel:
        if(this.isAneksPodugovora) {
          if (this.aneksSpotoviList.some(a => a['rbr'] === event.document.rbr)) {
            this.copyProperties(
              event.document,
              this.aneksSpotoviList.filter(a => a['rbr'] === event.document.rbr)[0]
            );
          }
        }
        else {
          if (this.spotoviList.some(a => a['rbr'] === event.document.rbr)) {
            this.copyProperties(
              event.document,
              this.spotoviList.filter(a => a['rbr'] === event.document.rbr)[0]
            );
          }
        }
        break;
      case TableActionEnum.Add:
        this.toggleSpotLookup(true);
        this.setSpotoviLookupInitFilter();
        if(this.isAneksPodugovora) {
          this.aneksSpotoviContentPlaceholder.onInlineAddOpenApproved(null, false);
        }
        else {
          this.spotoviContentPlaceholder.onInlineAddOpenApproved(null, false);
        }
        break;
      case TableActionEnum.Delete:
        if(this.isAneksPodugovora) {
          if (this.isModeEdit && event.document.Id) {
            this._spinner.show();
            this._subscriptions.push(
              this.checkSpotNaMP(event).subscribe((response: any) => {
                if (response.ServiceData === false) {
                  event.document.State = 'deleted';
                  this.aneksSpotoviContentPlaceholder.removeRowApproved(
                    event.document
                  );
                  this.deletedAneksSpotoviList.push(event.document);
                } else {
                  this._notificationService.notyError(
                    `Spot se koristi na rezervaciji u kombinaciji sa ovim podugovorom.`
                  );
                }
                this._spinner.hide();
              })
            );
          }
          else {
            this.aneksSpotoviContentPlaceholder.removeRowApproved(event.document);
            event.document.State = 'deleted';
          }
        }
        else {
          if (this.podugovor.Id && this.isModeEdit && event.document.Id) {
            this._spinner.show();
            this._subscriptions.push(
              this.checkSpotNaMP(event).subscribe((response: any) => {
                if (response.ServiceData === false) {
                  event.document.State = 'deleted';
                  this.spotoviContentPlaceholder.removeRowApproved(
                    event.document
                  );
                  this.deletedSpotoviList.push(event.document);
                } else {
                  this._notificationService.notyError(
                    `Spot se koristi na rezervaciji u kombinaciji sa ovim podugovorom.`
                  );
                }
                this._spinner.hide();
              })
            );
        } else {
          this.spotoviContentPlaceholder.removeRowApproved(event.document);
          event.document.State = 'deleted';
        }
      }
        
        break;
      case TableActionEnum.AddCancel:
        this.toggleSpotLookup(false);
        if(this.isAneksPodugovora) {
          return this.aneksSpotoviContentPlaceholder.removeRowApproved(event.document);
        }
        else {
          return this.spotoviContentPlaceholder.removeRowApproved(event.document);
        }

    }
  }

  private checkSpotNaMP(event: any): Observable<any> {
    let payload;
    if(this.isAneksPodugovora) {
        payload = this._rtsBackendService.getRequestPayload(
        FormCode.MSMP_SPOUSE,
        FormName.MediaPlan,
        EndpointTypes.GetAllEntities,
        `?spotId=${event.document.Id}&podugovorId=${this.aneksPodugovora.Id}`,
        null,
        null,
        true
      );
    }
    else {
        payload = this._rtsBackendService.getRequestPayload(
        FormCode.MSMP_SPOUSE,
        FormName.MediaPlan,
        EndpointTypes.GetAllEntities,
        `?spotId=${event.document.Id}&podugovorId=${this.podugovor.Id}`,
        null,
        null,
        true
      );
    }

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  private checkDupliSpot(event: any) {
    if(this.isAneksPodugovora) {
      if (this.aneksSpotoviList.filter(x => x.Id === event.document.Id).length > 1) {
        this.showRowError(
          event,
          'Izabrani spot je već dodat u podugovor.',
          this.aneksSpotoviContentPlaceholder
        );
      }
    }
    else {
      if (this.spotoviList.filter(x => x.Id === event.document.Id).length > 1) {
        this.showRowError(
          event,
          'Izabrani spot je već dodat u podugovor.',
          this.spotoviContentPlaceholder
        );
      }
    }
  }

  setPodugovorKlijentLookupInitFilter() {
    const filters = [];

    if (this.klijentBudzetList && this.klijentBudzetList.length) {
      filters.push({ name: 'klijentIds', value: this.klijentIds });
    } else {
      filters.push({ name: 'vratiPrazno', value: 'True' });
    }

    this.podugovorFieldStructure.getFieldByName(
      'Klijent'
    ).lookupInitFilter = filters;
  }

  setUgovorInitialValues(order) {
    order.TipUgovoraId = 5;
    order.DatumKreiranja = new Date();
    order.StatusUgovoraId = 1;
    order.NacinObracunaId = 2;
    order.NacinPlacanjaId = 3;
    order.ValutaId = 4;
  }

  fetchSingleEntity() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSUGO_UGOSINGLE,
          FormName.PregledUgovora,
          EndpointTypes.SingleEntity,
          '',
          this.order.Id ? this.order.Id : null
        )
        .subscribe((data) => {
          if (data.Error) {
            this._spinner.hide();
            let parts = data.Error.split('|');
            this.notifyError(parts[1].slice(0, -1));
            return;
          }
          this._spinner.hide();
          this.order = this.order.Id ? data.ServiceData[0] : {};
          
          
          this.setLookupsPathUgovor(data.Settings);
          if (!this.order.Id) {
            this.order.IsNew = true;
            this.order.JeAktivan = true;
            this.toggleEditBrojUgovora(data.Settings);
            this.setUgovorInitialValues(this.order);
            this.korekcijeUgovorList = [];
            this.ciljneGrupeUgovorList = [];
            this.podugovorList = [];
            this.deletedPodugovorList = [];
            this.pregledDetaljaSponzorstvaCenaList = [];
            this.sponzorstvaEmisijaList = [];
            this.klijentBudzetList = [];
            this.aneksPodugovora.JeAneks = false;
            this._enumService.fetchNacinObracunaUgovor(5);
          } else {
            this.order.IsNew = false;
            if (this._returnToMode === FormModeEnum.Aneks) {
              this.toggleEditBrojUgovora(data.Settings);
            }
            this.setKlijetBudzetList();
            this.setUgovoriKorekcijeList();
            this.setCiljneGrupeUgovorList();
            this.setPodugovoriList();
            this.setAneksiUgovoraList();
            this.setAneksiPodugovoraList();
          }

          if (!this.order.Id) {
            this.clearPodugovorTables();
          } else {
            this._enumService.fetchNacinObracunaUgovor(this.order.TipUgovoraId);
          }

          if (this.order.IzmenioImePrezime === null) {
            this.setInfobar(
              true,
              this.order.KorisnikImePrezime,
              this.order.DatumKreiranja
            );
          } else {
            this.setInfobar(
              true,
              this.order.IzmenioImePrezime,
              this.order.DatumIzmene
            );
          }

          this.showDetails = true;
          this.privilegije = data.Privilegije;

          if (this.order.Id) {
            this.showFinData = data.ServiceData[0].ShowFinData;
          } else {
            this.showFinData = true;
          }

          this.fetchPodugovorSettings();

          if (!this.showFinData) {
            this.hideFinDataUgovor(data.Settings);
          } else {
            this.setKorekcijeSettings(data.Settings, 'Ugovor');
            // if (this.order.Id) {
            //   this.getBudget(this.order.Id);
            // }
          }

          this.setTabUgovor(UgovorTabEnum.Podugovori);
          this.setKlijentiBudzetSettings(data.Settings);
          this.setRealizovanoNotEditableFields();
          this.setPodugovorListSettings(data.Settings);
          this.setCiljneGrupeUgovorSettings(data.Settings);

          this.splitDetails(data.Settings, 14, false);
          this.ugovorFieldStructure = new FieldStructure(
            data.Settings,
            'header'
          );

          this.setUgovorListSettings(data.Settings);
          if(this.mode === FormModeEnum.Add) {
            this.ugovorFieldStructure.getFieldByName('ParentBrojUgovora').visible = false;
            this.ugovorFieldStructure.getFieldByName('ParentPraviBrojUgovora').visible = false;
            this.ugovorFieldStructure.getFieldByName('PraviBrojUgovora').editable = false;
          }

          this.ugovorFieldStructure.getFieldByName('BrojAneksiranogUgovora').visible = false;

          if(this._ugovorFormMode === UgovorFormModeEnum.Ugovor && this.mode !== FormModeEnum.Add) {
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.View);
          }
          else {
            this.ugovorFieldStructure.getFieldByName('ParentJeAktivan').visible = false;
          }

          const isToggle = this.order.ValutaId === 1;
          if (isToggle === false) {
            this.clearKurs(this.order);
          }

          this.toggleKursData(this.ugovorFieldStructure, isToggle);

          if (!this.order.TipUgovoraId) {
            this.toggleNacinObracuna(this.ugovorFieldStructure, false);
          }

          this.disableJedinstvenaCena();
        })
    );
  }

  hideFinDataUgovor(settings) {
    this.finDataUgovor.forEach(x => {
      const index = settings.allFields.indexOf(
        settings.allFields.find(y => y.name === x)
      );
      if (index) {
        settings.allFields.splice(index, 1);
      }
    });
  }

  hideFinDataPodugovor(settings) {
    this.finDataPodugovor.forEach(x => {
      const index = settings.allFields.indexOf(
        settings.allFields.find(y => y.name === x)
      );
      if (index) {
        settings.allFields.splice(index, 1);
      }
    });
  }

  getFieldIndex(allFields: any[], name: string): number {
    return allFields.indexOf(allFields.find(x => x.name === name));
  }

  disableJedinstvenaCena() {
    if (
      this.ugovorFieldStructure.fieldList.find(
        x => x.fieldName === 'JedinstvenaCena'
      )
    ) {
      this.ugovorFieldStructure.getFieldByName(
        'JedinstvenaCena'
      ).visible = false;
    }
  }

  private setUgovoriKorekcijeList() {
    this.korekcijeUgovorList = this._utilService.deepCopy(this.order.Korekcije);
    this.setRbr(this.korekcijeUgovorList);
  }

  private setAneksUgovoriKorekcijeList() {
    this.korekcijeAneksUgovorList = this._utilService.deepCopy(this.order.Korekcije);
    this.setRbr(this.korekcijeAneksUgovorList);
  }

  private setKlijetBudzetList() {
    this.klijentBudzetList = this._utilService.deepCopy(
      this.order.KlijentBudzet
    );

    this.setRbr(this.klijentBudzetList);
  }

  private setAneksKlijentBudzetList() {
    this._ugovorZaAneksiranje.KlijentBudzet.forEach(function (klijent) {
      klijent.RealizovanoRSD = 0;
      klijent.RealizovanoEUR = 0;
      klijent.ProcenatIskoriscenosti = 0;
    });

    this.aneksKlijentBudzetList = this._utilService.deepCopy(
      this._ugovorZaAneksiranje.KlijentBudzet
    );

    this.setRbr(this.aneksKlijentBudzetList);
  }

  private setPodugovoriList() {
    this.podugovorList = [...this.order.Podugovori];
    this.setRbr(this.podugovorList);
  }

  private setAneksiUgovoraList() {
    if(this.order.AneksiraniUgovori) {
      this.aneksiUgovoraList = [...this.order.AneksiraniUgovori];
      this.setRbr(this.aneksiUgovoraList);
    }
  }

  private setAneksiPodugovoraList() {
    if(this.order.AneksiraniPodugovori) {
      this.aneksiPodugovoraList = [...this.order.AneksiraniPodugovori];
      this.setRbr(this.aneksiPodugovoraList);
    }
  }

  private setCiljneGrupeUgovorList() {
    this.ciljneGrupeUgovorList = this._utilService.deepCopy(
      this.order.CiljneGrupe
    );
    this.setRbr(this.ciljneGrupeUgovorList);
  }

  private setCiljneGrupeAneksUgovorList() {
    this.ciljneGrupeAneksUgovorList = this._utilService.deepCopy(
      this.order.CiljneGrupe
    );
    this.setRbr(this.ciljneGrupeAneksUgovorList);
  }

  toggleEditBrojUgovora(settings) {
    const index = settings.allFields.findIndex(
      field => field.fieldKey === 'BrojUgovora'
    );
    settings.allFields[index].editable = true;
  }

  private clearPodugovorTables() {
    this.korekcijePodugovorList = [];
    this.ciljneGrupePodugovorList = [];
    this.spotoviList = [];
    this.oglasivaciList = [];
    this.cenePoOdluciList = [];
    this.cppCeneList = [];
    this.pregledDetaljaSponzorstvaCenaList = [];
    this.sponzorstvaEmisijaList = [];
    this.brendiraneSpiceList = [];
  }

  private setPodugovorListSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'Podugovor');
    settings.details[index].inlineEditing = false;
    settings.details[index].inlineAdding = false;
    settings.details[index].additable = false;
    settings.details[index].deletable = false;

    this.podugovorSettingsTable = new TableSettings(
      settings.details[0],
      'table'
    );
  }

  private setUgovorListSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'UgovorTableSettings');
    settings.details[index].inlineEditing = false;
    settings.details[index].inlineAdding = false;
    settings.details[index].additable = false;
    settings.details[index].deletable = false;

    this.ugovorSettingsTable = new TableSettings(
      settings.details[index],
      'table'
    );
  }

  getDetailsIndex(settings: any, detailsGroup: string): number {
    return settings.details.findIndex(x => x.group === detailsGroup);
  }

  private setSpotoviSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'Spot');
    const spotoviSettings = settings.details[index];

    this.spotoviSettingsTable = new TableSettings(spotoviSettings, 'table');

    this.alterSpotoviTableSettings();
  }

  private setCenePoOdluciSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'CenaPoOdluci');
    const cenePoOdluciSettings = settings.details[index];

    this.cenePoOdluciSettingsTable = new TableSettings(
      cenePoOdluciSettings,
      'table'
    );

    this.alterCeneTableSettings(this.cenePoOdluciSettingsTable);
  }

  private setCppCeneSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'CenaCPP');
    const cppCeneSettings = settings.details[index];

    this.cppCeneSettingsTable = new TableSettings(cppCeneSettings, 'table');

    this.alterCppCeneTableSettings(this.cppCeneSettingsTable);
  }

  private setBrendiraneSpiceSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'BrendiranaSpica');
    const brendiraneSpiceSettings = settings.details[index];

    this.brendiraneSpiceSettingsTable = new TableSettings(
      brendiraneSpiceSettings,
      'table'
    );
  }

  setKorekcijeSettings(settings: any, ugoOrPug: string) {
    let settingsToUse = '';
    if (ugoOrPug === 'Ugovor') {
      settingsToUse = 'KorekcijaUgovorSettings';
    }
    if (ugoOrPug === 'Podugovor') {
      settingsToUse = 'KorekcijaPodugovorSettings';
    }
    const index = this.getDetailsIndex(settings, settingsToUse);
    settings.details[index].allFields.find(
      x => x.name === 'VrstaKorekcije'
    ).additable = false;
    settings.details[index].allFields.find(
      x => x.name === 'VrstaKorekcije'
    ).editable = false;

    settings.details[index].allFields.find(
      x => x.name === 'TipKorekcijeSifra'
    ).additable = false;
    settings.details[index].allFields.find(
      x => x.name === 'TipKorekcijeSifra'
    ).editable = false;

    if (ugoOrPug === 'Ugovor') {
      this.korekcijeSettingsTable = new TableSettings(
        settings.details[index],
        'table'
      );
    }

    if (ugoOrPug === 'Podugovor') {
      this.korekcijePodugovorSettings = new TableSettings(
        settings.details[index],
        'table'
      );
    }
  }

  private setCiljneGrupeUgovorSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'CiljnaGrupa');

    settings.details[index].allFields.forEach(field => {
      field.editable = !this.disabledColumnsCiljneGrupe.includes(
        field.fieldKey
      );
    });

    this.ciljneGrupeUgovorSettingsTable = new TableSettings(
      settings.details[index],
      'table'
    );

    this.setRbr(this.ciljneGrupeUgovorList);
  }

  private setCiljneGrupePodugovorSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'CiljnaGrupa');

    settings.details[index].allFields.forEach(field => {
      field.editable = !this.disabledColumnsCiljneGrupe.includes(
        field.fieldKey
      );
    });

    this.ciljneGrupePodugovorSettingsTable = new TableSettings(
      settings.details[index],
      'table'
    );

    this.setRbr(this.ciljneGrupePodugovorList);
  }

  setOglasivaciSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'Oglasivac');

    settings.details[index].allFields.forEach(field => {
      field.editable = !this.disabledColumnsOglasivaci.includes(field.fieldKey);
    });

    this.oglasivaciSettingsTable = new TableSettings(
      settings.details[index],
      'table'
    );
  }

  setSponzorstvoCenaSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'SponzorstvoCena');

    this.sponzorstvoCenaSettingsTable = new TableSettings(
      settings.details[index],
      'table'
    );
  }

  setSponzorstvoEmisijaSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'SponzorstvoEmisija');

    this.sponzorstvoEmisijaSettingsTable = new TableSettings(
      settings.details[index],
      'table'
    );
  }

  setKlijentiBudzetSettings(settings: any) {
    const index = this.getDetailsIndex(settings, 'KlijentUgovoreniBudzet');

    this.klijentBudzetSettings = new TableSettings(
      settings.details[index],
      'table'
    );
  }

  setLookupValuesOglasivac(event, index) {
    if(this.isAneksPodugovora) {
      this.aneksOglasivaciList[index].Sifra = event.newValue.Sifra;
      this.aneksOglasivaciList[index].PrezimeImeNaziv = event.newValue.Naziv;
      this.aneksOglasivaciList[index].KlijentId = event.newValue.Id;
      this.aneksOglasivaciList[index].Naziv = event.newValue.Naziv;
    }
    else {
      this.oglasivaciList[index].Sifra = event.newValue.Sifra;
      this.oglasivaciList[index].PrezimeImeNaziv = event.newValue.Naziv;
      this.oglasivaciList[index].KlijentId = event.newValue.Id;
      this.oglasivaciList[index].Naziv = event.newValue.Naziv;
    }
    
  }

  oglasivacValueChanged(event: any) {
    if(this.isAneksPodugovora) {
      if (event.newValue) {
        const index = this.aneksOglasivaciList.findIndex(b => {
          return b.rbr === event.order.rbr;
        });
        switch (event.fieldMap.fieldKey) {
          case 'Lookup':
            this.setLookupValuesOglasivac(event, index);
            break;
  
          case 'IznosRSD':
            this.aneksOglasivaciList[index].IznosRSD = event.order.IznosRSD;
            break;
  
          case 'IznosEUR':
            this.aneksOglasivaciList[index].IznosEUR = event.order.IznosEUR;
            break;
        }
      }  
    }
    else {
      if (event.newValue) {
        const index = this.oglasivaciList.findIndex(b => {
          return b.rbr === event.order.rbr;
        });
        switch (event.fieldMap.fieldKey) {
          case 'Lookup':
            this.setLookupValuesOglasivac(event, index);
            break;
  
          case 'IznosRSD':
            this.oglasivaciList[index].IznosRSD = event.order.IznosRSD;
            break;
  
          case 'IznosEUR':
            this.oglasivaciList[index].IznosEUR = event.order.IznosEUR;
            break;
        }
      }
    }
  }

  korekcijeUgovorValueChange(event: any) {
    if(this._ugovorFormMode === UgovorFormModeEnum.AneksUgovora) {
      if (event.newValue) {
        const index = this.korekcijeAneksUgovorList.findIndex(b => {
          return b.rbr === event.order['rbr'];
        });
  
        switch (event.fieldMap.fieldKey) {
          case 'TipKorekcijeId':
            const korekcija = this._enumService._korekcijeUgovor.find(
              k => k.Id === this.korekcijeAneksUgovorList[index].TipKorekcijeId
            );
            this.korekcijeAneksUgovorList[index].VrstaKorekcije = korekcija.Vrsta;
            this.korekcijeAneksUgovorList[index].TipKorekcijeSifra = korekcija.Sifra;
  
            this.switchSifraTipaKorekcije(
              index,
              this.korekcijeAneksUgovorList,
              this.korekcijeSettingsTable
            );
            this.fillDatumiKorkecije(this.korekcijeAneksUgovorList, index, this.order);
            break;
          case 'RedniBrojPrimene':
            if (this.korekcijeAneksUgovorList[index].RedniBrojPrimene) {
              if (
                this.isNotNumber(this.korekcijeAneksUgovorList[index].RedniBrojPrimene)
              ) {
                this.korekcijeAneksUgovorList[index].RedniBrojPrimene = null;
                this.notifyError(
                  'Vrednost rednog broja primene korekcije mora biti ceo broj.'
                );
              }
            }
            break;
          case 'ProgramId':
            this.setValidation(
              index,
              this.korekcijeAneksUgovorList,
              this.korekcijeSettingsTable,
              this.korekcijeUgovorContentPlaceholder
            );
  
            let val = null;
            if (event.newValue) {
              val = event.newValue;
            }
            const program = this._enumService.getProgramById(val);
            this.korekcijeAneksUgovorList[index].ProgramId = program.Id;
            this.korekcijeAneksUgovorList[index].ProgramNaziv = program.Naziv;
            break;
        }
      }
    }
    else {
      if (event.newValue) {
        const index = this.korekcijeUgovorList.findIndex(b => {
          return b.rbr === event.order['rbr'];
        });
  
        switch (event.fieldMap.fieldKey) {
          case 'TipKorekcijeId':
            const korekcija = this._enumService._korekcijeUgovor.find(
              k => k.Id === this.korekcijeUgovorList[index].TipKorekcijeId
            );
            this.korekcijeUgovorList[index].VrstaKorekcije = korekcija.Vrsta;
            this.korekcijeUgovorList[index].TipKorekcijeSifra = korekcija.Sifra;
  
            this.switchSifraTipaKorekcije(
              index,
              this.korekcijeUgovorList,
              this.korekcijeSettingsTable
            );
            this.fillDatumiKorkecije(this.korekcijeUgovorList, index, this.order);
            break;
          case 'RedniBrojPrimene':
            if (this.korekcijeUgovorList[index].RedniBrojPrimene) {
              if (
                this.isNotNumber(this.korekcijeUgovorList[index].RedniBrojPrimene)
              ) {
                this.korekcijeUgovorList[index].RedniBrojPrimene = null;
                this.notifyError(
                  'Vrednost rednog broja primene korekcije mora biti ceo broj.'
                );
              }
            }
            break;
          case 'ProgramId':
            this.setValidation(
              index,
              this.korekcijeUgovorList,
              this.korekcijeSettingsTable,
              this.korekcijeUgovorContentPlaceholder
            );
  
            let val = null;
            if (event.newValue) {
              val = event.newValue;
            }
            const program = this._enumService.getProgramById(val);
            this.korekcijeUgovorList[index].ProgramId = program.Id;
            this.korekcijeUgovorList[index].ProgramNaziv = program.Naziv;
            break;
        }
      }
    }
  }

  fillDatumiKorkecije(lista, index, objekatUgovora) {
    const sifra = lista[index].TipKorekcijeSifra;
    switch (sifra) {
      case 'P_SE':
      case 'U_SE':
        lista[index].VaziOd = '';
        lista[index].VaziDo = '';
        break;
      default:
        lista[index].VaziOd = objekatUgovora.DatumKreiranja;
        lista[index].VaziDo = objekatUgovora.DatumIsteka;
        break;
    }
  }

  switchSifraTipaKorekcije(index: number, korekcije, settings: TableSettings) {
    if (korekcije[index].TipKorekcijeId) {
      let sifra = '';
      if (settings.documentId === 'KorekcijaUgovorSettings') {
        sifra = this._enumService._korekcijeUgovor.find(
          k => k.Id === korekcije[index].TipKorekcijeId
        ).Sifra;
      } else {
        sifra = this._enumService._korekcijePodugovor.find(
          k => k.Id === korekcije[index].TipKorekcijeId
        ).Sifra;
      }

      if (sifra === 'U_EM') {
        this.toggleEmisijaEditableField(settings, true);
        settings.getFieldByName('Emisija').mandatory = true;
      } else {
        this.toggleEmisijaEditableField(settings, false);
        settings.getFieldByName('Emisija').mandatory = false;
        korekcije[index].Emisija = {};
      }

      if (settings.documentId === 'KorekcijaPodugovorSettings') {
        if (sifra === 'U_PB') {
          this.togglePozicijaEditableField(settings, true);
          settings.getFieldByName('Pozicija').mandatory = true;
        } else {
          this.togglePozicijaEditableField(settings, false);
          settings.getFieldByName('Pozicija').mandatory = false;
          korekcije[index].Pozicija = null;
        }
      }
    }
  }

  korekcijePodugovorValueChange(event: any) {
    if(this.isAneksPodugovora) {
      if (event.newValue) {
        const index = this.korekcijeAneksPodugovorList.findIndex(b => {
          return b.rbr === event.order.rbr;
        });
  
        switch (event.fieldMap.fieldKey) {
          case 'TipKorekcijeId':
            const korekcija = this._enumService._korekcijePodugovor.find(
              k => k.Id === this.korekcijeAneksPodugovorList[index].TipKorekcijeId
            );
            this.korekcijeAneksPodugovorList[index].TipKorekcijeSifra =
              korekcija.Sifra;
            this.korekcijeAneksPodugovorList[index].VrstaKorekcije = korekcija.Vrsta;
            this.switchSifraTipaKorekcije(
              index,
              this.korekcijeAneksPodugovorList,
              this.korekcijePodugovorSettings
            );
            this.fillDatumiKorkecije(
              this.korekcijeAneksPodugovorList,
              index,
              this.aneksPodugovora
            );
            break;
          case 'RedniBrojPrimene':
            if (this.korekcijeAneksPodugovorList[index].RedniBrojPrimene) {
              if (
                this.isNotNumber(
                  this.korekcijeAneksPodugovorList[index].RedniBrojPrimene
                )
              ) {
                this.korekcijeAneksPodugovorList[index].RedniBrojPrimene = null;
                this.notifyError(
                  'Vrednost rednog broja primene korekcije mora biti ceo broj.'
                );
              }
            }
            break;
          case 'ProgramId':
            this.setValidation(
              index,
              this.korekcijeAneksPodugovorList,
              this.korekcijePodugovorSettings,
              this.korekcijeAneksPodugovorContentPlaceholder
            );
  
            let val = null;
            if (event.newValue) {
              val = event.newValue;
            }
            const program = this._enumService.getProgramById(val);
            this.korekcijeAneksPodugovorList[index].ProgramId = program.Id;
            this.korekcijeAneksPodugovorList[index].ProgramNaziv = program.Naziv;
            break;
        }
      }
    }
    else {
      if (event.newValue) {
        const index = this.korekcijePodugovorList.findIndex(b => {
          return b.rbr === event.order.rbr;
        });
  
        switch (event.fieldMap.fieldKey) {
          case 'TipKorekcijeId':
            const korekcija = this._enumService._korekcijePodugovor.find(
              k => k.Id === this.korekcijePodugovorList[index].TipKorekcijeId
            );
            this.korekcijePodugovorList[index].TipKorekcijeSifra =
              korekcija.Sifra;
            this.korekcijePodugovorList[index].VrstaKorekcije = korekcija.Vrsta;
            this.switchSifraTipaKorekcije(
              index,
              this.korekcijePodugovorList,
              this.korekcijePodugovorSettings
            );
            this.fillDatumiKorkecije(
              this.korekcijePodugovorList,
              index,
              this.podugovor
            );
            break;
          case 'RedniBrojPrimene':
            if (this.korekcijePodugovorList[index].RedniBrojPrimene) {
              if (
                this.isNotNumber(
                  this.korekcijePodugovorList[index].RedniBrojPrimene
                )
              ) {
                this.korekcijePodugovorList[index].RedniBrojPrimene = null;
                this.notifyError(
                  'Vrednost rednog broja primene korekcije mora biti ceo broj.'
                );
              }
            }
            break;
          case 'ProgramId':
            this.setValidation(
              index,
              this.korekcijePodugovorList,
              this.korekcijePodugovorSettings,
              this.korekcijePodugovorContentPlaceholder
            );
  
            let val = null;
            if (event.newValue) {
              val = event.newValue;
            }
            const program = this._enumService.getProgramById(val);
            this.korekcijePodugovorList[index].ProgramId = program.Id;
            this.korekcijePodugovorList[index].ProgramNaziv = program.Naziv;
            break;
        }
      }
    }
  }

  changeMetodRacunanja() {
    if(this.isAneksPodugovora) {
      const budzet = this.klijentBudzetList.find(
        b => b.Klijent.Id === this.aneksPodugovora.Klijent.Id
      );
  
      if (budzet) {
        this._spinner.show();
        this._subscriptions.push(
          this.fetchMetodRacunanja(budzet).subscribe(response => {
            if (this.responseHasError(response)) {
              return this.notifyErrorFromResponse(response);
            }
  
            this.aneksPodugovora.MetodRacunanja = response.ServiceData;
            this.notify(
              `Metod obračuna postavljen na "${this.aneksPodugovora.MetodRacunanja}".`
            );
  
            this._spinner.hide();
          })
        );
      }
    }
    else {
      const budzet = this.klijentBudzetList.find(
        b => b.Klijent.Id === this.podugovor.Klijent.Id
      );
  
      if (budzet) {
        this._spinner.show();
        this._subscriptions.push(
          this.fetchMetodRacunanja(budzet).subscribe(response => {
            if (this.responseHasError(response)) {
              return this.notifyErrorFromResponse(response);
            }
  
            this.podugovor.MetodRacunanja = response.ServiceData;
            this.notify(
              `Metod obračuna postavljen na "${this.podugovor.MetodRacunanja}".`
            );
  
            this._spinner.hide();
          })
        );
      }
    }
  }

  setSpotoviLookupInitFilter() {
    const filters = [
      {
        name: 'jeSpica',
        value: 'False',
      },
    ];

    if(this.isAneksPodugovora) {
      if (this.aneksPodugovora.Klijent) {
        filters.push({ name: 'klijentId', value: this.aneksPodugovora.Klijent.Id });
      } else {
        filters.push({ name: 'vratiPrazno', value: 'True' });
      }
    }
    else {
      if (this.podugovor.Klijent) {
        filters.push({ name: 'klijentId', value: this.podugovor.Klijent.Id });
      } else {
        filters.push({ name: 'vratiPrazno', value: 'True' });
      }
    }

    this.spotoviSettingsTable.getFieldByName(
      'Lookup'
    ).lookupInitFilter = filters;
  }

  toggleJedinstvenaCenaField(id: number, fieldStructure: FieldStructure) {
    if(fieldStructure) {
    this.showJedinstvenaCena(+id !== 2, fieldStructure);

      if (
        fieldStructure.fieldList.find(x => x.fieldName === 'UkupnaVrednostPaketa')
      ) {
        const toggleEdit = +id === 3;
        this.setEditableJedinstvenaCena(toggleEdit, fieldStructure);
        this.toggleJedinstvenaCenaLabel(fieldStructure, id);
      }
    }
  }

  showJedinstvenaCena(show: boolean, fieldStructure: FieldStructure) {
    fieldStructure.getFieldByName('JedinstvenaCena').visible = show;
  }

  toggleTrajanjePodugovor(id: number) {
    const trajanjeVisible = +id === 3;
    this.podugovorFieldStructure.getFieldByName(
      'Trajanje'
    ).visible = trajanjeVisible;
  }

  toggleUkupnaVrednostPaketaPodugovor(id: number) {
    if (
      this.podugovorFieldStructure.fieldList.find(
        x => x.fieldName === 'UkupnaVrednostPaketa'
      )
    ) {
      const result = id ? +id === 3 : false;
      this.podugovorFieldStructure.getFieldByName(
        'UkupnaVrednostPaketa'
      ).visible = result;
    }
  }

  toggleEmisijaEditableField(
    korekcijaSettings: TableSettings,
    enabled: boolean
  ) {
    korekcijaSettings.getFieldByName('Emisija').editable = enabled;
    korekcijaSettings.getFieldByName('Emisija').additable = enabled;
  }

  togglePozicijaEditableField(
    korekcijaSettings: TableSettings,
    enabled: boolean
  ) {
    const field = korekcijaSettings.getFieldByName('Pozicija');
    if (field) {
      field.editable = enabled;
      field.additable = enabled;
    }
  }

  setRealizovanoNotEditableFields() {
    const realizovanoEUR = this.klijentBudzetSettings.getFieldByName('RealizovanoEUR');
    const realizovanoRSD = this.klijentBudzetSettings.getFieldByName('RealizovanoRSD');
    const procenatIskoriscenosti = this.klijentBudzetSettings.getFieldByName('ProcenatIskoriscenosti');
    realizovanoEUR.editable = false;
    realizovanoRSD.editable = false;
    procenatIskoriscenosti.editable = false;
  }

  setEditableJedinstvenaCena(enabled: boolean, fieldStructure: FieldStructure) {
    if (fieldStructure.getFieldByName('JedinstvenaCena') !== null) {
      fieldStructure.getFieldByName('JedinstvenaCena').editable = enabled;
      fieldStructure.getFieldByName('JedinstvenaCena').additable = enabled;
    }
  }

  onPodugovorValueChanged(event) {
    if (event.newValue) {
      if(this.isAneksPodugovora) {
        switch (event.fieldMap.fieldKey) {
          case 'Klijent':
            this.aneksPodugovora.Klijent.Id = event.newValue.Id;
            this.aneksPodugovora.KlijentNaziv = event.newValue.NazivImePrezime;
            this.setSpotoviLookupInitFilter();
            this.aneksPodugovora.JeAgencija = event.newValue.JeAgencija;
  
            if (this.aneksPodugovora.NacinObracunaId === 2) {
              this.changeMetodRacunanja();
            }
            break;
          case 'TipUgovoraId':
            this.setEditableJedinstvenaCena(false, this.podugovorFieldStructure);
            this.toggleNacinObracuna(this.podugovorFieldStructure, true);
  
            this.tipUgovoraSwitched(
              'MSUGO_PUG_NacinObracunaIdEnum',
              event.newValue
            );
  
            if (event.oldValue === 4 && event.newValue !== 4) {
              this._notificationService.openNoty(
                'Promenom tipa ugovora sve unete cene po odluci biće obrisane.',
                false
              );
              this.setTabPodugovor(PodugovorTabEnum.KorekcijeAneks);
            }
  
            if (event.oldValue !== 5 && event.newValue === 5) {
              this.changeMetodRacunanja();
            }
  
            break;
          case 'NacinObracunaId':
            this.toggleMetodRacunanja(event.newValue === 2);
            if (event.newValue === 2 && this.aneksPodugovora.Klijent) {
              if (event.newValue !== event.oldValue) {
                this.changeMetodRacunanja();
              }
            } else {
              this.aneksPodugovora.MetodRacunanja = null;
            }
  
            this.toggleJedinstvenaCenaField(
              event.newValue,
              this.podugovorFieldStructure
            );
            this.toggleUkupnaVrednostPaketaPodugovor(
              this.aneksPodugovora.NacinObracunaId
            );
            this.toggleTrajanjePodugovor(this.aneksPodugovora.NacinObracunaId);
            // tslint:disable-next-line: triple-equals
            if(this.aneksPodugovora.NacinObracunaId === 3) {
              this.toggleBrojRezervacijaField(true);
            }
            else {
              this.toggleBrojRezervacijaField(false);
            }
            //this.toggleBrojRezervacijaField(event.newValue == 3);
  
            // aktivira drugi tab ako je nestao tab 'CPP Cene' usled promene nacina obracuna
            if (
              this.aneksPodugovora.TipUgovoraId === 1 &&
              event.oldValue === 2 &&
              event.newValue !== 2 &&
              this.activeTabPodugovor === PodugovorTabEnum.CppCeneAneks
            ) {
              this.setTabPodugovor(PodugovorTabEnum.SpotoviAneks);
            }
            break;
          case 'ValutaId':
            const isToggleKurs = event.newValue === 1;
            const isSponzorstvo = this.aneksPodugovora.NacinObracunaId === 4;
            if (isToggleKurs === false) {
              this.clearKurs(this.aneksPodugovora);
            }
            this.toggleKursData(this.podugovorFieldStructure, isToggleKurs);
            if (isSponzorstvo) {
              this.sponzorstvoValuta = this._enumService.valuteUgo.find(
                x => x.Id === this.aneksPodugovora.ValutaId
              ).Oznaka;
            }
            break;
        }
      }
      else {
        switch (event.fieldMap.fieldKey) {
          case 'Klijent':
            this.podugovor.Klijent.Id = event.newValue.Id;
            this.podugovor.KlijentNaziv = event.newValue.NazivImePrezime;
            this.setSpotoviLookupInitFilter();
            this.podugovor.JeAgencija = event.newValue.JeAgencija;
  
            if (this.podugovor.NacinObracunaId === 2) {
              this.changeMetodRacunanja();
            }
            break;
          case 'TipUgovoraId':
            this.setEditableJedinstvenaCena(false, this.podugovorFieldStructure);
            this.toggleNacinObracuna(this.podugovorFieldStructure, true);
  
            this.tipUgovoraSwitched(
              'MSUGO_PUG_NacinObracunaIdEnum',
              event.newValue
            );
  
            if (event.oldValue === 4 && event.newValue !== 4) {
              this._notificationService.openNoty(
                'Promenom tipa ugovora sve unete cene po odluci biće obrisane.',
                false
              );
              this.setTabPodugovor(PodugovorTabEnum.Korekcije);
            }
  
            if (event.oldValue !== 5 && event.newValue === 5) {
              this.changeMetodRacunanja();
            }
  
            break;
          case 'NacinObracunaId':
            this.toggleMetodRacunanja(event.newValue === 2);
            if (event.newValue === 2 && this.podugovor.Klijent) {
              if (event.newValue !== event.oldValue) {
                this.changeMetodRacunanja();
              }
            } else {
              this.podugovor.MetodRacunanja = null;
            }
  
            this.toggleJedinstvenaCenaField(
              event.newValue,
              this.podugovorFieldStructure
            );
            this.toggleUkupnaVrednostPaketaPodugovor(
              this.podugovor.NacinObracunaId
            );
            this.toggleTrajanjePodugovor(this.podugovor.NacinObracunaId);
            // tslint:disable-next-line: triple-equals
            if(this.podugovor.NacinObracunaId === 3) {
              this.toggleBrojRezervacijaField(true);
            }
            else {
              this.toggleBrojRezervacijaField(false);
            }
            //this.toggleBrojRezervacijaField(event.newValue == 3);
  
            // aktivira drugi tab ako je nestao tab 'CPP Cene' usled promene nacina obracuna
            if (
              this.podugovor.TipUgovoraId === 1 &&
              event.oldValue === 2 &&
              event.newValue !== 2 &&
              this.activeTabPodugovor === PodugovorTabEnum.CppCene
            ) {
              this.setTabPodugovor(PodugovorTabEnum.Spotovi);
            }
            break;
          case 'ValutaId':
            const isToggleKurs = event.newValue === 1;
            const isSponzorstvo = this.podugovor.NacinObracunaId === 4;
            if (isToggleKurs === false) {
              this.clearKurs(this.podugovor);
            }
            this.toggleKursData(this.podugovorFieldStructure, isToggleKurs);
            if (isSponzorstvo) {
              this.sponzorstvoValuta = this._enumService.valuteUgo.find(
                x => x.Id === this.podugovor.ValutaId
              ).Oznaka;
            }
            break;
        }
      }
    }
  }

  toggleJedinstvenaCenaMandatory() {
    if (
      this.podugovor.TipUgovoraId === 5 ||
      this.podugovor.TipUgovoraId === 2
    ) {
      this.podugovorFieldStructure.getFieldByName(
        'JedinstvenaCena'
      ).mandatory = true;
    } else {
      this.podugovorFieldStructure.getFieldByName(
        'JedinstvenaCena'
      ).mandatory = false;
    }
  }

  toggleAneksJedinstvenaCenaMandatory() {
    if (
      this.aneksPodugovora.TipUgovoraId === 5 ||
      this.aneksPodugovora.TipUgovoraId === 2
    ) {
      this.podugovorFieldStructure.getFieldByName(
        'JedinstvenaCena'
      ).mandatory = true;
    } else {
      this.podugovorFieldStructure.getFieldByName(
        'JedinstvenaCena'
      ).mandatory = false;
    }
  }

  toggleBrojRezervacijaField(enabled: boolean) {
    this.podugovorFieldStructure.getFieldByName(
      'BrojPlaniranihRezervacija'
    ).visible = enabled;
    this.podugovorFieldStructure.getFieldByName(
      'BrojPlaniranihRezervacija'
    ).mandatory = enabled;
    // this.podugovorFieldStructure.getFieldByName(
    //   'JedinstvenaCena'
    // ).mandatory = enabled;

    if (!enabled) {
      if(this.activeTabUgovor === UgovorTabEnum.AneksiPodugovora) {
        this.aneksPodugovora.BrojPlaniranihRezervacija = null;
      }
      else {
        this.podugovor.BrojPlaniranihRezervacija = null;
      }
    }
  }

  private clearKurs(obj) {
    obj.DatumValute = '';
    obj.Kurs = null;
  }

  private toggleKursData(fieldStructure: FieldStructure, isToggle: boolean) {
    this.toggleKurs(fieldStructure, isToggle);
    this.toggleDatumValute(fieldStructure, isToggle);
  }

  toggleKurs(fieldStructure: FieldStructure, enabled: boolean) {
    const kursField = fieldStructure.getFieldByName('Kurs');
    if (kursField) {
      kursField.editable = enabled;
      kursField.additable = enabled;
    }
  }

  toggleDatumValute(fieldStructure: FieldStructure, enabled: boolean) {
    const datumValuteField = fieldStructure.getFieldByName('DatumValute');
    if (datumValuteField) {
      datumValuteField.editable = enabled;
      datumValuteField.additable = enabled;
    }
  }

  toggleNacinObracuna(fieldStructure: FieldStructure, enabled: boolean) {
      if(fieldStructure) {
        const nacinObracunaPug = fieldStructure.fieldList.find(
          f => f.fieldKey === 'NacinObracunaId'
        );
        nacinObracunaPug.editable = enabled;
        nacinObracunaPug.additable = enabled;
      }
  }

  onOglasivaciChanged(event: TableActionParams) {
    if (
      event.action === TableActionEnum.Save ||
      event.action === TableActionEnum.Delete ||
      event.action === TableActionEnum.Update
    ) {
      this.setSumsOglasivaci();
    }

    if (event.action === TableActionEnum.Save) {
      event.document.IznosRSD = +event.document.IznosRSD;
      event.document.IznosEUR = +event.document.IznosEUR;
    }

    if(this.isAneksPodugovora) {
      if (TableActionEnum.EditCancel) {
        if (this.aneksOglasivaciList.some(a => a['rbr'] === event.document.rbr)) {
          this.copyProperties(
            event.document,
            this.aneksOglasivaciList.filter(a => a['rbr'] === event.document.rbr)[0]
          );
        }
      }
    }
    else {
      if (TableActionEnum.EditCancel) {
        if (this.oglasivaciList.some(a => a['rbr'] === event.document.rbr)) {
          this.copyProperties(
            event.document,
            this.oglasivaciList.filter(a => a['rbr'] === event.document.rbr)[0]
          );
        }
      }
    }
  }

  setSumsOglasivaci() {
    if(this.isAneksPodugovora) {
      this.aneksPodugovora.SumaOglasivacaRSD = 0;
      this.aneksPodugovora.SumaOglasivacaEUR = 0;
  
      this.oglasivaciList.forEach(o => {
        this.aneksPodugovora.SumaOglasivacaRSD += +o.IznosRSD;
        this.aneksPodugovora.SumaOglasivacaEUR += +o.IznosEUR;
      });
    }
    else {
      this.podugovor.SumaOglasivacaRSD = 0;
      this.podugovor.SumaOglasivacaEUR = 0;
  
      this.oglasivaciList.forEach(o => {
        this.podugovor.SumaOglasivacaRSD += +o.IznosRSD;
        this.podugovor.SumaOglasivacaEUR += +o.IznosEUR;
      });
    }
  }

  setSpotoviPodugovorList(collection: any[], event: any) {
    let index;
    if(this.isAneksPodugovora) {
      index = this.getRowIndex(this.aneksSpotoviList, event);
    }
    else {
      index = this.getRowIndex(this.spotoviList, event);
    }

    collection[index].Id = event.newValue.Id;
    collection[index].Sifra = event.newValue.Sifra;
    collection[index].Naziv = event.newValue.Naziv;
    collection[index].VrstaSpotaId = event.newValue.VrstaSpotaId;
    collection[index].VrstaSpota = event.newValue.VrstaSpota;
    collection[index].KlijentNaziv = event.newValue.KlijentNaziv;
    collection[index].TrajanjeSekunde = event.newValue.TrajanjeSekunde;
  }

  private getRowIndex(list: any[], event: any) {
    return list.findIndex(b => {
      return b.rbr === event.order.rbr;
    });
  }

  setLookupsPathPodugovor(podugovorSettings: any) {
    podugovorSettings.details
      .find(x => x.name === 'Spot')
      .allFields.find(x => x.name === 'Lookup').path = 'Lookup';

    podugovorSettings.details
      .find(x => x.name === 'Oglasivac')
      .allFields.find(x => x.name === 'Lookup').path = 'Lookup';

    podugovorSettings.details
      .find(x => x.name === 'CiljnaGrupa')
      .allFields.find(x => x.name === 'Lookup').path = 'Lookup';

    podugovorSettings.details
      .find(x => x.name === 'SponzorstvoCena')
      .allFields.find(x => x.name === 'Lookup').path = 'Lookup';
  }

  setLookupsPathUgovor(ugovorSettings: any) {
    ugovorSettings.details
      .find(x => x.name === 'CiljnaGrupa')
      .allFields.find(x => x.name === 'Lookup').path = 'Lookup';
  }

  tablePodugovorAction(event: TableActionParams) {
    switch (event.action) {
      case TableActionEnum.Select:
        this.onPodugovorTableSelect(event.document);
        break;
    }
  }

  tableAneksPodugovoraAction(event: TableActionParams) {
    switch (event.action) {
      case TableActionEnum.Select:
        this.onAneksPodugovoraTableSelect(event.document);
        break;
    }
  }

  spotoviValueChanged(event: any) {
    if (event.newValue) {
      switch (event.fieldMap.fieldKey) {
        case 'Lookup':
          if(this.isAneksPodugovora) {
            this.setSpotoviPodugovorList(this.aneksSpotoviList, event);
          }
          else {
            this.setSpotoviPodugovorList(this.spotoviList, event);
          }
          break;
      }
    }
  }

  cenePoOdluciValueChanged(event: any) {
    if(this.isAneksPodugovora) {
      const index = this.getRowIndex(this.aneksCenePoOdluciList, event);
      let val = null;
      if (event.newValue) {
        val = event.newValue;
      }
      switch (event.fieldMap.fieldKey) {
        case 'Emisija':
          this.aneksCenePoOdluciList[index].Emisija = val;
          this.setValidation(
            index,
            this.aneksCenePoOdluciList,
            this.cenePoOdluciSettingsTable,
            this.aneksContentPlaceholder
          );
          break;
        case 'ProgramId':
          this.aneksCenePoOdluciList[index].ProgramId = val;
          this.setValidation(
            index,
            this.aneksCenePoOdluciList,
            this.cenePoOdluciSettingsTable,
            this.aneksContentPlaceholder
          );
          break;
        case 'CenaOff':
          this.aneksCenePoOdluciList[index].CenaOff = val;
          break;
        case 'CenaPrime':
          this.aneksCenePoOdluciList[index].CenaPrime = val;
          break;
      }
    }
    else {
      const index = this.getRowIndex(this.cenePoOdluciList, event);
      let val = null;
      if (event.newValue) {
        val = event.newValue;
      }
      switch (event.fieldMap.fieldKey) {
        case 'Emisija':
          this.cenePoOdluciList[index].Emisija = val;
          this.setValidation(
            index,
            this.cenePoOdluciList,
            this.cenePoOdluciSettingsTable,
            this.contentPlaceholder
          );
          break;
        case 'ProgramId':
          this.cenePoOdluciList[index].ProgramId = val;
          this.setValidation(
            index,
            this.cenePoOdluciList,
            this.cenePoOdluciSettingsTable,
            this.contentPlaceholder
          );
          break;
        case 'CenaOff':
          this.cenePoOdluciList[index].CenaOff = val;
          break;
        case 'CenaPrime':
          this.cenePoOdluciList[index].CenaPrime = val;
          break;
      }
    }
  }

  cppCeneValueChanged(event: any) {
    if(this.isAneksPodugovora) {
      const index = this.getRowIndex(this.aneksCppCeneList, event);
      let val = null;
      if (event.newValue) {
        val = event.newValue;
      }
      switch (event.fieldMap.fieldKey) {
        case 'Emisija':
          this.aneksCppCeneList[index].Emisija = val;
          this.setValidation(
            index,
            this.aneksCppCeneList,
            this.cppCeneSettingsTable,
            this.aneksCppCeneContentPlaceholder
          );
          break;
        case 'ProgramId':
          this.aneksCppCeneList[index].ProgramId = val;
          this.setValidation(
            index,
            this.aneksCppCeneList,
            this.cppCeneSettingsTable,
            this.aneksCppCeneContentPlaceholder
          );
          break;
        case 'CenaOff':
          this.aneksCppCeneList[index].CenaOff = val;
          break;
        case 'CenaPrime':
          this.aneksCppCeneList[index].CenaPrime = val;
          this.setCppMandatoryFields(index);
          break;
        case 'VremeOd':
          this.aneksCppCeneList[index].VremeOd = val;
          this.setCppMandatoryFields(index);
          break;
        case 'VremeDo':
          this.aneksCppCeneList[index].VremeDo = val;
          this.setCppMandatoryFields(index);
          break;
        case 'DatumOd':
          this.aneksCppCeneList[index].DatumOd = val;
          break;
        case 'DatumDo':
          this.aneksCppCeneList[index].DatumDo = val;
          break;
      }
    }
    else {
      const index = this.getRowIndex(this.cppCeneList, event);
      let val = null;
      if (event.newValue) {
        val = event.newValue;
      }
      switch (event.fieldMap.fieldKey) {
        case 'Emisija':
          this.cppCeneList[index].Emisija = val;
          this.setValidation(
            index,
            this.cppCeneList,
            this.cppCeneSettingsTable,
            this.cppCeneContentPlaceholder
          );
          break;
        case 'ProgramId':
          this.cppCeneList[index].ProgramId = val;
          this.setValidation(
            index,
            this.cppCeneList,
            this.cppCeneSettingsTable,
            this.cppCeneContentPlaceholder
          );
          break;
        case 'CenaOff':
          this.cppCeneList[index].CenaOff = val;
          break;
        case 'CenaPrime':
          this.cppCeneList[index].CenaPrime = val;
          this.setCppMandatoryFields(index);
          break;
        case 'VremeOd':
          this.cppCeneList[index].VremeOd = val;
          this.setCppMandatoryFields(index);
          break;
        case 'VremeDo':
          this.cppCeneList[index].VremeDo = val;
          this.setCppMandatoryFields(index);
          break;
        case 'DatumOd':
          this.cppCeneList[index].DatumOd = val;
          break;
        case 'DatumDo':
          this.cppCeneList[index].DatumDo = val;
          break;
      }
    }
  }

  setCppMandatoryFields(index) {
    this.cppCeneSettingsTable.getFieldByName(
      'VremeDo'
    ).mandatory = this.isCppFieldMandatory(index);
    this.cppCeneSettingsTable.getFieldByName(
      'VremeOd'
    ).mandatory = this.isCppFieldMandatory(index);
  }

  isCppFieldMandatory(index) {
    let field;
    if(this.isAneksPodugovora) {
      field = this.aneksCppCeneList[index];
    }
    else {
      field = this.cppCeneList[index];  
    }
    
    return !!field.CenaPrime || !!field.VremeDo || !!field.VremeOd;
  }

  sponzorstvaCenaPodugovorValueChange(event: any) {
    if (event.newValue) {
      switch (event.fieldMap.fieldKey) {
        case 'Lookup':
          if(this.isAneksPodugovora) {
            this.setSponzorstvaCenePodugovorList(
              this.aneksPregledDetaljaSponzorstvaCenaList,
              event
            );
          }
          else {
            this.setSponzorstvaCenePodugovorList(
              this.pregledDetaljaSponzorstvaCenaList,
              event
            );
          }
          break;
      }
    }
  }

  setSponzorstvaCenePodugovorList(collection: any[], event: any) {
    let index;
    if(this.isAneksPodugovora) {
      index = this.getRowIndex(
        this.aneksPregledDetaljaSponzorstvaCenaList,
        event
      );
    }
    else {
      index = this.getRowIndex(
        this.pregledDetaljaSponzorstvaCenaList,
        event
      );
    }
    
    collection[index].Id = event.newValue.Id;
    collection[index].Naziv = event.newValue.Naziv;
    collection[index].VrstaSpotaId = event.newValue.Id;
    collection[index].VrstaSpotaNaziv = event.newValue.Naziv;
  }

  sponzorstvaCenaPodugovorListTableAction(event) {
    switch (event.action) {
      case TableActionEnum.BeforeSave:
        if(this.isAneksPodugovora) {
          if (event.document.Cena <= 0) {
            this.showRowError(
              event,
              'Cena mora biti veća od 0.',
              this.aneksSponzorstvoCeneContentPlaceholder
            );
          }
        }
        else {
          if (event.document.Cena <= 0) {
            this.showRowError(
              event,
              'Cena mora biti veća od 0.',
              this.sponzorstvoCeneContentPlaceholder
            );
          }
        }
        break;
    }
  }

  sponzorstvaEmisijaPodugovorValueChange(event: any) {
    if (event.newValue) {
      switch (event.fieldMap.fieldKey) {
        case 'Emisija':
          if(this.isAneksPodugovora) {
            this.setSponzorstvaEmisijaPodugovorList(
              this.aneksSponzorstvaEmisijaList,
              event
            );
          }
          else {
            this.setSponzorstvaEmisijaPodugovorList(
              this.sponzorstvaEmisijaList,
              event
            );
          }
          break;
      }
    }
  }

  checkEmisijaMediaPlan(
    ugovorId: any,
    kupacId: any,
    podugovorId: any,
    emisijaId: any
  ): Observable<any> {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMP_EMIREZ,
      FormName.PregledEmisija,
      EndpointTypes.SingleEntity,
      `?podugovorId=${podugovorId}&emisijaId=${emisijaId}&klijentId=${kupacId}&ugovorId=${ugovorId}`,
      null,
      null,
      true
    );

    return this._rtsBackendService.fetchMediaPlanSettings(payload);
  }

  sponzorstvaEmisijaPodugovorTableAction(event) {
    if(this.isAneksPodugovora) {
      switch (event.action) {
        case TableActionEnum.Add:
          this.aneksSponzorstvaEmisijeContentPlaceholder.onInlineAddOpenApproved(
            null,
            false
          );
          break;
        case TableActionEnum.AddCancel:
          return this.aneksSponzorstvaEmisijeContentPlaceholder.removeRowApproved(
            event.document
          );
        case TableActionEnum.Edit:
          if (this.isModeEdit && event.document.rbr) {
            this._spinner.show();
            this._subscriptions.push(
              this.checkEmisijaMediaPlan(
                this.order.Id,
                this.aneksPodugovora.Klijent.Id,
                this.aneksPodugovora.Id,
                event.document.EmisijaId
              ).subscribe(
                (data: any) => {
                  if (data.ServiceData === false) {
                    event.document.cantUpdateMessage = null;
                  } else {
                    event.document.cantUpdateMessage =
                      'Emisija se koristi na razervaciji u kombinaciji sa ovim podugovorom.';
                  }
                  this._spinner.hide();
                },
                error => {
                  this._spinner.hide();
                }
              )
            );
          }
          break;
        case TableActionEnum.Delete:
          if (this.aneksPodugovora.Id && this.isModeEdit) {
            this._spinner.show();
            this._subscriptions.push(
              this.checkEmisijaMediaPlan(
                this.order.Id,
                this.aneksPodugovora.Klijent.Id,
                this.aneksPodugovora.Id,
                event.document.EmisijaId
              ).subscribe(
                (data: any) => {
                  if (data.ServiceData === false) {
                    this.aneksSponzorstvaEmisijeContentPlaceholder.removeRowApproved(
                      event.document
                    );
                  } else {
                    this._notificationService.notyError(
                      'Emisija se koristi na razervaciji u kombinaciji sa ovim podugovorom.'
                    );
                  }
  
                  this._spinner.hide();
                },
                error => {
                  this._spinner.hide();
                }
              )
            );
          } else {
            this.aneksSponzorstvaEmisijeContentPlaceholder.removeRowApproved(
              event.document
            );
          }
          break;
      }
    }
    else {
      switch (event.action) {
        case TableActionEnum.Add:
          this.sponzorstvaEmisijaContentPlaceholder.onInlineAddOpenApproved(
            null,
            false
          );
          break;
        case TableActionEnum.AddCancel:
          return this.sponzorstvaEmisijaContentPlaceholder.removeRowApproved(
            event.document
          );
        case TableActionEnum.Edit:
          if (this.isModeEdit && event.document.rbr) {
            this._spinner.show();
            this._subscriptions.push(
              this.checkEmisijaMediaPlan(
                this.order.Id,
                this.podugovor.Klijent.Id,
                this.podugovor.Id,
                event.document.EmisijaId
              ).subscribe(
                (data: any) => {
                  if (data.ServiceData === false) {
                    event.document.cantUpdateMessage = null;
                  } else {
                    event.document.cantUpdateMessage =
                      'Emisija se koristi na razervaciji u kombinaciji sa ovim podugovorom.';
                  }
                  this._spinner.hide();
                },
                error => {
                  this._spinner.hide();
                }
              )
            );
          }
          break;
        case TableActionEnum.Delete:
          if (this.podugovor.Id && this.isModeEdit) {
            this._spinner.show();
            this._subscriptions.push(
              this.checkEmisijaMediaPlan(
                this.order.Id,
                this.podugovor.Klijent.Id,
                this.podugovor.Id,
                event.document.EmisijaId
              ).subscribe(
                (data: any) => {
                  if (data.ServiceData === false) {
                    this.sponzorstvaEmisijaContentPlaceholder.removeRowApproved(
                      event.document
                    );
                  } else {
                    this._notificationService.notyError(
                      'Emisija se koristi na razervaciji u kombinaciji sa ovim podugovorom.'
                    );
                  }
  
                  this._spinner.hide();
                },
                error => {
                  this._spinner.hide();
                }
              )
            );
          } else {
            this.sponzorstvaEmisijaContentPlaceholder.removeRowApproved(
              event.document
            );
          }
          break;
      }
    }
  }

  setSponzorstvaEmisijaPodugovorList(collection: any[], event: any) {
    let index;
    if(this.isAneksPodugovora) {
      index = this.getRowIndex(this.aneksSponzorstvaEmisijaList, event);
    }
    else {
      index = this.getRowIndex(this.sponzorstvaEmisijaList, event);
    }
    collection[index].Id = event.newValue.Id;
    collection[index].Naziv = event.newValue.Naziv;
    collection[index].EmisijaId = event.newValue.Id;
    collection[index].EmisijaNaziv = event.newValue.Naziv;
  }

  ciljneGrupeUgovorValueChange(event: any) {
    if(this._ugovorFormMode === UgovorFormModeEnum.AneksUgovora) {
      if (event.newValue && event.fieldMap.fieldKey === 'Lookup') {
        this.setCiljneGrupeList(this.ciljneGrupeAneksUgovorList, event);
      }
    }
    else {
      if (event.newValue && event.fieldMap.fieldKey === 'Lookup') {
        this.setCiljneGrupeList(this.ciljneGrupeUgovorList, event);
      }
    }
  }

  ciljneGrupeUgovorTableAction(event) {
    if(this._ugovorFormMode === UgovorFormModeEnum.AneksUgovora) {
      switch (event.action) {
        case TableActionEnum.EditCancel:
          if (
            this.ciljneGrupeAneksUgovorList.some(
              a => a['rbr'] === event.document['rbr']
            )
          ) {
            this.copyProperties(
              event.document,
              this.ciljneGrupeAneksUgovorList.filter(
                a => a['rbr'] === event.document['rbr']
              )[0]
            );
          }
          break;
      }
    }
    else {
      switch (event.action) {
        case TableActionEnum.EditCancel:
          if (
            this.ciljneGrupeUgovorList.some(
              a => a['rbr'] === event.document['rbr']
            )
          ) {
            this.copyProperties(
              event.document,
              this.ciljneGrupeUgovorList.filter(
                a => a['rbr'] === event.document['rbr']
              )[0]
            );
          }
          break;
      }
    }
    
  }

  ciljneGrupePodugovorTableAction(event) {
    if(this.isAneksPodugovora) {
      switch (event.action) {
        case TableActionEnum.EditCancel:
          if (
            this.ciljneGrupeAneksPodugovorList.some(
              a => a['rbr'] === event.document['rbr']
            )
          ) {
            this.copyProperties(
              event.document,
              this.ciljneGrupeAneksPodugovorList.filter(
                a => a['rbr'] === event.document['rbr']
              )[0]
            );
          }
          break;
      }
    }
    else {
      switch (event.action) {
        case TableActionEnum.EditCancel:
          if (
            this.ciljneGrupePodugovorList.some(
              a => a['rbr'] === event.document['rbr']
            )
          ) {
            this.copyProperties(
              event.document,
              this.ciljneGrupePodugovorList.filter(
                a => a['rbr'] === event.document['rbr']
              )[0]
            );
          }
          break;
      }
    }
  }

  ciljneGrupePodugovorValueChange(event: any) {
    if(this.isAneksPodugovora) {
      if (event.newValue && event.fieldMap.fieldKey === 'Lookup') {
        this.setCiljneGrupeList(this.ciljneGrupeAneksPodugovorList, event);
      }
    }
    else {
      if (event.newValue && event.fieldMap.fieldKey === 'Lookup') {
        this.setCiljneGrupeList(this.ciljneGrupePodugovorList, event);
      }
    }
  }

  setCiljneGrupeList(collection: any[], event: any) {
    const index = collection.findIndex(b => {
      return b.rbr === event.order.rbr;
    });

    collection[index].CiljnaGrupaId = event.newValue.Id;
    collection[index].Naziv = event.newValue.Naziv;
    collection[index].Opis = event.newValue.Opis;
  }

  toggleKlijentPodugovor(enabled: boolean) {
    const klijent = this.podugovorFieldStructure.fieldList.find(
      f => f.fieldKey === 'Klijent'
    );
    klijent.additable = enabled;
    klijent.editable = enabled;
  }

  toggleBrojPodugovora(enabled: boolean) {
    const brojPodugovora = this.podugovorFieldStructure.fieldList.find(
      f => f.fieldKey === 'BrojPodugovora'
    );
    brojPodugovora.editable = enabled;
    brojPodugovora.additable = enabled;
  }

  onUgovorValueChanged(event) {
    if (event.newValue !== null) {
      switch (event.fieldMap.fieldKey) {
        case 'TipUgovoraId':
          this.setEditableJedinstvenaCena(false, this.ugovorFieldStructure);
          this.toggleNacinObracuna(this.ugovorFieldStructure, true);
          this.tipUgovoraSwitched(
            'MSUGO_UGO_NacinObracunaIdEnum',
            event.newValue
          );
          break;
        case 'NacinObracunaId':
          this.toggleJedinstvenaCenaField(
            event.newValue,
            this.ugovorFieldStructure
          );
          break;
        case 'Klijent':
          this.order.JeAgencija = this.order.Klijent.JeAgencija;
          break;
        case 'ValutaId':
          const isToggle = event.newValue === 1;
          if (isToggle === false) {
            this.clearKurs(this.order);
          }
          this.toggleKursData(this.ugovorFieldStructure, isToggle);
          break;
        case 'BrojUgovora':
          if (this.podugovorList.length) {
            this.podugovorList.forEach(x => {
              x.BrojUgovora = event.newValue;
              x.BrojPodugovora = (<string>x.BrojPodugovora).replace(
                event.oldValue,
                event.newValue
              );
            });
          }
          break;
        case 'ParentJeAktivan': {
          if(this._ugovorZaAneksiranje.ParentJeAktivan === true) {
            this.korekcijeAneksUgovorList = this.parentKorekcije;
            this.ciljneGrupeAneksUgovorList = this.order.CiljneGrupe;
          }
          else {
            this.korekcijeAneksUgovorList = [];
            this.ciljneGrupeAneksUgovorList = [];
          }
        }
        break;
      }
    }
  }

  toggleJedinstvenaCenaLabel(
    fieldStructure: FieldStructure,
    nacinObracunaId: number
  ) {
    if (fieldStructure.getFieldByName('JedinstvenaCena') !== null) {
      switch (nacinObracunaId) {
        case 2:
          fieldStructure.getFieldByName('JedinstvenaCena').label =
            'Jedinstvena cena CPP';
          break;
        case 3:
          fieldStructure.getFieldByName('JedinstvenaCena').label =
            'Cena paketa po sekundi';
          break;
        default:
          fieldStructure.getFieldByName('JedinstvenaCena').label =
            'Jedinstvena cena';
      }
    }
  }

  // Na inilne edit aktivira edit mode
  onDetailsTableEdit(event: any) {
    this.onEditMode();
  }

  onEdit() {
    switch(this._ugovorFormMode) {
      case UgovorFormModeEnum.Ugovor:
        this.deletedKlijentBudzetWhileEditing = [];
        this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Edit);
        break;
      case UgovorFormModeEnum.AneksUgovora:
        this._ugovorZaAneksiranje = { ...this.order };
        this.deletedKlijentBudzetWhileEditing = [];
        this.switchForm(UgovorFormModeEnum.AneksUgovora, FormModeEnum.Edit);
        break;
      case UgovorFormModeEnum.Podugovor:
        this.switchForm(UgovorFormModeEnum.Podugovor, FormModeEnum.Edit);
        this.setKlijentSaUgovoraNotEditable();
        this.toggleNacinObracuna(this.ugovorFieldStructure, true);
        if (this.podugovor.Id) {
          this.toggleKlijentPodugovor(false);
          this.toggleBrojPodugovora(false);
        }
        break;
      case UgovorFormModeEnum.AneksPodugovora:
        this.switchForm(UgovorFormModeEnum.AneksPodugovora, FormModeEnum.Edit);
        this.setKlijentSaUgovoraNotEditable();
        this.toggleNacinObracuna(this.ugovorFieldStructure, true);
        if (this.aneksPodugovora.Id) {
          this.toggleKlijentPodugovor(false);
          this.toggleBrojPodugovora(false);
        }
        break;
    }
  }

  onTableActionAdd() {
    this.fetchEnumsUgovorSingle();
    this.onAddMode();
    this.ugovoreniBudzetRSD = 0;
    this.rezervacijeRSD = 0;
    this.realaizacijeRSD = 0;
    this.order.JeAktivan = true;
  }

  setKlijentSaUgovoraNotEditable() {
    this.podugovorFieldStructure.getFieldByName(
      'KlijentSaUgovora'
    ).editable = false;
    this.podugovorFieldStructure.getFieldByName(
      'KlijentSaUgovora'
    ).additable = false;
  }

  onAddMode() {
    this.order = {};
    this.order.Podugovori = [];
    this.order.Korekcije = [];
    this.order.CiljneGrupe = [];
    this.order.AneksiPodugovora = [];
    this.ugovoreniBudzetRSD = 0;
    this.rezervacijeRSD = 0;
    this.realaizacijeRSD = 0;
    this.fetchSingleEntity();
    this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Add);
  }

  onTableMode() {
    super.onTableMode();
    this.podugovorList = [];
    this.deletedPodugovorList = [];
    this.ucitaniPodugovoriList = [];
    this.aneksiPodugovoraList = [];
    this.aneksiUgovoraList = [];
    this.showPodugovorDetails = false;
    this.setTabUgovor(UgovorTabEnum.Podugovori);
    this.setTabPodugovor(PodugovorTabEnum.Korekcije);
  }

  checkPdv(ugovor) {
    return !!(ugovor.SamoPDV && !ugovor.PDV);
  }

  getPodugovoreBezDefinisanihKlijenata(): boolean {
    const nedefinisani = this.getNedefinisaniKlijentIdsFromPodugovorList();

    if (nedefinisani && nedefinisani.length) {
      const podugovori = this.podugovorList.filter(p =>
        nedefinisani.includes(p.Klijent.Id)
      );

      const nedefinisaniPodugovori = podugovori
        .map(p => p.BrojPodugovora)
        .join(',');

      this._notificationService.notyError(
        `Nije moguće sačuvati ugovor zato što na podugovoru/ima: ${nedefinisaniPodugovori} nisu definisani klijenti u tabu "Klijenti na ugovoru."`
      );

      return true;
    }

    return false;
  }

  getNedefinisaniKlijentIdsFromPodugovorList(): any[] {
    let nedefinisani = [];
    const defKlijenti = this.klijentBudzetList.map(p => p.Klijent.Id);
    //console.log(defKlijenti);
    const podugovorKlijentIds = this.podugovorList.map(p => p.Klijent.Id);
    //console.log(podugovorKlijentIds);
    //const podugovorKlijentIds = this.ucitaniPodugovoriList.map(p => p.Klijent.Id);

    nedefinisani = podugovorKlijentIds.filter(id => !defKlijenti.includes(id));
    //console.log(nedefinisani);

    return this.klijentIds.length ? nedefinisani : this.podugovorList;
    //return this.klijentIds.length ? nedefinisani : this.ucitaniPodugovoriList;
  }

  onSave() {
    if (this._ugovorFormMode === UgovorFormModeEnum.Podugovor) {
      this.setDetailsTableToPodugovor();

      let BRENDIRANA_SPICA = 9;
      let brendiraneSpiceIzSpotova = this.podugovor.Spotovi.filter(s => {
        return s.VrstaSpotaId == BRENDIRANA_SPICA
      })

      let IdsBrendiranihSpicaIzSpotova = brendiraneSpiceIzSpotova.map(s => s.Id);
      IdsBrendiranihSpicaIzSpotova = IdsBrendiranihSpicaIzSpotova.sort(function (a, b) {
        return  a.Id > b.Id ? 1 : -1;
      });

      let brendiraneSpiceSpot = this.podugovor.BrendiraneSpice.map(b => b.Spot);
      let IdsBrendiraneSpice = brendiraneSpiceSpot.map(b => b.Id);

      IdsBrendiraneSpice = IdsBrendiraneSpice.sort(function (a, b) {
        return  a.Id > b.Id ? 1 : -1;
      });

      let IdsBrendiraneSpiceKojeNisuUnesene = IdsBrendiranihSpicaIzSpotova.filter(item => IdsBrendiraneSpice.indexOf(item) == -1);
      let brendiraneSpiceKojeNisuUnesene = [];
      
      for(let i = 0; i < brendiraneSpiceIzSpotova.length; i++) {
        for(let j = 0; j < IdsBrendiraneSpiceKojeNisuUnesene.length; j++) {
          if(brendiraneSpiceIzSpotova[i].Id === IdsBrendiraneSpiceKojeNisuUnesene[j]) {
            brendiraneSpiceKojeNisuUnesene.push(brendiraneSpiceIzSpotova[i]);
          }
        }
      }
      
      let IdsBrendiraneSpiceIzSpotovaKojiSuObrisani = IdsBrendiraneSpice.filter(item => IdsBrendiranihSpicaIzSpotova.indexOf(item) == -1);
      let brendiraneSpiceIzSpotovaKojiSuObrisani = [];

      for(let i = 0; i < brendiraneSpiceSpot.length; i++) {
        for(let j = 0; j < IdsBrendiraneSpiceIzSpotovaKojiSuObrisani.length; j++) {
          if(brendiraneSpiceSpot[i].Id === IdsBrendiraneSpiceIzSpotovaKojiSuObrisani[j]) {
            brendiraneSpiceIzSpotovaKojiSuObrisani.push(brendiraneSpiceSpot[i]);
          }
        }
      }

      let poruka = '';
      if(brendiraneSpiceKojeNisuUnesene.length > 0) {
        if(brendiraneSpiceKojeNisuUnesene.length === 1) {
          poruka = `Podaci za Brendiranu špicu: ${brendiraneSpiceKojeNisuUnesene[0].Naziv} nisu popunjeni.`
        }
        else {
          poruka = `Podaci za Brendirane špice: ${brendiraneSpiceKojeNisuUnesene.map(b => b.Naziv).join(', ')} nisu popunjeni.`
        }

        this._notificationService.notyError(
          poruka
        );

        return;
      }

      if(brendiraneSpiceIzSpotovaKojiSuObrisani.length > 0) {
        if(brendiraneSpiceIzSpotovaKojiSuObrisani.length === 1) {
          poruka = `Brendirana špica: ${brendiraneSpiceIzSpotovaKojiSuObrisani[0].Naziv} ne može biti obrisana jer je unesena na tabu Brendirane špice.`
        }
        else {
          poruka = `Brendirane špice: ${brendiraneSpiceIzSpotovaKojiSuObrisani.map(b => b.Naziv).join(', ')} ne mogu biti obrisane jer su unesene na tabu Brendirane špice.`
        }

        this._notificationService.notyError(
          poruka
        );

        return;
      }

      if(this.podugovor.ValutaId === 1 && this.podugovor.NacinObracunaId === 2) {
        if(!this.podugovor.DatumValute && !this.podugovor.Kurs) {
          this._notificationService.notyError('Ukoliko je valuta EUR potrebno je uneti datum i/ili vrednost kursa.');
          return;
        }
      }

      if (
        this.podugovor.NacinObracunaId === 2 &&
        this.podugovor.TipUgovoraId !== 4 &&
        !this.cppCeneList.length
      ) {
        this._notificationService.notyError(
          `Podugovor sa načinom obračuna 'Cena po CPP-ju' mora sadržati bar jednu CPP cenu.`
        );

        return;
      }

      if (
        this.podugovor.NacinObracunaId === 2 &&
        !this.ciljneGrupePodugovorList.length
      ) {
        this._notificationService.notyError(
          `Podugovor sa načinom obračuna 'Cena po CPP-ju' mora sadržati bar jednu ciljnu grupu.`
        );

        return;
      }

      if (this.podugovor.TipUgovoraId === 4 && !this.cenePoOdluciList.length) {
        this._notificationService.notyError(
          'Potrebno je uneti bar jednu cenu po odluci.'
        );

        return;
      }

      if (this.isNotNumber(this.podugovor.UgovorenaVrednost)) {
        this.notifyError('Ugovorena vrednost mora da sadrži samo brojeve.');

        return;
      }

      if (this.checkPdv(this.podugovor)) {
        this.notifyError(
          'Ukoliko je označeno polje Samo PDV, polje Plaća PDV mora biti označeno.'
        );

        return;
      }

      if (this.podugovor.TipUgovoraId === 7) {
        if (!this.pregledDetaljaSponzorstvaCenaList.length) {
          this.notifyError(
            'Potrebno je dodati barem jednu vrstu spota i cenu za datu vrstu spota u kartici "Sponzorstvo cena".'
          );

          return;
        }

        const vrsteSpotaBezCene = this.getVrsteSpotaBezCene();
        if (vrsteSpotaBezCene.length) {
          const vise = vrsteSpotaBezCene.length > 1;
          this.notifyError(
            `Potrebno je definisati ${vise ? 'cene' : 'cenu'} za ${
              vise ? 'vrste' : 'vrstu'
            } spota ${vrsteSpotaBezCene.join(', ')}.`
          );

          return;
        }
      }

      const nedefinisani = this.getPozicijeZaKojeNisuDefinisaneKorekcije();
      if (nedefinisani.length) {
        this.notifyError(
          `Potrebno je definisati korekciju "Uvećanje za poziciju u bloku" za pozicije: ${nedefinisani.join(
            ', '
          )}`
        );

        return;
      }

      // Ovo je zakomentarisano zbog uvodjenja polja Program i koristi se druga logika validacije
      // const duplePozicije = this.getDuplePozicije();
      // if (duplePozicije.length) {
      //   this.notifyError(
      //     `Korekcija "Uvećanje za poziciju u bloku" sa ${
      //       duplePozicije.length > 1 ? 'pozicijama' : 'pozicijom'
      //     } ${duplePozicije.map(x => `"${x}"`).join(', ')} je uneta više puta.`
      //   );

      //   return;
      // }

      if (this.mode === FormModeEnum.Add) {
        this._modalService.openModal(
          this.getSaveUgovorMssageAndGetSpotoviWarning(),
          response => {
            if (response) {
              this.podugovor.Updated = true;
              this.podugovor.IsUpdated = true;
              this.kreiranjePodugovoraInProgress = false;
              this.addPodugovor();
            }
          }
        );
      } else if (this.mode === FormModeEnum.Edit) {
        this._modalService.openModal(
          this.getSaveUgovorMssageAndGetSpotoviWarning(),
          response => {
            if (response) {
              this.podugovor.Updated = true;
              this.podugovor.IsUpdated = true;
              this.updatePodugovor();
            }
          }
        );
      }

      if (this.deletedSpotoviList && this.deletedSpotoviList.length > 0) {
        this.podugovor.Spotovi = this.podugovor.Spotovi.concat(
          this.deletedSpotoviList
        );
        this.deletedSpotoviList = [];
      }
    }

     else if (this._ugovorFormMode === UgovorFormModeEnum.AneksUgovora) {
      if (this.checkPdv(this._ugovorZaAneksiranje)) {
        this.notifyError(
          'Ukoliko je označeno polje Samo PDV, polje Plaća PDV mora biti označeno.'
        );

        return;
      }
      this._jeAneksUgovora = false;
      this.setDetailsTableToAneksUgovora();
      this.aneksUgovora();
      this.podugovor = {};
      this.aneksPodugovora = {};
      this.aneksiUgovoraList = [];
      this.aneksiPodugovoraList = [];
     }
     else if (this._ugovorFormMode === UgovorFormModeEnum.AneksPodugovora) {
      this.setDetailsTableToAneksPodugovor();

      let BRENDIRANA_SPICA = 9;
      let brendiraneSpiceIzSpotova = this.aneksPodugovora.Spotovi.filter(s => {
        return s.VrstaSpotaId == BRENDIRANA_SPICA
      })

      let IdsBrendiranihSpicaIzSpotova = brendiraneSpiceIzSpotova.map(s => s.Id);
      IdsBrendiranihSpicaIzSpotova = IdsBrendiranihSpicaIzSpotova.sort(function (a, b) {
        return  a.Id > b.Id ? 1 : -1;
      });

      let brendiraneSpiceSpot = this.aneksPodugovora.BrendiraneSpice.map(b => b.Spot);
      let IdsBrendiraneSpice = brendiraneSpiceSpot.map(b => b.Id);

      IdsBrendiraneSpice = IdsBrendiraneSpice.sort(function (a, b) {
        return  a.Id > b.Id ? 1 : -1;
      });

      let IdsBrendiraneSpiceKojeNisuUnesene = IdsBrendiranihSpicaIzSpotova.filter(item => IdsBrendiraneSpice.indexOf(item) == -1);
      let brendiraneSpiceKojeNisuUnesene = [];
      
      for(let i = 0; i < brendiraneSpiceIzSpotova.length; i++) {
        for(let j = 0; j < IdsBrendiraneSpiceKojeNisuUnesene.length; j++) {
          if(brendiraneSpiceIzSpotova[i].Id === IdsBrendiraneSpiceKojeNisuUnesene[j]) {
            brendiraneSpiceKojeNisuUnesene.push(brendiraneSpiceIzSpotova[i]);
          }
        }
      }
      
      let IdsBrendiraneSpiceIzSpotovaKojiSuObrisani = IdsBrendiraneSpice.filter(item => IdsBrendiranihSpicaIzSpotova.indexOf(item) == -1);
      let brendiraneSpiceIzSpotovaKojiSuObrisani = [];

      for(let i = 0; i < brendiraneSpiceSpot.length; i++) {
        for(let j = 0; j < IdsBrendiraneSpiceIzSpotovaKojiSuObrisani.length; j++) {
          if(brendiraneSpiceSpot[i].Id === IdsBrendiraneSpiceIzSpotovaKojiSuObrisani[j]) {
            brendiraneSpiceIzSpotovaKojiSuObrisani.push(brendiraneSpiceSpot[i]);
          }
        }
      }

      let poruka = '';
      if(brendiraneSpiceKojeNisuUnesene.length > 0) {
        if(brendiraneSpiceKojeNisuUnesene.length === 1) {
          poruka = `Podaci za Brendiranu špicu: ${brendiraneSpiceKojeNisuUnesene[0].Naziv} nisu popunjeni.`
        }
        else {
          poruka = `Podaci za Brendirane špice: ${brendiraneSpiceKojeNisuUnesene.map(b => b.Naziv).join(', ')} nisu popunjeni.`
        }

        this._notificationService.notyError(
          poruka
        );

        return;
      }

      if(brendiraneSpiceIzSpotovaKojiSuObrisani.length > 0) {
        if(brendiraneSpiceIzSpotovaKojiSuObrisani.length === 1) {
          poruka = `Brendirana špica: ${brendiraneSpiceIzSpotovaKojiSuObrisani[0].Naziv} ne može biti obrisana jer je unesena na tabu Brendirane špice.`
        }
        else {
          poruka = `Brendirane špice: ${brendiraneSpiceIzSpotovaKojiSuObrisani.map(b => b.Naziv).join(', ')} ne mogu biti obrisane jer su unesene na tabu Brendirane špice.`
        }

        this._notificationService.notyError(
          poruka
        );

        return;
      }

      if(this.aneksPodugovora.ValutaId === 1 && this.aneksPodugovora.NacinObracunaId === 2) {
        if(!this.aneksPodugovora.DatumValute && !this.aneksPodugovora.Kurs) {
          this._notificationService.notyError('Ukoliko je valuta EUR potrebno je uneti datum i/ili vrednost kursa.');
          return;
        }
      }

      if (
        this.aneksPodugovora.NacinObracunaId === 2 &&
        this.aneksPodugovora.TipUgovoraId !== 4 &&
        !this.aneksPodugovora.CeneCPP.length
      ) {
        this._notificationService.notyError(
          `Podugovor sa načinom obračuna 'Cena po CPP-ju' mora sadržati bar jednu CPP cenu.`
        );

        return;
      }

      if (
        this.aneksPodugovora.NacinObracunaId === 2 &&
        !this.aneksPodugovora.CiljneGrupe.length
      ) {
        this._notificationService.notyError(
          `Podugovor sa načinom obračuna 'Cena po CPP-ju' mora sadržati bar jednu ciljnu grupu.`
        );

        return;
      }

      if (this.aneksPodugovora.TipUgovoraId === 4 && !this.aneksPodugovora.CenePoOdlukama.length) {
        this._notificationService.notyError(
          'Potrebno je uneti bar jednu cenu po odluci.'
        );

        return;
      }

      if (this.isNotNumber(this.aneksPodugovora.UgovorenaVrednost)) {
        this.notifyError('Ugovorena vrednost mora da sadrži samo brojeve.');

        return;
      }

      if (this.checkPdv(this.aneksPodugovora)) {
        this.notifyError(
          'Ukoliko je označeno polje Samo PDV, polje Plaća PDV mora biti označeno.'
        );

        return;
      }

      if (this.aneksPodugovora.TipUgovoraId === 7) {
        if (!this.aneksPregledDetaljaSponzorstvaCenaList.length) {
          this.notifyError(
            'Potrebno je dodati barem jednu vrstu spota i cenu za datu vrstu spota u kartici "Sponzorstvo cena".'
          );

          return;
        }

        const vrsteSpotaBezCene = this.getAneksVrsteSpotaBezCene();
        if (vrsteSpotaBezCene.length) {
          const vise = vrsteSpotaBezCene.length > 1;
          this.notifyError(
            `Potrebno je definisati ${vise ? 'cene' : 'cenu'} za ${
              vise ? 'vrste' : 'vrstu'
            } spota ${vrsteSpotaBezCene.join(', ')}.`
          );

          return;
        }
      }

      const nedefinisani = this.getAneksPozicijeZaKojeNisuDefinisaneKorekcije();
      if (nedefinisani.length) {
        this.notifyError(
          `Potrebno je definisati korekciju "Uvećanje za poziciju u bloku" za pozicije: ${nedefinisani.join(
            ', '
          )}`
        );

        return;
      }

      if (this.deletedAneksSpotoviList && this.deletedAneksSpotoviList.length > 0) {
        this.aneksPodugovora.Spotovi = this.aneksPodugovora.Spotovi.concat(
          this.deletedAneksSpotoviList
        );
        this.deletedAneksSpotoviList = [];
      }

      if (this.mode === FormModeEnum.Edit) {
        this._modalService.openModal(
          this.getSaveUgovorMssageAndGetSpotoviWarning(),
          response => {
            if (response) {
              if(this.aneksPodugovora.IsNew) {
                if(this.aneksiPodugovoraList.length === 0) {
                  this.aneksiPodugovoraList.push(this.aneksPodugovora);
                }
                else {
                  for(let i = 0; i < this.aneksiPodugovoraList.length; i++) {
                    if(this.aneksiPodugovoraList[i].Id === this.aneksPodugovora.Id &&
                      this.aneksiPodugovoraList[i].BrojPodugovora === this.aneksPodugovora.BrojPodugovora) {
                        break;
                      }
                      else {
                        this.aneksiPodugovoraList.push(this.aneksPodugovora);
                      }
                  }
                }
                this.isAneksPodugovora = false;
                this.podugovor = this.parentPodugovor;
                this.aneksPodugovora = {};
                this.setSumUkupnoUgovoreno();
              }
              else {
                let index = 0;
                for(let i = 0; i < this.aneksiPodugovoraList.length; i++) {
                  if(this.aneksiPodugovoraList[i].Id === this.aneksPodugovora.Id &&
                    this.aneksiPodugovoraList[i].BrojPodugovora === this.aneksPodugovora.BrojPodugovora) {
                      index = i;
                      break;
                    }
                    else {
                      index = -1;
                    }
                }

                if(index !== -1) {
                  this.aneksiPodugovoraList[index] = this.aneksPodugovora;
                }
              }
              this.aneksiranjeInProgress = false;
              this.isAneksPodugovora = false;
              this.podugovor = this.parentPodugovor;
              this.aneksPodugovora = {};
              this.setSumUkupnoUgovoreno();
              this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Edit);
            }
            else {
              this.aneksiranjeInProgress = true;
            }
          }
        );
      }

    } else {
      // if (this.checkIfDeletedKlijentHasAssignedPodugovor()) {
      //   return;
      // }
      if(this.podugovorList.length === 0 && this.aneksiPodugovoraList.length === 0) {
        this._notificationService.notyError(
          'Ugovor mora sadržati bar jedan podugovor ili aneks podugovora.'
        );
  
        return;
      }

      const nevalidniSponz = this.proveriCeneZaSponzorstvoZaSvePodugovore();
      if (nevalidniSponz.length) {
        this.notifyError(
          `Podugovor ${nevalidniSponz.join(
            ', '
          )} nema definisane cene za sve vrste spotova koje su za njega vezane.`
        );
        
        return;
      }

      const nevalidniSponzNula = this.proveriNuleZaSveSponzorstvoCene();
      if (nevalidniSponzNula.length) {
        this.notifyError(
          `Kod podugovora ${nevalidniSponzNula.join(
            ', '
          )} sve cene za sponzorstvo moraju biti veće od 0.`
        );

        return;
      }

      if (this.getPodugovoreBezDefinisanihKlijenata()) {
        return;
      }

      if (this.checkPdv(this.order)) {
        this.notifyError(
          'Ukoliko je označeno polje Samo PDV, polje Plaća PDV mora biti označeno.'
        );

        return;
      }

      if(this.order.Id) {
        this.getPraviBrojeviUgovoraDuplikati();
      }
      else {
        this.setDetailsTableToOrder();
        super.onSave();
        this.allSelected = false;
      }
    }
  }

  private getVrsteSpotaBezCene() {
    const vrsteSpota = this._utilService.distinct(
      this.spotoviList.map(x => x.VrstaSpotaId)
    );
    const vrsteSpotaSaCenom = this._utilService.distinct(
      this.pregledDetaljaSponzorstvaCenaList.map(x => x.VrstaSpotaId)
    );
    const vrsteSpotaBezCene = [];
    vrsteSpota.forEach(x => {
      if (!vrsteSpotaSaCenom.includes(x)) {
        vrsteSpotaBezCene.push(
          this._enumService.vrsteSpota.find(s => s.Id === x).Naziv
        );
      }
    });

    return vrsteSpotaBezCene;
  }

  private getAneksVrsteSpotaBezCene() {
    const vrsteSpota = this._utilService.distinct(
      this.aneksSpotoviList.map(x => x.VrstaSpotaId)
    );
    const vrsteSpotaSaCenom = this._utilService.distinct(
      this.aneksPregledDetaljaSponzorstvaCenaList.map(x => x.VrstaSpotaId)
    );
    const vrsteSpotaBezCene = [];
    vrsteSpota.forEach(x => {
      if (!vrsteSpotaSaCenom.includes(x)) {
        vrsteSpotaBezCene.push(
          this._enumService.vrsteSpota.find(s => s.Id === x).Naziv
        );
      }
    });

    return vrsteSpotaBezCene;
  }

  // zbog starih podugovora
  private proveriCeneZaSponzorstvoZaSvePodugovore(): string[] {
    const podugovoriSaNedefinisanomCenomZaVrstuSpota = [];
    this.ucitaniPodugovoriList
      .filter(x => x.TipUgovoraId === 7)
      .forEach(p => {
        const vrsteSpota = this._utilService.distinct(
          p.Spotovi.map(x => x.VrstaSpotaId)
        );

        const vrsteSpotaSaCenom = this._utilService.distinct(
          p.SponzorstvoCene.map(x => x.VrstaSpotaId)
        );

        vrsteSpota.forEach(x => {
          if (!vrsteSpotaSaCenom.includes(x)) {
            podugovoriSaNedefinisanomCenomZaVrstuSpota.push(p.BrojPodugovora);
          }
        });
      });

    return podugovoriSaNedefinisanomCenomZaVrstuSpota;
  }

  // zbog starih podugovora
  private proveriNuleZaSveSponzorstvoCene(): string[] {
    const podugovoriSaCenomNula = [];

    this.ucitaniPodugovoriList
      .filter(x => x.TipUgovoraId === 7)
      .forEach(p => {
        if (p.SponzorstvoCene.some(x => x.Cena <= 0)) {
          podugovoriSaCenomNula.push(p.BrojPodugovora);
        }
      });

    return podugovoriSaCenomNula;
  }
  
  private getDuplePozicije(): string[] {
    const dict = {};

    if(this.isAneksPodugovora) {
      this.korekcijeAneksPodugovorList
      .filter(x => x.TipKorekcijeSifra === 'U_PB')
      .forEach(x => {
        if (x.Pozicija) {
          if (dict[x.Pozicija]) {
            dict[x.Pozicija]++;
          } else {
            dict[x.Pozicija] = 1;
          }
        }
      });

      const duple: string[] = [];

      for (const key in dict) {
        if (dict[key] > 1) {
          duple.push(key);
        }
      }

      return duple;
    }
    else {
      this.korekcijePodugovorList
      .filter(x => x.TipKorekcijeSifra === 'U_PB')
      .forEach(x => {
        if (x.Pozicija) {
          if (dict[x.Pozicija]) {
            dict[x.Pozicija]++;
          } else {
            dict[x.Pozicija] = 1;
          }
        }
      });

      const duple: string[] = [];

      for (const key in dict) {
        if (dict[key] > 1) {
          duple.push(key);
        }
      }

      return duple;
    }
  }

  getSaveUgovorMssageAndGetSpotoviWarning() {
    if(this.isAneksPodugovora) {
      if (this.aneksSpotoviList.length < 1) {
        return `Podugovor ${this.aneksPodugovora.BrojPodugovora} nema definisane spotove, da li ste sigurni da želite da nastavite?`;
      }
  
      return `Da li ste sigurni da želite snimite podugovor pod brojem ${this.aneksPodugovora.BrojPodugovora}?`;
    }
    else {
      if (this.spotoviList.length < 1) {
        return `Podugovor ${this.podugovor.BrojPodugovora} nema definisane spotove, da li ste sigurni da želite da nastavite?`;
      }
  
      return `Da li ste sigurni da želite snimite podugovor pod brojem ${this.podugovor.BrojPodugovora}?`;
    }
  }

  getPraviBrojeviUgovoraDuplikati() {
    let ugovoriSaIstimPravimBrojem = [];

    this._rtsBackendService.fetchSettings(
      FormCode.MSUGO_PBUG,
      FormName.PregledUgovora,
      EndpointTypes.AllEntities,
      `?ugovorId=${this.order.Id}&praviBrojUgovora=${this.order.PraviBrojUgovora}`,
      null,
      true).subscribe(data => {
        ugovoriSaIstimPravimBrojem = data.ServiceData;
        if(ugovoriSaIstimPravimBrojem.length) {
          let poruka = '';

          if(ugovoriSaIstimPravimBrojem.length === 1) {
            poruka = `Ugovor: ${ugovoriSaIstimPravimBrojem} već ima unesen pravi broj ugovora: ${this.order.PraviBrojUgovora}, da li želite da nastavite sa snimanjem ugovora?`;
          }
          else if(ugovoriSaIstimPravimBrojem.length > 1) {
            poruka = `Ugovori: ${ugovoriSaIstimPravimBrojem.join(', ')} već imaju unesen pravi broj ugovora: ${this.order.PraviBrojUgovora}, da li želite da nastavite sa snimanjem ugovora?`
          }
  
          this._modalService.openModal(
            poruka,
            response => {
              if (response) {
                this.setDetailsTableToOrder();
                super.onSave();
                this.allSelected = false;
              }
              else {
                return;
              }
            }
          );
        }
        else {
          this.setDetailsTableToOrder();
          super.onSave();
          this.allSelected = false;
        }
      });
  }

  getPozicijeZaKojeNisuDefinisaneKorekcije(): string[] {
    const zeljenePozicije = this.spotoviList
      .filter(x => x.ZeljenaPozicija)
      .map(x => x.ZeljenaPozicija);

    const pozicije = this.korekcijePodugovorList
      .filter(x => x.TipKorekcijeSifra === 'U_PB')
      .map(x => x.Pozicija);

    const nedefinisani = zeljenePozicije.filter(
      x => pozicije.includes(x) === false
    );

    return nedefinisani;
  }

  getAneksPozicijeZaKojeNisuDefinisaneKorekcije(): string[] {
    const zeljenePozicije = this.aneksSpotoviList
      .filter(x => x.ZeljenaPozicija)
      .map(x => x.ZeljenaPozicija);

    const pozicije = this.korekcijeAneksPodugovorList
      .filter(x => x.TipKorekcijeSifra === 'U_PB')
      .map(x => x.Pozicija);

    const nedefinisani = zeljenePozicije.filter(
      x => pozicije.includes(x) === false
    );

    return nedefinisani;
  }

  returnToMode() {
    switch (this._returnToMode) {
      case FormModeEnum.Aneks:
        this.switchForm(UgovorFormModeEnum.AneksUgovora, FormModeEnum.Edit);
        break;
      case FormModeEnum.Add:
      case FormModeEnum.Edit:
      case FormModeEnum.View:
        this.switchForm(UgovorFormModeEnum.Ugovor, this._returnToMode);
        break;
      default:
        break;
    }
  }

  setDetailsTableToAneksUgovora() {
    this._ugovorZaAneksiranje.Korekcije = [...this.korekcijeAneksUgovorList]
    this._ugovorZaAneksiranje.CiljneGrupe = [...this.ciljneGrupeAneksUgovorList];
    this._ugovorZaAneksiranje.KlijentBudzet = [...this.aneksKlijentBudzetList];
    this._ugovorZaAneksiranje.PodugovoriZaAneksiranje = [...this._podugovoriZaAneksiranje];
  }

  setDetailsTableToOrder() {
    this.order.Korekcije = [...this.korekcijeUgovorList];
    this.order.CiljneGrupe = [...this.ciljneGrupeUgovorList];
    this.order.Podugovori = [...this.podugovorList];
    this.order.AneksiraniPodugovori = [...this.aneksiPodugovoraList];
    this.order.KlijentBudzet = [...this.klijentBudzetList];
    this.order.PodugovoriZaAneksiranje = [...this._podugovoriZaAneksiranje];
    this.order.PodugovoriZaBrisanje = [...this.deletedPodugovorList];
  }

  setDetailsTableToPodugovor() {
    this.podugovor.Korekcije = this.korekcijePodugovorList;
    this.podugovor.CiljneGrupe = this.ciljneGrupePodugovorList;
    this.podugovor.Spotovi = this.spotoviList;
    this.podugovor.Oglasivaci = this.oglasivaciList;
    this.podugovor.CenePoOdlukama = this.cenePoOdluciList;
    this.podugovor.CeneCPP = this.cppCeneList;
    this.podugovor.SponzorstvoCene = this.pregledDetaljaSponzorstvaCenaList;
    this.podugovor.SponzorstvoEmisija = this.sponzorstvaEmisijaList;
    this.podugovor.BrendiraneSpice = this.brendiraneSpiceList;
    // this.podugovor.IsUpdated = true;
  }

  setDetailsTableToAneksPodugovor() {
    this.aneksPodugovora.Korekcije = this.korekcijeAneksPodugovorList;
    this.aneksPodugovora.CiljneGrupe = this.ciljneGrupeAneksPodugovorList;
    this.aneksPodugovora.Spotovi = this.aneksSpotoviList;
    this.aneksPodugovora.Oglasivaci = this.aneksOglasivaciList;
    this.aneksPodugovora.CenePoOdlukama = this.aneksCenePoOdluciList;
    this.aneksPodugovora.CeneCPP = this.aneksCppCeneList;
    this.aneksPodugovora.SponzorstvoCene = this.aneksPregledDetaljaSponzorstvaCenaList;
    this.aneksPodugovora.SponzorstvoEmisija = this.aneksSponzorstvaEmisijaList;
    this.aneksPodugovora.BrendiraneSpice = this.aneksBrendiraneSpiceList;
    this.aneksPodugovora.IsUpdated = true;
  }

  switchForm(form: UgovorFormModeEnum, mode: FormModeEnum) {
    window.scrollTo(0, 0);
    this._prosliMode = this.mode;
    this.mode = mode;
    this._ugovorFormMode = form;
    this.showPodugovorDetails =
      form === UgovorFormModeEnum.Podugovor ||
      form === UgovorFormModeEnum.AneksPodugovora;
    this.setToolbar();
    if (!this.showPodugovorDetails) {
      this.onViewPodugovor(null);
    }

    if (form === UgovorFormModeEnum.Ugovor && mode === FormModeEnum.Table) {
      this.podugovorFieldStructure = null;
    }
  }

  setTabUgovor(tab: UgovorTabEnum) {
    this.activeTabUgovor = tab;
  }

  setTabPodugovor(tab: PodugovorTabEnum) {
    this.activeTabPodugovor = tab;

    if (this.activeTabPodugovor === PodugovorTabEnum.BrendiraneSpice) {
      this.setBrendiranaSpicaInitFilters();
    }
    else if(this.activeTabPodugovor === PodugovorTabEnum.BrendiraneSpiceAneks) {
      this.setBrendiranaSpicaInitFilters();
    }
  }

  setTabAneksiUgovora(tab: UgovorTabEnum) {
    this.activeTabUgovor = tab;
  }

  setTabAneksiPodugovora(tab: UgovorTabEnum) {
    this.activeTabUgovor = tab;

    if (this.activeTabPodugovor === PodugovorTabEnum.BrendiraneSpice) {
      this.setBrendiranaSpicaInitFilters();
    }
    else if (this.activeTabPodugovor === PodugovorTabEnum.BrendiraneSpiceAneks) {
      this.setBrendiranaSpicaInitFilters();
    }
  }

  setBrendiranaSpicaInitFilters() {
    const filters = [
      {
        name: 'spotIds',
        value: this.spotIds,
      },
    ];

    this.brendiraneSpiceSettingsTable.getFieldByName(
      'Spot'
    ).lookupInitFilter = filters;
  }

  resetAddedValuesOnCancelOrOnClose() {
    if(this.isAneksPodugovora && this.mode === this.FormModeEnum.Edit) {
      this.setAneksKorekcijePodugovorList();
      this.setAneksCiljneGrupePodugovorList();
      this.setAneksOglasivaciList();
      this.setAneksSpotoviList();
      this.setAneksBrendiraneSpiceList();
      this.setAneksCppCeneList();
      this.setAneksCenePoOdluciList();
      this.setAneksSponzorstvoEmisija();
      this.setAneksSponzorstvaCena();
      this.setAneksSponzorstvoValuta();
    }
    else if(this.isAneksPodugovora && this.mode === this.FormModeEnum.Edit) {
      this.setAneksKorekcijePodugovorList();
      this.setAneksCiljneGrupePodugovorList();
      this.setAneksOglasivaciList();
      this.setAneksSpotoviList();
      this.setAneksBrendiraneSpiceList();
      this.setAneksCppCeneList();
      this.setAneksCenePoOdluciList();
      this.setAneksSponzorstvoEmisija();
      this.setAneksSponzorstvaCena();
      this.setAneksSponzorstvoValuta();
    }
    else {
      this.setKorekcijePodugovorList();
      this.setCiljneGrupePodugovorList();
      this.setOglasivaciList();
      this.setSpotoviList();
      this.setBrendiraneSpiceList();
      this.setCppCeneList();
      this.setCenePoOdluciList();
      this.setSponzorstvoEmisija();
      this.setSponzorstvaCena();
      this.setSponzorstvoValuta();
    }
  }

  onCancel() {
    switch(this._ugovorFormMode) {
      case UgovorFormModeEnum.Ugovor:
        this.syncListsUgovor();
        if (this.ugovorMode === FormModeEnum.Edit) {
          this.copyProperties(this._ugovorZaAneksiranje, this.order);
          if (
            this.order.Podugovori &&
            this.order.Podugovori.some(
              a => a.Id === this.aneksPodugovora.Id
            )
          ) {
            this.copyProperties(
              this.aneksPodugovora,
              this.order.AneksiraniPodugovori.filter(
                a => a.Id === this.aneksPodugovora.Id
              )[0]
            );
          }
          this.isUgovorMode = true;
          this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.View);
        } else if (this.mode === FormModeEnum.Add) {
          this.onClose();
        }
        this.deletedPodugovorList = [];
        break;
      case UgovorFormModeEnum.AneksUgovora:
        this.syncListsUgovor();
        if (this.mode === FormModeEnum.Edit && this._ugovorZaAneksiranje.IsNew === undefined) {
          this.copyProperties(this._ugovorZaAneksiranje, this.order);
          if (
            this.order.Podugovori &&
            this.order.Podugovori.some(
              a => a.Id === this.aneksPodugovora.Id
            )
          ) {
            this.copyProperties(
              this.aneksPodugovora,
              this.order.AneksiraniPodugovori.filter(
                a => a.Id === this.aneksPodugovora.Id
              )[0]
            );
          }
          this.switchForm(UgovorFormModeEnum.AneksUgovora, FormModeEnum.View);
        } else {
          this.ugovorFieldStructure.getFieldByName('BrojUgovora').label = "Broj Ugovora";
          this.ugovorFieldStructure.getFieldByName('PraviBrojUgovora').label = "Pravi broj ugovora";
          this.korekcijeSettingsTable.listAdditable = true;
          this.ciljneGrupeUgovorSettingsTable.listAdditable = true;
          this._jeAneksUgovora = false;
          this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.View);
        }
        break;
      case UgovorFormModeEnum.Podugovor:
        if (this.mode === FormModeEnum.Add) {
          if(this.ugovorMode === FormModeEnum.Add) {
            this.isUgovorMode = true;
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Add);  
          }
          else {
            this.isUgovorMode = true;
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Edit);
          }
        }
        else if (this.mode === FormModeEnum.Edit) {
          this.resetAddedValuesOnCancelOrOnClose();
          this.switchForm(UgovorFormModeEnum.Podugovor, FormModeEnum.View);
        }
        else if (this.mode === FormModeEnum.View) {
          if(this.ugovorMode === FormModeEnum.Add) {
            this.isUgovorMode = true;
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Add);  
          }
          else if(this.ugovorMode === FormModeEnum.View) {
            this.isUgovorMode = true;
            this.resetAddedValuesOnCancelOrOnClose();
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.View);
          }
          else {
            this.isUgovorMode = true;
            this.resetAddedValuesOnCancelOrOnClose();
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Edit);
          }
        }
        this.deletedSpotoviList = [];
        break;
      case UgovorFormModeEnum.AneksPodugovora:
        if(this.aneksiranjeInProgress) {
          this.aneksPodugovora.JeAneks = false;
        }
        if(this.activeTabUgovor === UgovorTabEnum.AneksiPodugovora) {
          if (this.mode === FormModeEnum.Edit) {
            this.aneksiranjeInProgress = false;
            
            this.resetAddedValuesOnCancelOrOnClose();
            this.switchForm(UgovorFormModeEnum.AneksPodugovora, FormModeEnum.View);
            this.setTabPodugovor(PodugovorTabEnum.KorekcijeAneks);
          }
        }
        else {
          if (this.mode === FormModeEnum.Edit) {
            this.aneksiranjeInProgress = false;
            this.isAneksPodugovora = false;
            this.resetAddedValuesOnCancelOrOnClose();
            this.switchForm(UgovorFormModeEnum.Podugovor, FormModeEnum.View);
            this.setTabPodugovor(PodugovorTabEnum.Korekcije);
          }
        }
        this.deletedAneksSpotoviList = [];
        break;
    }
  }

  syncListsUgovor() {
    if (this.order.Korekcije) {
      this.korekcijeUgovorList = this._utilService.deepCopy(
        this.order.Korekcije
      );
    }

    if (this.order.CiljneGrupe) {
      this.ciljneGrupeUgovorList = [...this.order.CiljneGrupe];
    }

    if (this.order.KlijentBudzet) {
      this.klijentBudzetList = [...this.order.KlijentBudzet];
    }

    this.setRbr(this.korekcijeUgovorList);
    this.setRbr(this.ciljneGrupeUgovorList);
    this.setRbr(this.klijentBudzetList);
  }

  onClose() {
    switch(this._ugovorFormMode) {
      case UgovorFormModeEnum.Ugovor:
        this.isUgovorMode = true;
        this._ugovorFormMode = UgovorFormModeEnum.Ugovor;
        this.allSelected = false;
        this.isAneksPodugovora = false;
        super.onClose();
        break;
      case UgovorFormModeEnum.AneksUgovora:
        this._ugovorFormMode = UgovorFormModeEnum.Ugovor;
        this.isUgovorMode = true;
        this.korekcijeSettingsTable.listAdditable = true;
        this.ciljneGrupeUgovorSettingsTable.listAdditable = true;
        this.allSelected = false;
        this._jeAneksUgovora = false;
        this.isAneksPodugovora = false;
        super.onClose();
        break;
      case UgovorFormModeEnum.Podugovor:
        if (this.mode === FormModeEnum.Add) {
          if(this.order.IsNew) {
            this.isUgovorMode = true;
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Add);  
          }
          else {
            this.isUgovorMode = true;
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Edit);
          }
        }
        else if (this.mode === FormModeEnum.View) {
          if(this.ugovorMode === FormModeEnum.View) {
            this.isUgovorMode = true;
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.View);
          }
          else if(this.ugovorMode === FormModeEnum.Add) {
            this.isUgovorMode = true;
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Add);  
          }
          else {
            this.isUgovorMode = true;
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Edit);
          }
        }
        else if (this.mode === FormModeEnum.Edit) {
          this.resetAddedValuesOnCancelOrOnClose();
          this.switchForm(UgovorFormModeEnum.Podugovor, FormModeEnum.View);
        }
        break;
      case UgovorFormModeEnum.AneksPodugovora:
        if(this.aneksiranjeInProgress) {
          this.aneksPodugovora.JeAneks = false;
        }
        if (this.mode === FormModeEnum.View) {
          if(this.ugovorMode === FormModeEnum.View) {
            this.podugovor = null;
            this.aneksiranjeInProgress = false;
            this.aneksPodugovora = {};
            this.isUgovorMode = true;
            this.isAneksPodugovora = false;
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.View);
            this.podugovor = this.parentPodugovor;
          }
          else {
            this.podugovor = null;
            this.aneksiranjeInProgress = false;
            this.aneksPodugovora = {};
            this.isUgovorMode = true;
            this.isAneksPodugovora = false;
            this.switchForm(UgovorFormModeEnum.Ugovor, FormModeEnum.Edit);
            this.podugovor = this.parentPodugovor;
          }
        }
        else if (this.mode === FormModeEnum.Edit) {
          if(this._prosliMode === FormModeEnum.View && this.aneksiranjeInProgress === true) {
            this.aneksiranjeInProgress = false;
            this.resetAddedValuesOnCancelOrOnClose();
            this.switchForm(UgovorFormModeEnum.Podugovor, FormModeEnum.View);
          }
          else {
            this.aneksiranjeInProgress = false;
            this.resetAddedValuesOnCancelOrOnClose();
            this.switchForm(UgovorFormModeEnum.AneksPodugovora, FormModeEnum.View);
          }
        }
        break;
    }
  }

  private setToolbar() {
    this.setToolbarOptions({
      toolbarVisible: false,
    });
    switch (this.mode) {
      case FormModeEnum.View:
        this.setViewToolbar();
        break;
      case FormModeEnum.Add:
        this.setAddToolbar();
        break;
      case FormModeEnum.Edit:
        this.setEditToolbar();
        break;
    }
  }

  private setEditToolbar() {
    switch (this._ugovorFormMode) {
      case UgovorFormModeEnum.Podugovor:
        this.setInProgress(FormModeEnum.Edit);
        this.name = 'Izmena podugovora';
        this.setToolbarOptions({
          items: [
            ToolbarItem.ItemSave(true, true, PODUGOVOR_SACUVAJ),
            ToolbarItem.ItemCancel(),
          ],
        });
        this.podugovorFieldStructure.getFieldByName('ParentNaziv').visible = false;
        this.podugovorFieldStructure.getFieldByName('StatusUgovoraId').editable = true;
        this.podugovorFieldStructure.getFieldByName('StatusUgovoraId').additable = true;
        this.podugovorFieldStructure.getFieldByName('Naziv').editable = true;
        this.podugovorFieldStructure.getFieldByName('TipUgovoraId').additable = false;
        this.podugovorFieldStructure.getFieldByName('TipUgovoraId').editable = false;
        this.toggleSpotLookup(false);
        break;
      case UgovorFormModeEnum.Ugovor:
        this.ugovorMode = FormModeEnum.Edit;
        this.setInProgress(FormModeEnum.Edit);
        this.name = 'Izmena ugovora';
        this.setToolbarOptions({
          items: [
            ToolbarItem.ItemDodajPodugovor(),
            ToolbarItem.ItemSave(),
            ToolbarItem.ItemCancel(true, true, UGOVOR_OTKAZI),
          ],
        });
        this.ugovorFieldStructure.getFieldByName('BrojAneksiranogUgovora').visible = false;
        this.ugovorFieldStructure.getFieldByName('ParentBrojUgovora').editable = false;
        this.ugovorFieldStructure.getFieldByName('ParentPraviBrojUgovora').editable = false;
        this.ugovorFieldStructure.getFieldByName('BrojUgovora').editable = false;
        if(this.order.JeAneks) {
          this.ugovorFieldStructure.getFieldByName('StatusUgovoraId').editable = false;
          this.ugovorFieldStructure.getFieldByName('StatusUgovoraId').additable = false;
          this.ugovorFieldStructure.getFieldByName('TipUgovoraId').additable = false;
          this.ugovorFieldStructure.getFieldByName('TipUgovoraId').editable = false;  
          this.ugovorFieldStructure.getFieldByName('NacinObracunaId').editable = false;
          this.ugovorFieldStructure.getFieldByName('NacinObracunaId').additable = false;
        }
        else {
          this.ugovorFieldStructure.getFieldByName('StatusUgovoraId').editable = true;
          this.ugovorFieldStructure.getFieldByName('StatusUgovoraId').additable = true;
          this.ugovorFieldStructure.getFieldByName('TipUgovoraId').additable = true;
          this.ugovorFieldStructure.getFieldByName('TipUgovoraId').editable = true;
          this.ugovorFieldStructure.getFieldByName('NacinObracunaId').editable = true;
          this.ugovorFieldStructure.getFieldByName('NacinObracunaId').additable = true;
        }
        break;
      case UgovorFormModeEnum.AneksUgovora:
        this.setInProgress(FormModeEnum.Aneks);
        if(this._ugovorZaAneksiranje.IsNew === true) {
          this.name = 'Aneksiranje ugovora';
        }
        else {
          this.name = 'Izmena aneksa ugovora';
        }
        this.setToolbarOptions({
          items: [
            //ToolbarItem.ItemDodajPodugovor(),
            ToolbarItem.ItemSave(),
            ToolbarItem.ItemCancel(),
          ],
        });
        this.ugovorFieldStructure.getFieldByName('BrojUgovora').editable = false;
        this.ugovorFieldStructure.getFieldByName('StatusUgovoraId').editable = false;
        this.ugovorFieldStructure.getFieldByName('StatusUgovoraId').additable = false;
        this.ugovorFieldStructure.getFieldByName('TipUgovoraId').additable = false;
        this.ugovorFieldStructure.getFieldByName('TipUgovoraId').editable = false;
        break;
      case UgovorFormModeEnum.AneksPodugovora:
        this._prosliMode = FormModeEnum.View;
        this.setInProgress(FormModeEnum.Aneks);
        if(this.aneksiranjeInProgress) {
          this.name = 'Aneksiranje podugovora';
        }
        else {
          this.name = 'Izmena aneksa podugovora';
        }
        this.setToolbarOptions({
          items: [
            //ToolbarItem.ItemDodajPodugovor(),
            ToolbarItem.ItemSave(),
            ToolbarItem.ItemCancel(),
          ],
        });
        this.podugovorFieldStructure.getFieldByName('ParentNaziv').visible = true;
        this.podugovorFieldStructure.getFieldByName('ParentNaziv').editable = false;
        this.podugovorFieldStructure.getFieldByName('ParentBrojPodugovora').editable = false;
        this.podugovorFieldStructure.getFieldByName('Naziv').editable = true;
        this.podugovorFieldStructure.getFieldByName('TipUgovoraId').additable = false;
        this.podugovorFieldStructure.getFieldByName('TipUgovoraId').editable = false;
        this.podugovorFieldStructure.getFieldByName('StatusUgovoraId').editable = false;
        this.podugovorFieldStructure.getFieldByName('StatusUgovoraId').additable = false;
        this.podugovorFieldStructure.getFieldByName('BrojPodugovora').editable = true;
        break;
    }
  }

  private setAddToolbar() {
    switch (this._ugovorFormMode) {
      case UgovorFormModeEnum.Podugovor:
        this.name = 'Novi podugovor';
        this.podugovorFieldStructure.getFieldByName('ParentNaziv').visible = false;
        this.podugovorFieldStructure.getFieldByName('ParentBrojPodugovora').visible = false;
        this.podugovorFieldStructure.getFieldByName('TipUgovoraId').additable = true;
        this.podugovorFieldStructure.getFieldByName('TipUgovoraId').editable = true;
        this.podugovor.JeAktivan = true;
        this.setToolbarOptions({
          items: [
            ToolbarItem.ItemSave(true, true, PODUGOVOR_SACUVAJ),
            ToolbarItem.ItemCancel(),
          ],
        });
        this.toggleSpotLookup(true);
        break;
      case UgovorFormModeEnum.Ugovor:
        this.setInProgress(FormModeEnum.Add);
        this.ugovorMode = FormModeEnum.Add;
        this.name = 'Novi ugovor';
        this.setToolbarOptions({
          items: [
            ToolbarItem.ItemDodajPodugovor(),
            ToolbarItem.ItemSave(),
            ToolbarItem.ItemCancel(true, true, UGOVOR_OTKAZI),
          ],
        });
        break;
    }
  }

  private setViewToolbar() {
    const toolbarItems: ToolbarItem[] = [];
    switch (this._ugovorFormMode) {
      case UgovorFormModeEnum.Ugovor:
        this.ugovorMode = FormModeEnum.View;
        this.name = 'Ugovor';
          if (this.privilegije.includes('MSUGO_UGO_ANEKSIRAJ') && this.order.JeAneks === null) {
            toolbarItems.push(ToolbarItem.ItemAneksiraj(true, true));
            this.ugovorFieldStructure.getFieldByName('ParentBrojUgovora').visible = false;
            this.ugovorFieldStructure.getFieldByName('ParentPraviBrojUgovora').visible = false;
            this.ugovorFieldStructure.getFieldByName('ParentJeAktivan').visible = false;
            this.ugovorFieldStructure.getFieldByName('BrojAneksiranogUgovora').visible = false;
          }
          
          if (this.isStatusAneksiran) {
            this.setToolbarOptions({
              items: [ToolbarItem.ItemDelete()],
            });
          } else {
            if (this.privilegije.includes('MSUGO_UGO_UPDATE')) {
              toolbarItems.push(ToolbarItem.ItemEdit(true, true, null, 'Izmeni'));
            }
            if (this.privilegije.includes('MSUGO_UGO_DELETE')) {
              toolbarItems.push(ToolbarItem.ItemDelete());
            }
            this.setToolbarOptions({
              items: toolbarItems,
            });
          }
        break;
      case UgovorFormModeEnum.AneksUgovora:
        this.name = 'Aneks ugovora'
        this.ugovorFieldStructure.getFieldByName('ParentJeAktivan').visible = true;
        if (this.privilegije.includes('MSUGO_UGO_UPDATE')) {
          toolbarItems.push(ToolbarItem.ItemEdit(true, true, null, 'Izmeni'));
        }
        if (this.privilegije.includes('MSUGO_UGO_DELETE')) {
          toolbarItems.push(ToolbarItem.ItemDelete());
        }
        this.setToolbarOptions({
          items: toolbarItems,
        });
        break;
      case UgovorFormModeEnum.Podugovor:
        this.name = 'Podugovor';
        if (this.privilegije.includes('MSUGO_UGO_ANEKSIRAJ') && this.podugovor.JeAneks == null) {
          toolbarItems.push(ToolbarItem.ItemAneksiraj(true, true));
          this.podugovorFieldStructure.getFieldByName('BrojPodugovora').label = "Broj podugovora";
          this.podugovorFieldStructure.getFieldByName('Naziv').label = "Naziv podugovora";
          this.podugovorFieldStructure.getFieldByName('ParentNaziv').visible = false;
          this.podugovorFieldStructure.getFieldByName('ParentBrojPodugovora').visible = false;
        }
        if (this.privilegije.includes('MSUGO_UGO_UPDATE')) {
          toolbarItems.push(ToolbarItem.ItemEdit(true, true, null, 'Izmeni'));
        }
        if (this.privilegije.includes('MSUGO_UGO_DELETE')) {
          toolbarItems.push(ToolbarItem.ItemDelete());
        }
        if (this.showEditButtonToolbar()) {
          this.setToolbarOptions({
            items: toolbarItems,
          });
        } else {
          this.setToolbarOptions({
            items: [],
          });
        }
        break;
      case UgovorFormModeEnum.AneksPodugovora:
        this.name = 'Aneks podugovora';
        this.podugovorFieldStructure.getFieldByName('ParentNaziv').visible = true;
        this.podugovorFieldStructure.getFieldByName('ParentBrojPodugovora').visible = true;
        if (this.privilegije.includes('MSUGO_UGO_UPDATE')) {
          toolbarItems.push(ToolbarItem.ItemEdit(true, true, null, 'Izmeni'));
        }
        if (this.privilegije.includes('MSUGO_UGO_DELETE')) {
          toolbarItems.push(ToolbarItem.ItemDelete());
        }
        if (this.showEditButtonToolbar()) {
          this.setToolbarOptions({
            items: toolbarItems,
          });
        } else {
          this.setToolbarOptions({
            items: [],
          });
        }
        break;
    }
  }

  showEditButtonToolbar() {
    return (
      (this._returnToMode !== FormModeEnum.View &&
        !this.isStatusPotpisan &&
        !this.isStatusAneksiran) ||
      (this.isStatusPotpisan &&
        !this.isStatusAneksiran &&
        this._returnToMode === FormModeEnum.Aneks)
    );
  }

  getPercentUgovoreniBudzetRSD(
    ugovoreniBudzetRSD: number,
    rezervacijeRSD: number,
    realaizacijeRSD: number
  ) {
    const percentages = {
      ugovoreniBudzetRSD: 0,
      rezervacijeRSD: 0,
      realaizacijeRSD: 0,
    };
    if (
      ugovoreniBudzetRSD > rezervacijeRSD &&
      ugovoreniBudzetRSD > realaizacijeRSD
    ) {
      percentages.realaizacijeRSD =
        (realaizacijeRSD / ugovoreniBudzetRSD) * 100;
      percentages.rezervacijeRSD = (rezervacijeRSD / ugovoreniBudzetRSD) * 100;
      percentages.ugovoreniBudzetRSD = 100;
    }
    if (
      rezervacijeRSD > ugovoreniBudzetRSD &&
      rezervacijeRSD > realaizacijeRSD
    ) {
      percentages.realaizacijeRSD = (realaizacijeRSD / rezervacijeRSD) * 100;
      percentages.ugovoreniBudzetRSD =
        (ugovoreniBudzetRSD / rezervacijeRSD) * 100;
      percentages.rezervacijeRSD = 100;
    }
    if (
      realaizacijeRSD > ugovoreniBudzetRSD &&
      realaizacijeRSD > rezervacijeRSD
    ) {
      percentages.rezervacijeRSD = (rezervacijeRSD / realaizacijeRSD) * 100;
      percentages.ugovoreniBudzetRSD =
        (ugovoreniBudzetRSD / realaizacijeRSD) * 100;
      percentages.realaizacijeRSD = 100;
    }

    return percentages;
  }

  private setValidation(
    index,
    array: any[],
    settingsTable: any,
    contentPlaceHolder: TableComponent
  ) {
    let mandatory = false;
    if (
      !array[index].ProgramId &&
      (!array[index].Emisija ||
        array[index].Emisija.id === null ||
        array[index].Emisija.Id === null)
    ) {
      mandatory = true;
    }
    settingsTable.getFieldByName('ProgramId').mandatory = mandatory;
    settingsTable.getFieldByName('Emisija').mandatory = mandatory;
    contentPlaceHolder.doValidationOfInput(
      'ProgramId',
      contentPlaceHolder
        .getItemRef()
        .querySelector(`table tr:nth-of-type(${index + 1}) td:nth-of-type(6)`)
    );
    contentPlaceHolder.doValidationOfInput(
      'ProgramId',
      contentPlaceHolder
        .getItemRef()
        .querySelector(`table tr:nth-of-type(${index + 1}) td:nth-of-type(7)`)
    );
  }

  cenePoOdluciListTableAction(event: any) {
    if(this.isAneksPodugovora) {
      switch (event.action) {
        case TableActionEnum.Select:
          const index = this.aneksCenePoOdluciList.findIndex(
            i => i.rbr === event.document['rbr']
          );
          this.setValidation(
            index,
            this.aneksCenePoOdluciList,
            this.cenePoOdluciSettingsTable,
            this.aneksContentPlaceholder
          );
          break;
        case TableActionEnum.BeforeSave:
          if (!this._validationService.validateHHmm(event.document.VremeOd)) {
            this.showRowError(
              event,
              '"Vreme od" nije validno.',
              this.aneksContentPlaceholder
            );
          }
  
          if (!this._validationService.validateHHmm(event.document.VremeDo)) {
            this.showRowError(
              event,
              '"Vreme do" nije validno.',
              this.aneksContentPlaceholder
            );
          }
  
          if (this.saveCenaPoOdluciDisabled(event)) {
            this.showRowError(
              event,
              'Nije moguće izvršiti čuvanje zbog postojanja cena po odluci koje se vremenski preklapaju.',
              this.aneksContentPlaceholder
            );
  
            return;
          }
          break;
        case TableActionEnum.EditCancel:
          this.copyProperties(
            event.document,
            this.aneksCenePoOdluciList.filter(
              a => a['rbr'] === event.document['rbr']
            )[0]
          );
          break;
      }
    }
    else {
      switch (event.action) {
        case TableActionEnum.Select:
          const index = this.cenePoOdluciList.findIndex(
            i => i.rbr === event.document['rbr']
          );
          this.setValidation(
            index,
            this.cenePoOdluciList,
            this.cenePoOdluciSettingsTable,
            this.contentPlaceholder
          );
          break;
        case TableActionEnum.BeforeSave:
          if (!this._validationService.validateHHmm(event.document.VremeOd)) {
            this.showRowError(
              event,
              '"Vreme od" nije validno.',
              this.contentPlaceholder
            );
          }
  
          if (!this._validationService.validateHHmm(event.document.VremeDo)) {
            this.showRowError(
              event,
              '"Vreme do" nije validno.',
              this.contentPlaceholder
            );
          }
  
          if (this.saveCenaPoOdluciDisabled(event)) {
            this.showRowError(
              event,
              'Nije moguće izvršiti čuvanje zbog postojanja cena po odluci koje se vremenski preklapaju.',
              this.contentPlaceholder
            );
  
            return;
          }
          break;
        case TableActionEnum.EditCancel:
          this.copyProperties(
            event.document,
            this.cenePoOdluciList.filter(
              a => a['rbr'] === event.document['rbr']
            )[0]
          );
          break;
      }
    }
  }

  cppCeneListTableAction(event: any) {
    if(this.isAneksPodugovora) {
      switch (event.action) {
        case TableActionEnum.Select:
          const index = this.aneksCppCeneList.findIndex(
            i => i.rbr === event.document['rbr']
          );
          this.setValidation(
            index,
            this.aneksCppCeneList,
            this.cppCeneSettingsTable,
            this.aneksCppCeneContentPlaceholder
          );
          break;
        case TableActionEnum.BeforeSave:
          if (!this._validationService.validateHHmm(event.document.VremeOd)) {
            this.showRowError(
              event,
              '"Vreme od" nije validno.',
              this.aneksCppCeneContentPlaceholder
            );
  
            return;
          }
  
          if (!this._validationService.validateHHmm(event.document.VremeDo)) {
            this.showRowError(
              event,
              '"Vreme do" nije validno.',
              this.aneksCppCeneContentPlaceholder
            );
  
            return;
          }
  
          if (this.intervalDatumaNijeValidan(event)) {
            this.showRowError(
              event,
              'Nije moguće izvršiti čuvanje zbog nevalidnog datumskog opsega.',
              this.aneksCppCeneContentPlaceholder
            );
  
            return;
          }
  
          if (!this.validateCppDates(event.index)) {
            this.showRowError(
              event,
              'Nije moguće izvršiti čuvanje zbog preklapanja datumskog intervala.',
              this.aneksCppCeneContentPlaceholder
            );
  
            return;
          }
  
          break;
        case TableActionEnum.EditCancel:
          this.copyProperties(
            event.document,
            this.aneksCppCeneList.filter(a => a['rbr'] === event.document['rbr'])[0]
          );
          break;
      }
    }
    else {
      switch (event.action) {
        case TableActionEnum.Select:
          const index = this.cppCeneList.findIndex(
            i => i.rbr === event.document['rbr']
          );
          this.setValidation(
            index,
            this.cppCeneList,
            this.cppCeneSettingsTable,
            this.cppCeneContentPlaceholder
          );
          break;
        case TableActionEnum.BeforeSave:
          if (!this._validationService.validateHHmm(event.document.VremeOd)) {
            this.showRowError(
              event,
              '"Vreme od" nije validno.',
              this.cppCeneContentPlaceholder
            );
  
            return;
          }
  
          if (!this._validationService.validateHHmm(event.document.VremeDo)) {
            this.showRowError(
              event,
              '"Vreme do" nije validno.',
              this.cppCeneContentPlaceholder
            );
  
            return;
          }
  
          if (this.intervalDatumaNijeValidan(event)) {
            this.showRowError(
              event,
              'Nije moguće izvršiti čuvanje zbog nevalidnog datumskog opsega.',
              this.cppCeneContentPlaceholder
            );
  
            return;
          }
  
          if (!this.validateCppDates(event.index)) {
            this.showRowError(
              event,
              'Nije moguće izvršiti čuvanje zbog preklapanja datumskog intervala.',
              this.cppCeneContentPlaceholder
            );
  
            return;
          }
  
          break;
        case TableActionEnum.EditCancel:
          this.copyProperties(
            event.document,
            this.cppCeneList.filter(a => a['rbr'] === event.document['rbr'])[0]
          );
          break;
      }
    }
  }

  brendiraneSpicePodugovorValueChange(event: any) {
    if(this.isAneksPodugovora) {
      const index = this.getRowIndex(this.aneksBrendiraneSpiceList, event);
      let val = null;
      if (event.newValue) {
        val = event.newValue;
      }
      switch (event.fieldMap.fieldKey) {
        case 'ProgramId':
          this.aneksBrendiraneSpiceList[index].ProgramId = val;
          const program = this._enumService.getProgramById(val);
          this.aneksBrendiraneSpiceList[index].ProgramNaziv = program.Naziv;
          break;
      }
    }
    else {
      const index = this.getRowIndex(this.brendiraneSpiceList, event);
      let val = null;
      if (event.newValue) {
        val = event.newValue;
      }
      switch (event.fieldMap.fieldKey) {
        case 'ProgramId':
          this.brendiraneSpiceList[index].ProgramId = val;
          const program = this._enumService.getProgramById(val);
          this.brendiraneSpiceList[index].ProgramNaziv = program.Naziv;
          break;
      }
    }
  }

  brendiraneSpicePodugovorListTableAction(event) {
    switch (event.action) {
      case 'add':
        event.document.isNew = true;
        break;
      case 'edit':
        event.document.isNew = false;
        break;
      case TableActionEnum.BeforeSave:
        return this.validateBrendiraneSpice(event);
    }
  }

  brendiraneSpiceDatumskiIVremenskiOpsegSePoklapa(event) {
    let disabled = false;
    const newRowValues = { ...event.document };

    if (newRowValues.DatumOd) {
      newRowValues.DatumOd = moment(newRowValues.DatumOd).format('YYYY-MM-DD');
    }

    if (newRowValues.DatumDo) {
      newRowValues.DatumDo = moment(newRowValues.DatumDo).format('YYYY-MM-DD');
    }

    let potencNevalid;

    if(this.isAneksPodugovora) {
      potencNevalid = this.aneksBrendiraneSpiceList.filter(
        // x => x.rbr - 1 !== event.index &&
        x => x.ProgramId === newRowValues.ProgramId
      );
    }
    else {
      potencNevalid = this.brendiraneSpiceList.filter(
        // x => x.rbr - 1 !== event.index &&
        x => x.ProgramId === newRowValues.ProgramId
      );
    }

    let preklapanjeDatuma = false;
    let newVremeOd;
    let newVremeDo;
    let pnVremeOd;
    let pnVremeDo;
    let razlicitaCenaEUR = false;
    let postojiNevalid = false;

    if (newRowValues.isNew) {
      potencNevalid.splice(potencNevalid.indexOf(newRowValues), 1);
    }

    potencNevalid.forEach(stavka => {
      if (potencNevalid) {
        preklapanjeDatuma = false;
        razlicitaCenaEUR = false;

        newVremeOd = moment(newRowValues.VremeOd, 'HH:mm').format('HH:mm');
        newVremeDo = moment(newRowValues.VremeDo, 'HH:mm').format('HH:mm');
        pnVremeOd = moment(stavka.VremeOd, 'HH:mm').format('HH:mm');
        pnVremeDo = moment(stavka.VremeDo, 'HH:mm').format('HH:mm');

        const pnDatumDo = moment(stavka.DatumDo).format('YYYY-MM-DD');
        const pnDatumOd = moment(stavka.DatumOd).format('YYYY-MM-DD');

        preklapanjeDatuma =
          newRowValues.DatumOd <= pnDatumDo &&
          newRowValues.DatumDo >= pnDatumOd;

        razlicitaCenaEUR = newRowValues.CenaEUR !== stavka.CenaEUR;

        if (preklapanjeDatuma && razlicitaCenaEUR) {
          postojiNevalid = true;
        }
      }
    });

    if (postojiNevalid) {
      const preklapanjeVremena =
        newVremeOd <= pnVremeDo && newVremeDo >= pnVremeOd;

      return preklapanjeVremena && postojiNevalid;
    }

    disabled = postojiNevalid;

    return disabled;
  }

  intervalDatumaNijeValidan(event) {
    const row = { ...event.document };
    if (row.DatumOd) {
      row.DatumOd = moment(row.DatumOd).format('YYYY-MM-DD');
    }

    if (row.DatumDo) {
      row.DatumDo = moment(row.DatumDo).format('YYYY-MM-DD');
    }

    return row.DatumOd > row.DatumDo;
  }

  validateCppDatumi(event) {
    const row = { ...event.document };
    if (row.DatumOd) {
      row.DatumOd = moment(row.DatumOd).format('YYYY-MM-DD');
    }

    if (row.DatumDo) {
      row.DatumDo = moment(row.DatumDo).format('YYYY-MM-DD');
    }

    const datumOd = new Date(row.DatumOd);
    const datumDo = new Date(row.DatumDo);

    return datumOd > datumDo;
  }

  vremenskiIntervalNijeValidan(event) {
    const newRowValues = { ...event.document };

    const newVremeOd = moment(newRowValues.VremeOd).format('HH:mm');
    const newVremeDo = moment(newRowValues.VremeDo).format('HH:mm');

    return newVremeOd > newVremeDo;
  }

  validateBrojDanaEmitovanja(event) {
    const newValues = { ...event.document };
    const diff = moment(newValues.DatumDo).diff(
      moment(newValues.DatumOd),
      'days'
    );

    // moment ne računa početni dan, zato + 1
    return diff + 1 < newValues.BrojZakupljenihDana;
  }

  validateDatumiSaDatumomPodugovora(event) {
    const newValues = { ...event.document };

    if (newValues.DatumDo) {
      newValues.DatumDo = moment(newValues.DatumDo).format('YYYY-MM-DD');
    }
    let datumIsteka;
    if(this.isAneksPodugovora) {
      datumIsteka = this.aneksPodugovora.DatumIsteka;
      if (datumIsteka) {
        datumIsteka = moment(datumIsteka).format('YYYY-MM-DD');
      }
    }
    else {
      datumIsteka = this.podugovor.DatumIsteka;
      if (datumIsteka) {
        datumIsteka = moment(datumIsteka).format('YYYY-MM-DD');
      }
    }

    return newValues.DatumDo > datumIsteka;
  }

  validateBrendiraneSpice(event) {
    if(this.isAneksPodugovora) {
      if (this.brendiraneSpiceDatumskiIVremenskiOpsegSePoklapa(event)) {
        return this.showRowError(
          event,
          'Nije moguće izvršiti čuvanje zbog postojanja brendiranih špica koje se vremenski preklapaju, a imaju različitu Cenu EUR.',
          this.aneksBrendiraneSpiceContentPlaceholder
        );
      } else if (this.intervalDatumaNijeValidan(event)) {
        return this.showRowError(
          event,
          'Datum do mora biti veći ili jednak sa datumom od.',
          this.aneksBrendiraneSpiceContentPlaceholder
        );
      } else if (!this._validationService.validateHHmm(event.document.VremeOd)) {
        return this.showRowError(
          event,
          '"Vreme od" nije validno.',
          this.aneksBrendiraneSpiceContentPlaceholder
        );
      } else if (!this._validationService.validateHHmm(event.document.VremeDo)) {
        return this.showRowError(
          event,
          '"Vreme do" nije validno.',
          this.aneksBrendiraneSpiceContentPlaceholder
        );
      } else if (this.vremenskiIntervalNijeValidan(event)) {
        return this.showRowError(
          event,
          'Vreme od mora biti manje od vrednosti polja vreme do.',
          this.aneksBrendiraneSpiceContentPlaceholder
        );
      } else if (this.validateBrojDanaEmitovanja(event)) {
        return this.showRowError(
          event,
          'Broj zakupljenih dana ne sme biti veći od intervala emitovanja.',
          this.aneksBrendiraneSpiceContentPlaceholder
        );
      } else if (this.validateDatumiSaDatumomPodugovora(event)) {
        return this.showRowError(
          event,
          'Datum do ne može biti veći od datuma isteka podugovora.',
          this.aneksBrendiraneSpiceContentPlaceholder
        );
      }
    }
    else {
      if (this.brendiraneSpiceDatumskiIVremenskiOpsegSePoklapa(event)) {
        return this.showRowError(
          event,
          'Nije moguće izvršiti čuvanje zbog postojanja brendiranih špica koje se vremenski preklapaju, a imaju različitu Cenu EUR.',
          this.brendiraneSpiceContentPlaceholder
        );
      } else if (this.intervalDatumaNijeValidan(event)) {
        return this.showRowError(
          event,
          'Datum do mora biti veći ili jednak sa datumom od.',
          this.brendiraneSpiceContentPlaceholder
        );
      } else if (!this._validationService.validateHHmm(event.document.VremeOd)) {
        return this.showRowError(
          event,
          '"Vreme od" nije validno.',
          this.brendiraneSpiceContentPlaceholder
        );
      } else if (!this._validationService.validateHHmm(event.document.VremeDo)) {
        return this.showRowError(
          event,
          '"Vreme do" nije validno.',
          this.brendiraneSpiceContentPlaceholder
        );
      } else if (this.vremenskiIntervalNijeValidan(event)) {
        return this.showRowError(
          event,
          'Vreme od mora biti manje od vrednosti polja vreme do.',
          this.brendiraneSpiceContentPlaceholder
        );
      } else if (this.validateBrojDanaEmitovanja(event)) {
        return this.showRowError(
          event,
          'Broj zakupljenih dana ne sme biti veći od intervala emitovanja.',
          this.brendiraneSpiceContentPlaceholder
        );
      } else if (this.validateDatumiSaDatumomPodugovora(event)) {
        return this.showRowError(
          event,
          'Datum do ne može biti veći od datuma isteka podugovora.',
          this.brendiraneSpiceContentPlaceholder
        );
      }
    }
  }

  showRowError(
    event: any,
    message: string,
    contentPlaceholder: TableComponent
  ) {
    const selector = $(
      contentPlaceholder
        .getItemRef()
        .querySelector(`table tbody tr:nth-of-type(${event.index + 1})`)
    );

    selector.addClass('disabled');
    this._notificationService.notyError(message);
    setTimeout(() => {
      selector.removeClass('disabled');
    }, 0);
  }

  validateCppDates(rbr) {
    let valid = true;

    if (this.cppCeneList.length <= 1) {
      return valid;
    }

    this.cppCeneList.forEach((c, i) => {
      if (
        i !== rbr &&
        c.ProgramId === this.cppCeneList[rbr].ProgramId &&
        valid
      ) {
        const datumOd = moment.isMoment(this.cppCeneList[rbr].DatumOd)
          ? this.cppCeneList[rbr].DatumOd.format('YYYY-MM-DD')
          : this.cppCeneList[rbr].DatumOd;
        const datumDo = moment.isMoment(this.cppCeneList[rbr].DatumDo)
          ? this.cppCeneList[rbr].DatumDo.format('YYYY-MM-DD')
          : this.cppCeneList[rbr].DatumDo;

        valid = !(
          moment(datumOd).isBetween(c.DatumOd, c.DatumDo, undefined, '[]') ||
          moment(datumDo).isBetween(c.DatumOd, c.DatumDo, undefined, '[]') ||
          moment(c.DatumOd).isBetween(datumOd, datumDo, undefined, '[]') ||
          moment(c.DatumDo).isBetween(datumOd, datumDo, undefined, '[]')
        );
      }
    });

    return valid;
  }

  toggleEditableRealizovanoRSDOrRealizovanoEUR(document: any) {
    if(document) {
      if(document.UgovoreniBudzet === undefined) {
        document.UgovoreniBudzet = 0;
        document.UgovoreniBudzetRSD = 0;
        document.RealizovanoEUR = 0;
        document.RealizovanoRSD = 0;
        document.ProcenatIskoriscenosti = 0;
      }
      if(document.UgovoreniBudzet === 0 && document.UgovoreniBudzetRSD === 0) {
        this.klijentBudzetSettings.getFieldByName('UgovoreniBudzet').editable = true;
        this.klijentBudzetSettings.getFieldByName('UgovoreniBudzetRSD').editable = true;
      }
      if(document.UgovoreniBudzet > 0) {
        document.UgovoreniBudzetRSD = 0;
        this.klijentBudzetSettings.getFieldByName('UgovoreniBudzetRSD').editable = false;
        this.klijentBudzetSettings.getFieldByName('UgovoreniBudzet').editable = true;
      }
      if(document.UgovoreniBudzetRSD > 0) {
        document.UgovoreniBudzet = 0;
        this.klijentBudzetSettings.getFieldByName('UgovoreniBudzet').editable = false;
        this.klijentBudzetSettings.getFieldByName('UgovoreniBudzetRSD').editable = true;
      }
    }
  }

  checkNegativeOrZeroBudzet(event: any) {
    if(event.document.UgovoreniBudzet < 0 || event.document.UgovoreniBudzetRSD < 0) {
      return this.showRowError(
        event,
        'Nije moguće uneti negativan budžet.',
        this.klijentBudzetPlaceholder
      );
    }
    else if(event.document.UgovoreniBudzet === 0 && event.document.UgovoreniBudzetRSD === 0) {
      return this.showRowError(
        event,
        'Budžet mora imati vrednost veću od 0.',
        this.klijentBudzetPlaceholder
      );
    }
  }

  tableKlijentBudzetAction(event: any) {
    this.toggleEditableRealizovanoRSDOrRealizovanoEUR(event.document);
    switch (event.action) {
      case TableActionEnum.Add:
        this.klijentBudzetPlaceholder.onInlineAddOpenApproved(null, false);
        break;
      case TableActionEnum.BeforeSave:
        this.checkNegativeOrZeroBudzet(event);
        // if (this.checkKursIliDatumValute(event.document)) {
        //   return this.showRowError(
        //     event,
        //     'Potrebno je uneti datum valute ili vrednost kursa.',
        //     this.klijentBudzetPlaceholder
        //   );
        // }
        if (this.checkDuplicateKlijentEntry(event)) {
          return this.showRowError(
            event,
            'Nije moguće dodati izabranog klijenta, isti se već nalazi u listi.',
            this.klijentBudzetPlaceholder
          );
        }
        break;
      case TableActionEnum.Delete:
        if (this.checkIfKlijentHasPodugovor(event.document)) {
          this._notificationService.notyError(
            'Nije moguće obrisati klijenta jer ima vezan podugovor.'
          );
        } else {
          this.klijentBudzetPlaceholder.removeRowApproved(event.document);
        }
        break;
      case TableActionEnum.Save:
      case TableActionEnum.Update:
        this.setPodugovorKlijentLookupInitFilter();
        this.updatePodugovorMetodRacunanja(event.document);
        break;
      case TableActionEnum.AddCancel:
        this.klijentBudzetPlaceholder.removeRowApproved(event.document);
        break;
    }
  }

  checkKursIliDatumValute(document) {
    return !document.Kurs && !document.DatumValute;
  }

  updatePodugovorMetodRacunanja(klijentBudzet) {
    const podugovori = this.getPodugovoriCppZaKlijenta(
      klijentBudzet.Klijent.Id
    );

    if (podugovori && podugovori.length) {
      this.fetchMetodRacunanja(klijentBudzet).subscribe(response => {
        if (this.responseHasError(response)) {
          return this.notifyErrorFromResponse(response);
        }

        const metodObracuna = this._enumService.getResponseData(response);
        const podugovoriToUpdate = podugovori.filter(
          p => p.MetodRacunanja !== metodObracuna
        );

        if (podugovoriToUpdate && podugovoriToUpdate.length) {
          this._modalService.openModal(
            this.getModalMessageMetodObracuna(
              podugovoriToUpdate,
              klijentBudzet,
              metodObracuna
            ),
            res => {
              if (res) {
                podugovoriToUpdate.forEach(f => {
                  this.podugovorList
                    .filter(po => po.BrojPodugovora === f.BrojPodugovora)
                    .forEach(p => {
                      p.MetodRacunanja = metodObracuna;
                    });
                });
              }
            }
          );
        }
      });
    }
  }

  getModalMessageMetodObracuna(
    podugovoriToUpdate: any[],
    klijentBudzet: any,
    metodObracuna: string
  ) {
    const podugovor =
      podugovoriToUpdate.length > 1 ? 'podugovore' : 'podugovor';
    const ima = podugovoriToUpdate.length > 1 ? 'imaju' : 'ima';
    const brojeviPodugovora: string = podugovoriToUpdate
      .map(p => p.BrojPodugovora)
      .join(', ');
    const klijent = klijentBudzet.Klijent.NazivImePrezime;

    return `Da li želite da ažurirate ${podugovor}: ${brojeviPodugovora}, klijenta: ${klijent} (načinom obračuna "Cena po CPP") tako da ${ima} metod obračuna ${metodObracuna.toLowerCase()}?`;
  }

  checkIfKlijentHasPodugovor(document) {
    return this.podugovorList.some(p => p.Klijent.Id === document.Klijent.Id);
  }

  toggleMetodRacunanja(isToggle: boolean) {
    const metodRacunanjaField = this.podugovorFieldStructure.fieldList.find(
      x => x.fieldName === 'MetodRacunanja'
    );

    metodRacunanjaField.visible = isToggle;
    metodRacunanjaField.editable = isToggle;
    metodRacunanjaField.additable = isToggle;
    metodRacunanjaField.mandatory = isToggle;
  }

  getPodugovoriCppZaKlijenta(klijentId): any[] {
    return this.podugovorList.filter(
      p => p.Klijent.Id === klijentId && p.NacinObracunaId === 2
    );
  }

  checkDuplicateKlijentEntry(event) {
    if (this.klijentBudzetList && this.klijentBudzetList.length) {
      return this.klijentBudzetList.some(
        x =>
          x.rbr - 1 !== event.index &&
          x.Klijent.Id === event.document.Klijent.Id
      );
    }

    return false;
  }

  private saveCenaPoOdluciDisabled(event: any): boolean {
    let disabled = false;
    const newRowValues = event.document;

    if (newRowValues.DatumOd) {
      newRowValues.DatumOd = moment(newRowValues.DatumOd).format('YYYY-MM-DD');
    }

    if (newRowValues.DatumDo) {
      newRowValues.DatumDo = moment(newRowValues.DatumDo).format('YYYY-MM-DD');
    }

    let potencNevalid;
    if(this.isAneksPodugovora) {
      potencNevalid = this.aneksCenePoOdluciList.find(
        x =>
          x.rbr - 1 !== event.index && // ne poredi sa samim sobom
          ((x.Emisija &&
            newRowValues.Emisija &&
            x.Emisija.EmisijaId === newRowValues.Emisija.EmisijaId) ||
            ((!x.Emisija || !x.Emisija.Id) && !newRowValues.Emisija)) &&
          x.ProgramId === newRowValues.ProgramId
      );
    }
    else {
      potencNevalid = this.cenePoOdluciList.find(
        x =>
          x.rbr - 1 !== event.index && // ne poredi sa samim sobom
          ((x.Emisija &&
            newRowValues.Emisija &&
            x.Emisija.EmisijaId === newRowValues.Emisija.EmisijaId) ||
            ((!x.Emisija || !x.Emisija.Id) && !newRowValues.Emisija)) &&
          x.ProgramId === newRowValues.ProgramId
      );
    }

    if (potencNevalid) {
      // preklapanje vremena u slucaju da su sve vrednosti obavezne
      const preklapanjeVremena =
        newRowValues.VremeOd < potencNevalid.VremeDo &&
        newRowValues.VremeDo > potencNevalid.VremeOd;

      // preklapanje u slucaju da su sve vrednosti opcione
      const preklapanjeDatuma =
        (!newRowValues.DatumOd &&
          !newRowValues.DatumDo &&
          !potencNevalid.DatumOd &&
          !potencNevalid.DatumDo) ||
        (newRowValues.DatumOd &&
          newRowValues.DatumDo &&
          potencNevalid.DatumOd &&
          potencNevalid.DatumDo &&
          !(
            newRowValues.DatumOd > potencNevalid.DatumDo ||
            newRowValues.DatumDo < potencNevalid.DatumOd
          )) ||
        (newRowValues.DatumOd &&
          newRowValues.DatumOd <= potencNevalid.DatumDo &&
          newRowValues.DatumOd >= potencNevalid.DatumOd) ||
        newRowValues.DatumOd === potencNevalid.DatumOd ||
        (newRowValues.DatumDo &&
          newRowValues.DatumDo >= potencNevalid.DatumOd &&
          newRowValues.DatumDo <= potencNevalid.DatumDo) ||
        newRowValues.DatumDo === potencNevalid.DatumDo;

      disabled = disabled || (preklapanjeVremena && preklapanjeDatuma);
    }

    return disabled;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/ugovori/ugovori.component.ts